import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '../graphql/customGqlComponents';
import * as ApolloReactHooks from '../graphql/customGqlHooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
}

export interface AccessItemInputType {
  role: UserRole;
  venueId: Scalars['ID'];
}

export interface Account {
  __typename?: 'Account';
  canEditVenue: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  cultureCode?: Maybe<CultureCode>;
  defaultUserId?: Maybe<Scalars['ID']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  languageCode?: Maybe<CultureCode>;
  lastName: Scalars['String'];
  users: Array<User>;
}

export interface AccountingCategory {
  __typename?: 'AccountingCategory';
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  creditAccount?: Maybe<Scalars['String']>;
  debitAccount?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mrpCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface AccountingExpenseItemObjectType {
  __typename?: 'AccountingExpenseItemObjectType';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  paymentMethod: ExpensePaymentMethod;
  purchaseDate: Scalars['Date'];
  supplierName: Scalars['String'];
  wasExported: Scalars['Boolean'];
}

export interface AccountingExpensesObjectType {
  __typename?: 'AccountingExpensesObjectType';
  oneTimeExpenses: Array<AccountingExpenseItemObjectType>;
  splitExpenses: Array<AccountingExpenseItemObjectType>;
  supplyExpenses: Array<AccountingExpenseItemObjectType>;
  unifiedExpenses: Array<AccountingExpenseItemObjectType>;
}

export enum AccountingSystem {
  AbraFlexi = 'AbraFlexi',
  Duel = 'Duel',
  Mrp = 'MRP',
  MoneyS3 = 'MoneyS3',
  Omega = 'Omega',
  Pohoda = 'Pohoda',
  Premier = 'Premier',
  Xero = 'Xero',
}

export interface AdminAccount {
  __typename?: 'AdminAccount';
  accountId: Scalars['ID'];
  canConnectStoryousIntegration: Scalars['Boolean'];
  canCreateCustomCheckout: Scalars['Boolean'];
  canCreateNewVenues: Scalars['Boolean'];
  canManageInvoiceBilling: Scalars['Boolean'];
  canManageSupplierIntegrations: Scalars['Boolean'];
  canManageVenues: Scalars['Boolean'];
  canMigrateAutoCategorization: Scalars['Boolean'];
  canModifyCostRadarTrial: Scalars['Boolean'];
  canModifyInvoiceLimit: Scalars['Boolean'];
  canModifyPaymentFailureGracePeriod: Scalars['Boolean'];
  canMoveVenueToPaywall: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
}

export interface AdminMfaBackupCodesObjectType {
  __typename?: 'AdminMfaBackupCodesObjectType';
  backupCodes: Array<Scalars['String']>;
}

export interface AdminMfaEnrollmentBeginObjectType {
  __typename?: 'AdminMfaEnrollmentBeginObjectType';
  otpauthUri: Scalars['String'];
  qrCodeDataUrl: Scalars['String'];
  secret: Scalars['String'];
}

export interface AdminMfaStatusObjectType {
  __typename?: 'AdminMfaStatusObjectType';
  enrolled: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  isServiceAccount: Scalars['Boolean'];
  verified: Scalars['Boolean'];
}

export interface AdminPendingNewAccount {
  __typename?: 'AdminPendingNewAccount';
  adminAccountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isSent: Scalars['Boolean'];
  lastName: Scalars['String'];
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface AdminVenueGracePeriodObjectType {
  __typename?: 'AdminVenueGracePeriodObjectType';
  daysRemaining?: Maybe<Scalars['Int']>;
  gracePeriodDays?: Maybe<Scalars['Int']>;
  hasPaymentFailure: Scalars['Boolean'];
  isLockedOut: Scalars['Boolean'];
  overdueInvoiceAmount?: Maybe<Scalars['Float']>;
  overdueInvoiceCurrency?: Maybe<Scalars['String']>;
  overdueInvoiceDueDate?: Maybe<Scalars['String']>;
  overdueInvoiceVariableSymbol?: Maybe<Scalars['String']>;
  paymentFailureStartedAt?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
}

export enum AiFindingsOutcome {
  Created = 'Created',
  Failed = 'Failed',
  NotFound = 'NotFound',
  Skipped = 'Skipped',
}

export interface AiInsightAiCopy {
  __typename?: 'AiInsightAiCopy';
  cause?: Maybe<Scalars['String']>;
  confidence?: Maybe<Scalars['String']>;
  languageCode: Scalars['String'];
  nextStep?: Maybe<Scalars['String']>;
  related?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export enum AiInsightCadence {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

export interface AiInsightContextResult {
  __typename?: 'AiInsightContextResult';
  copy?: Maybe<AiInsightAiCopy>;
  generatedAt?: Maybe<Scalars['String']>;
  isTranslated: Scalars['Boolean'];
  sourceLanguageCode?: Maybe<Scalars['String']>;
  state: AiInsightContextState;
  unavailableReason?: Maybe<Scalars['String']>;
}

export enum AiInsightContextState {
  NotApplicable = 'NotApplicable',
  Pending = 'Pending',
  Ready = 'Ready',
  Unavailable = 'Unavailable',
}

export interface AiInsightCopy {
  __typename?: 'AiInsightCopy';
  impactComparisonTemplate?: Maybe<Scalars['String']>;
  moneyJson: Scalars['String'];
  noteTemplate?: Maybe<Scalars['String']>;
  paramsJson: Scalars['String'];
  problemTemplate?: Maybe<Scalars['String']>;
  summaryTemplate?: Maybe<Scalars['String']>;
  titleTemplate: Scalars['String'];
}

export enum AiInsightFeedbackRating {
  Down = 'Down',
  Up = 'Up',
}

export interface AiInsightGenerationRun {
  __typename?: 'AiInsightGenerationRun';
  asOf: Scalars['String'];
  cadence: AiInsightCadence;
  generatedCount: Scalars['Int'];
  periodKey: Scalars['String'];
  skipped: Array<AiInsightSkip>;
}

export interface AiInsightLockObjectType {
  __typename?: 'AiInsightLockObjectType';
  reason: AiInsightLockReason;
  type: AiInsightType;
}

export enum AiInsightLockReason {
  BankExpired = 'BankExpired',
  CostRadarInactive = 'CostRadarInactive',
  NoBank = 'NoBank',
  NoPos = 'NoPos',
  NoPosOrBank = 'NoPosOrBank',
  NotEnoughHistory = 'NotEnoughHistory',
}

export interface AiInsightMyFeedback {
  __typename?: 'AiInsightMyFeedback';
  fingerprint: Scalars['String'];
  rating: AiInsightFeedbackRating;
  reason?: Maybe<Scalars['String']>;
}

export interface AiInsightObjectType {
  __typename?: 'AiInsightObjectType';
  aiCopy?: Maybe<AiInsightAiCopy>;
  cadence: AiInsightCadence;
  copy: AiInsightCopy;
  currencyCode: Scalars['String'];
  evidenceJson: Scalars['String'];
  fingerprint: Scalars['String'];
  generatedAt: Scalars['String'];
  id: Scalars['ID'];
  impactAmount: Scalars['Float'];
  kind: Scalars['String'];
  metricsJson: Scalars['String'];
  myFeedback?: Maybe<AiInsightMyFeedback>;
  periodEnd: Scalars['String'];
  periodKey: Scalars['String'];
  periodStart: Scalars['String'];
  polarity: Scalars['String'];
  precision: Scalars['Int'];
  severity: Scalars['String'];
  status: Scalars['String'];
  story?: Maybe<Scalars['String']>;
  subjectKey: Scalars['String'];
  type: AiInsightType;
}

export interface AiInsightSkip {
  __typename?: 'AiInsightSkip';
  reason: Scalars['String'];
  type: AiInsightType;
}

export enum AiInsightType {
  AiFindings = 'AiFindings',
  Cashflow = 'Cashflow',
  FoodCost = 'FoodCost',
  PriceImpact = 'PriceImpact',
  SalesPerformance = 'SalesPerformance',
  SpendAnomaly = 'SpendAnomaly',
}

export interface AiInsightsAccess {
  __typename?: 'AiInsightsAccess';
  aiLanguageCode?: Maybe<Scalars['String']>;
  canGenerate: Scalars['Boolean'];
  canView: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  visibility: AiInsightsVisibility;
}

export interface AiInsightsRangeInput {
  cadences: Array<AiInsightCadence>;
  from: Scalars['String'];
  to: Scalars['String'];
  types: Array<AiInsightType>;
}

export enum AiInsightsVisibility {
  Everyone = 'Everyone',
  ServiceAccount = 'ServiceAccount',
}

export enum AnalyticsEvent {
  AccountingDataExported = 'AccountingDataExported',
  AppEmailCtaClicked = 'AppEmailCtaClicked',
  ApplyForLoanClicked = 'ApplyForLoanClicked',
  BoltPageCtaClicked = 'BoltPageCtaClicked',
  BoltPageViewed = 'BoltPageViewed',
  BulkPaymentFileExported = 'BulkPaymentFileExported',
  CalendarViewed = 'CalendarViewed',
  CashflowAccountConnected = 'CashflowAccountConnected',
  CashflowAccountReconnected = 'CashflowAccountReconnected',
  CashflowChartFiltered = 'CashflowChartFiltered',
  CashflowViewed = 'CashflowViewed',
  CostRadarFiltered = 'CostRadarFiltered',
  CostRadarItemDropdownExpanded = 'CostRadarItemDropdownExpanded',
  CostRadarTrialStarted = 'CostRadarTrialStarted',
  CostRadarUpgradeCompleted = 'CostRadarUpgradeCompleted',
  CostRadarUpgradeModalViewed = 'CostRadarUpgradeModalViewed',
  CostRadarViewed = 'CostRadarViewed',
  DashboardViewed = 'DashboardViewed',
  DepositCreated = 'DepositCreated',
  EmailIntegrationConnected = 'EmailIntegrationConnected',
  ExpenseExportedCsv = 'ExpenseExportedCsv',
  ExpenseMarkedAsPaid = 'ExpenseMarkedAsPaid',
  ExpenseMarkedAsUnpaid = 'ExpenseMarkedAsUnpaid',
  ExpensesViewed = 'ExpensesViewed',
  FinancingViewed = 'FinancingViewed',
  GlobalPnlViewed = 'GlobalPnlViewed',
  InvoiceApproved = 'InvoiceApproved',
  InvoiceExportedZip = 'InvoiceExportedZip',
  InvoiceUploaded = 'InvoiceUploaded',
  LaborExpenseCreated = 'LaborExpenseCreated',
  ManualRevenueAdded = 'ManualRevenueAdded',
  MobileAppInteracted = 'MobileAppInteracted',
  MobileAppLogin = 'MobileAppLogin',
  MobileAppScanWithQualityWarningAccepted = 'MobileAppScanWithQualityWarningAccepted',
  MobileAppScannerOpened = 'MobileAppScannerOpened',
  NoVatModeToggled = 'NoVatModeToggled',
  NotificationClicked = 'NotificationClicked',
  OnboardingComplete = 'OnboardingComplete',
  OtherExpenseCreated = 'OtherExpenseCreated',
  PnlExportedCsv = 'PnlExportedCsv',
  PnlFiltered = 'PnlFiltered',
  PnlViewed = 'PnlViewed',
  PosIntegrationConnected = 'PosIntegrationConnected',
  QrCodeViewed = 'QrCodeViewed',
  RealFoodcostCalculated = 'RealFoodcostCalculated',
  RecurringExpenseCreated = 'RecurringExpenseCreated',
  ReportingModeChanged = 'ReportingModeChanged',
  RevenuesImportedCsv = 'RevenuesImportedCsv',
  RevenuesViewed = 'RevenuesViewed',
  StatementInvoicePaired = 'StatementInvoicePaired',
  SupplyExpenseCreated = 'SupplyExpenseCreated',
  TransactionPaired = 'TransactionPaired',
  TransferCreated = 'TransferCreated',
  UnpairedTransactionsFiltered = 'UnpairedTransactionsFiltered',
  UserInvited = 'UserInvited',
  UserManagementBankAccountsViewed = 'UserManagementBankAccountsViewed',
  UserManagementVenuesViewed = 'UserManagementVenuesViewed',
  VenueSignedUp = 'VenueSignedUp',
  WfmIntegrationConnected = 'WfmIntegrationConnected',
  WithdrawalCreated = 'WithdrawalCreated',
  XeroIntegrationConnected = 'XeroIntegrationConnected',
}

export interface AppNotification {
  __typename?: 'AppNotification';
  autoapprovedInvoicesNotification?: Maybe<AutoapprovedInvoicesNotification>;
  autoapprovedInvoicesNotificationId?: Maybe<Scalars['ID']>;
  cashflowPairNotification?: Maybe<CashflowPairNotification>;
  cashflowPairNotificationId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  dismissedAt?: Maybe<Scalars['Date']>;
  dismissedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  orderItemAlertNotification?: Maybe<OrderItemAlertNotification>;
  orderItemAlertNotificationId?: Maybe<Scalars['ID']>;
  orderItemsExtractedNotification?: Maybe<OrderItemsExtractedNotification>;
  orderItemsExtractedNotificationId?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
  xeroNotification?: Maybe<XeroNotification>;
  xeroNotificationId?: Maybe<Scalars['ID']>;
}

export interface ArchivedAiInsights {
  __typename?: 'ArchivedAiInsights';
  hasMore: Scalars['Boolean'];
  items: Array<AiInsightObjectType>;
  nextOffset: Scalars['Int'];
  totalCount: Scalars['Int'];
}

export interface AskAiInsightQuestionInput {
  insightId: Scalars['ID'];
  languageCode?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
}

export interface AssignPeppolInboxInput {
  additionalVenueIds?: InputMaybe<Array<Scalars['ID']>>;
  peppolParticipantId: Scalars['String'];
  venueId: Scalars['ID'];
}

export interface AssignUnassignedPeppolDocumentInput {
  peppolDocumentId: Scalars['ID'];
  rememberBuyerReference?: InputMaybe<Scalars['Boolean']>;
  rememberDeliveryAddress?: InputMaybe<Scalars['Boolean']>;
  rememberSupplierIco?: InputMaybe<Scalars['Boolean']>;
  venueId: Scalars['ID'];
}

export interface AutoapprovedInvoicesNotification {
  __typename?: 'AutoapprovedInvoicesNotification';
  aggregatedCount: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceUploadItems: Array<Maybe<InvoiceUploadItem>>;
  seenAt?: Maybe<Scalars['Date']>;
  venueId: Scalars['ID'];
}

export enum BankAccountFormat {
  Czech = 'Czech',
  Iban = 'Iban',
  Uk = 'Uk',
}

export interface BarChartDataObjectType {
  __typename?: 'BarChartDataObjectType';
  category: Scalars['String'];
  mapped: Scalars['Boolean'];
  revenueCategoryName?: Maybe<Scalars['String']>;
  revenueTotalAmount: Scalars['Float'];
  revenueTotalAmountWithoutVat: Scalars['Float'];
  totalExpenseAmount: Scalars['Float'];
  totalExpenseAmountWithoutVat: Scalars['Float'];
}

export interface BasePaymentDetails {
  __typename?: 'BasePaymentDetails';
  address: Scalars['String'];
  businessId: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  representativeName: Scalars['String'];
  venueName: Scalars['String'];
}

export interface BaseSubscriptionPaymentDetailsInput {
  address: Scalars['String'];
  businessId: Scalars['String'];
  email: Scalars['String'];
  representativeName: Scalars['String'];
  venueName: Scalars['String'];
}

export enum BillingMethod {
  Fakturoid = 'FAKTUROID',
  Stripe = 'STRIPE',
}

export interface BusinessConnection {
  __typename?: 'BusinessConnection';
  tenantName: Scalars['String'];
  xeroIntegrationDataId: Scalars['String'];
}

export interface CashBurdnownObjectType {
  __typename?: 'CashBurdnownObjectType';
  totalAmount: Scalars['Float'];
  windowDays: Scalars['Int'];
}

export interface CashRegisterEntry {
  __typename?: 'CashRegisterEntry';
  amount: Scalars['Int'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  date: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  paymentMethod: PaymentMethod;
  paymentMethodId: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['String'];
}

export interface CashRegisterEntryInput {
  amount: Scalars['Int'];
  paymentMethodId: Scalars['ID'];
}

export enum CashflowAccessRole {
  Admin = 'Admin',
  EditAndView = 'EditAndView',
  NoAccess = 'NoAccess',
  ViewOnly = 'ViewOnly',
}

export interface CashflowAccountBalance {
  __typename?: 'CashflowAccountBalance';
  amount: Scalars['Int'];
  cashflowLinkedAccount?: Maybe<CashflowLinkedAccount>;
  cashflowLinkedAccountId?: Maybe<Scalars['ID']>;
  cashflowManualAccount?: Maybe<CashflowManualAccount>;
  cashflowManualAccountId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  currencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  referenceDate: Scalars['Date'];
}

export interface CashflowAccountRole {
  __typename?: 'CashflowAccountRole';
  account: Account;
  accountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  linkedAccount?: Maybe<CashflowLinkedAccount>;
  linkedAccountId?: Maybe<Scalars['String']>;
  manualAccount?: Maybe<CashflowManualAccount>;
  manualAccountId?: Maybe<Scalars['String']>;
  role: CashflowRole;
  roleName: CashflowAccessRole;
}

export interface CashflowInstitution {
  __typename?: 'CashflowInstitution';
  bic: Scalars['String'];
  countries: Array<Scalars['String']>;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  requiresAdditionalConsent: Scalars['Boolean'];
  transaction_total_days: Scalars['String'];
}

export interface CashflowLinkedAccount {
  __typename?: 'CashflowLinkedAccount';
  bic?: Maybe<Scalars['String']>;
  businessEntityId: Scalars['ID'];
  cashflowAccountBalances: Array<CashflowAccountBalance>;
  cashflowLinkedTransactions: Array<CashflowLinkedTransaction>;
  cashflowRequisition: CashflowRequisition;
  cashflowRequisitionId: Scalars['ID'];
  createdAt: Scalars['Date'];
  currencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  displayName?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  iban: Scalars['String'];
  id: Scalars['ID'];
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
  logo: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  requiresSecondConnection?: Maybe<Scalars['Boolean']>;
  role: Scalars['String'];
  secondConnectionCompleted?: Maybe<Scalars['Boolean']>;
  userAgreementEndDate: Scalars['Date'];
  venues: Array<Venue>;
  venuesJoin: Array<CashflowLinkedAccountVenueJoinTable>;
}

export interface CashflowLinkedAccountLatestSyncObjectType {
  __typename?: 'CashflowLinkedAccountLatestSyncObjectType';
  latestSyncDate?: Maybe<Scalars['Date']>;
}

export interface CashflowLinkedAccountObjectType {
  __typename?: 'CashflowLinkedAccountObjectType';
  balanceAmount?: Maybe<Scalars['Int']>;
  balanceConvertedAmount?: Maybe<Scalars['Int']>;
  balanceConvertedCurrency?: Maybe<CurrencyCode>;
  balanceCurrency?: Maybe<CurrencyCode>;
  bic?: Maybe<Scalars['String']>;
  businessEntityId: Scalars['ID'];
  cashflowAccountBalances: Array<CashflowAccountBalance>;
  cashflowLinkedTransactions: Array<CashflowLinkedTransaction>;
  cashflowRequisition: CashflowRequisition;
  cashflowRequisitionId: Scalars['ID'];
  createdAt: Scalars['Date'];
  currencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  displayName?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  iban: Scalars['String'];
  id: Scalars['ID'];
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
  logo: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  requiresSecondConnection?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  secondConnectionCompleted?: Maybe<Scalars['Boolean']>;
  userAgreementEndDate: Scalars['Date'];
  venues: Array<Venue>;
  venuesJoin: Array<CashflowLinkedAccountVenueJoinTable>;
}

export interface CashflowLinkedAccountVenueJoinTable {
  __typename?: 'CashflowLinkedAccountVenueJoinTable';
  cashflowLinkedAccount: CashflowLinkedAccount;
  cashflowLinkedAccountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface CashflowLinkedTransaction {
  __typename?: 'CashflowLinkedTransaction';
  amount: Scalars['Int'];
  bookingDate: Scalars['Date'];
  cashflowLinkedAccount: CashflowLinkedAccount;
  cashflowLinkedAccountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  creditorAccount?: Maybe<Scalars['String']>;
  creditorName?: Maybe<Scalars['String']>;
  currencyCode: CurrencyCode;
  debtorAccount?: Maybe<Scalars['String']>;
  debtorName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  externalBankTransactionId?: Maybe<Scalars['String']>;
  externalEndToEndId?: Maybe<Scalars['String']>;
  externalEntryReference?: Maybe<Scalars['String']>;
  externalTransactionId: Scalars['String'];
  id: Scalars['ID'];
  isExcludedFromAnalytics?: Maybe<Scalars['Boolean']>;
  notAnExpense?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  remittanceInformation: Scalars['String'];
  valueDate: Scalars['Date'];
}

export interface CashflowLinkedTransactionWithBalanceObjectType {
  __typename?: 'CashflowLinkedTransactionWithBalanceObjectType';
  balanceAmount?: Maybe<Scalars['Int']>;
  balanceCurrency?: Maybe<CurrencyCode>;
  role?: Maybe<Scalars['String']>;
  transaction: CashflowLinkedTransaction;
}

export interface CashflowManualAccount {
  __typename?: 'CashflowManualAccount';
  businessEntityId: Scalars['ID'];
  cashflowAccountBalances: Array<CashflowAccountBalance>;
  cashflowManualTransactions: Array<CashflowManualTransaction>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  role: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venues: Array<Venue>;
  venuesJoin: Array<CashflowManualAccountVenueJoinTable>;
}

export interface CashflowManualAccountObjectType {
  __typename?: 'CashflowManualAccountObjectType';
  balanceAmount?: Maybe<Scalars['Int']>;
  balanceConvertedAmount?: Maybe<Scalars['Int']>;
  balanceConvertedCurrency?: Maybe<CurrencyCode>;
  balanceCurrency?: Maybe<CurrencyCode>;
  businessEntityId: Scalars['ID'];
  cashflowAccountBalances: Array<CashflowAccountBalance>;
  cashflowManualTransactions: Array<CashflowManualTransaction>;
  connectedIntegrationProviders: Array<IntegrationProvider>;
  connectedRevenueSourceIds: Array<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  role: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venues: Array<Venue>;
  venuesJoin: Array<CashflowManualAccountVenueJoinTable>;
}

export interface CashflowManualAccountVenueJoinTable {
  __typename?: 'CashflowManualAccountVenueJoinTable';
  cashflowManualAccount: CashflowManualAccount;
  cashflowManualAccountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface CashflowManualTransaction {
  __typename?: 'CashflowManualTransaction';
  amount: Scalars['Int'];
  automatedFromRevenueSource?: Maybe<RevenueSource>;
  automatedFromRevenueSourceId?: Maybe<Scalars['ID']>;
  cashflowManualAccount: CashflowManualAccount;
  cashflowManualAccountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  date: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isExcludedFromAnalytics?: Maybe<Scalars['Boolean']>;
  isUnlinkedWithdrawal?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  posBillId?: Maybe<Scalars['String']>;
  transferTargetCashflowManualAccount?: Maybe<CashflowManualAccount>;
  transferTargetCashflowManualAccountId?: Maybe<Scalars['ID']>;
  updatedById?: Maybe<Scalars['ID']>;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['ID']>;
}

export interface CashflowManualTransactionWithBalanceObjectType {
  __typename?: 'CashflowManualTransactionWithBalanceObjectType';
  balanceAmount?: Maybe<Scalars['Int']>;
  balanceCurrency?: Maybe<CurrencyCode>;
  role?: Maybe<Scalars['String']>;
  transaction: CashflowManualTransaction;
}

export interface CashflowPairNotification {
  __typename?: 'CashflowPairNotification';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  payments?: Maybe<Array<Payment>>;
  venueId: Scalars['ID'];
}

export interface CashflowRequisition {
  __typename?: 'CashflowRequisition';
  businessEntityId: Scalars['ID'];
  cashflowLinkedAccounts: Array<CashflowLinkedAccount>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institution: Scalars['String'];
  secondConnection?: Maybe<Scalars['Boolean']>;
  state: CashflowRequisitionState;
  updatedById?: Maybe<Scalars['ID']>;
}

export enum CashflowRequisitionState {
  Expired = 'EXPIRED',
  Linked = 'LINKED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SetupStarted = 'SETUP_STARTED',
}

export interface CashflowRole {
  __typename?: 'CashflowRole';
  accountRoles: Array<CashflowAccountRole>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: CashflowAccessRole;
}

export interface CashflowStatementReportObjectType {
  __typename?: 'CashflowStatementReportObjectType';
  currencyCode: CurrencyCode;
  endBalance: Scalars['Float'];
  from: Scalars['Date'];
  moneyIn: Scalars['Float'];
  moneyOut: Scalars['Float'];
  startBalance: Scalars['Float'];
  timeSeries: Array<CashflowStatementTimeSeriesObjectType>;
  to: Scalars['Date'];
}

export enum CashflowStatementReportPeriod {
  DaysInMonth = 'DaysInMonth',
  MonthsInYear = 'MonthsInYear',
  QuartersInYear = 'QuartersInYear',
  WeeksInMonth = 'WeeksInMonth',
}

export interface CashflowStatementTimeSeriesObjectType {
  __typename?: 'CashflowStatementTimeSeriesObjectType';
  currencyCode: CurrencyCode;
  endBalance: Scalars['Float'];
  from: Scalars['Date'];
  moneyIn: Scalars['Float'];
  moneyOut: Scalars['Float'];
  startBalance: Scalars['Float'];
  to: Scalars['Date'];
}

export enum CashflowTransactionType {
  Deposit = 'Deposit',
  Expense = 'Expense',
  NotPaired = 'NotPaired',
  Revenue = 'Revenue',
  Transfer = 'Transfer',
  Unknown = 'Unknown',
  Withdrawal = 'Withdrawal',
}

export enum CashflowTransactionsSortKey {
  Amount = 'Amount',
  Date = 'Date',
  Type = 'Type',
}

export interface CashflowUnifiedTransaction {
  __typename?: 'CashflowUnifiedTransaction';
  amount: Scalars['Int'];
  balanceAmount?: Maybe<Scalars['Int']>;
  balanceCurrency?: Maybe<CurrencyCode>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  linkedTransaction?: Maybe<CashflowLinkedTransaction>;
  manualTransaction?: Maybe<CashflowManualTransaction>;
  sourceType: CashflowUnifiedTransactionSourceType;
}

export interface CashflowUnifiedTransactionConnection {
  __typename?: 'CashflowUnifiedTransactionConnection';
  items: Array<CashflowUnifiedTransaction>;
  totalCount: Scalars['Int'];
}

export enum CashflowUnifiedTransactionSourceType {
  Linked = 'Linked',
  Manual = 'Manual',
}

export interface Category {
  __typename?: 'Category';
  accountReference?: Maybe<Scalars['String']>;
  aiDescription?: Maybe<Scalars['String']>;
  categoryHierarchyTemplate?: Maybe<CategoryHierarchyTemplate>;
  categoryHierarchyTemplateId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  departmentCode?: Maybe<Scalars['String']>;
  employeeCount: Scalars['Int'];
  employees: Array<CategoryEmployeeObjectType>;
  id: Scalars['ID'];
  integrationDepartmentId?: Maybe<Scalars['ID']>;
  integrationType?: Maybe<LaborIntegrationType>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isInvisible?: Maybe<Scalars['Boolean']>;
  isLegacy?: Maybe<Scalars['Boolean']>;
  isLegacyMappingConfirmed?: Maybe<Scalars['Boolean']>;
  isSystemManaged?: Maybe<Scalars['Boolean']>;
  legacyMappedToCategoryId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  nominalAcRef?: Maybe<Scalars['String']>;
  parentCategory?: Maybe<Category>;
  parentCategoryId?: Maybe<Scalars['ID']>;
  reference?: Maybe<Scalars['String']>;
  revenueCategory?: Maybe<RevenueCategory>;
  revenueCategoryId?: Maybe<Scalars['ID']>;
  systemCategory?: Maybe<SystemCategoryType>;
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface CategoryEmployeeObjectType {
  __typename?: 'CategoryEmployeeObjectType';
  id: Scalars['ID'];
  integrationType?: Maybe<LaborIntegrationType>;
  name: Scalars['String'];
}

export interface CategoryHierarchyTemplate {
  __typename?: 'CategoryHierarchyTemplate';
  aiDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  parentTemplateId?: Maybe<Scalars['ID']>;
  systemCategory: SystemCategoryType;
  visibility: CategoryHierarchyTemplateVisibility;
}

export enum CategoryHierarchyTemplateVisibility {
  Default = 'Default',
  Invisible = 'Invisible',
  Optional = 'Optional',
}

export enum CategoryListMode {
  Active = 'Active',
  MigrationTargets = 'MigrationTargets',
  SettingsView = 'SettingsView',
}

export interface CategoryTotal {
  __typename?: 'CategoryTotal';
  name: Scalars['String'];
  revenueSource?: Maybe<RevenueSourceType>;
  total: Scalars['Float'];
  totalWithoutVat: Scalars['Float'];
}

export interface ClearAiInsightsInput {
  cadences: Array<AiInsightCadence>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['String'];
  to: Scalars['String'];
  types: Array<AiInsightType>;
}

export interface ClearAiInsightsResult {
  __typename?: 'ClearAiInsightsResult';
  count: Scalars['Int'];
  dryRun: Scalars['Boolean'];
}

export interface ConfirmSubscriptionUpgradeInput {
  numberOfInvoices: Scalars['Int'];
  planType: SubscriptionPlanType;
  withCostRadar: Scalars['Boolean'];
}

export interface ConfirmSubscriptionUpgradeResult {
  __typename?: 'ConfirmSubscriptionUpgradeResult';
  additionalMonthlyAmount: Scalars['Float'];
  currentMonthlyAmount?: Maybe<Scalars['Float']>;
  handling: SubscriptionUpgradeHandling;
  nextMonthlyAmount?: Maybe<Scalars['Float']>;
}

export interface CostRadarSubscription {
  __typename?: 'CostRadarSubscription';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  paidAt?: Maybe<Scalars['Date']>;
  state: CostRadarSubscriptionState;
  trialExpiresAt?: Maybe<Scalars['Date']>;
  trialLimitReachedEmailSent?: Maybe<Scalars['Boolean']>;
  trialStartedAt?: Maybe<Scalars['Date']>;
  venueId: Scalars['ID'];
}

export enum CostRadarSubscriptionState {
  Paid = 'Paid',
  TrialAvailable = 'TrialAvailable',
  TrialExpired = 'TrialExpired',
  TrialStarted = 'TrialStarted',
}

export interface CounterofferInfoDto {
  __typename?: 'CounterofferInfoDto';
  newLoanDetails: FlowpayLoanDetails;
  newOffer: FlowpayOffer;
  originalLoanDetails: FlowpayLoanDetails;
  originalOffer: FlowpayOffer;
}

export enum CountryCode {
  Afghanistan = 'Afghanistan',
  AlandIslands = 'AlandIslands',
  Albania = 'Albania',
  Algeria = 'Algeria',
  AmericanSamoa = 'AmericanSamoa',
  Andorra = 'Andorra',
  Angola = 'Angola',
  Anguilla = 'Anguilla',
  Antarctica = 'Antarctica',
  AntiguaAndBarbuda = 'AntiguaAndBarbuda',
  Argentina = 'Argentina',
  Armenia = 'Armenia',
  Aruba = 'Aruba',
  Australia = 'Australia',
  Austria = 'Austria',
  Azerbaijan = 'Azerbaijan',
  Bahamas = 'Bahamas',
  Bahrain = 'Bahrain',
  Bangladesh = 'Bangladesh',
  Barbados = 'Barbados',
  Belarus = 'Belarus',
  Belgium = 'Belgium',
  Belize = 'Belize',
  Benin = 'Benin',
  Bermuda = 'Bermuda',
  Bhutan = 'Bhutan',
  Bolivia = 'Bolivia',
  BosniaAndHerzegovina = 'BosniaAndHerzegovina',
  Botswana = 'Botswana',
  BouvetIsland = 'BouvetIsland',
  Brazil = 'Brazil',
  BritishIndianOceanTerritory = 'BritishIndianOceanTerritory',
  BruneiDarussalam = 'BruneiDarussalam',
  Bulgaria = 'Bulgaria',
  BurkinaFaso = 'BurkinaFaso',
  Burundi = 'Burundi',
  Cambodia = 'Cambodia',
  Cameroon = 'Cameroon',
  Canada = 'Canada',
  CapeVerde = 'CapeVerde',
  CaymanIslands = 'CaymanIslands',
  CentralAfricanRepublic = 'CentralAfricanRepublic',
  Chad = 'Chad',
  Chile = 'Chile',
  China = 'China',
  ChristmasIsland = 'ChristmasIsland',
  CocosKeelingIslands = 'CocosKeelingIslands',
  Colombia = 'Colombia',
  Comoros = 'Comoros',
  Congo = 'Congo',
  CongoDemocraticRepublic = 'CongoDemocraticRepublic',
  CookIslands = 'CookIslands',
  CostaRica = 'CostaRica',
  CoteDIvoire = 'CoteDIvoire',
  Croatia = 'Croatia',
  Cuba = 'Cuba',
  Cyprus = 'Cyprus',
  CzechRepublic = 'CzechRepublic',
  Denmark = 'Denmark',
  Djibouti = 'Djibouti',
  Dominica = 'Dominica',
  DominicanRepublic = 'DominicanRepublic',
  Ecuador = 'Ecuador',
  Egypt = 'Egypt',
  ElSalvador = 'ElSalvador',
  EquatorialGuinea = 'EquatorialGuinea',
  Eritrea = 'Eritrea',
  Estonia = 'Estonia',
  Ethiopia = 'Ethiopia',
  FalklandIslands = 'FalklandIslands',
  FaroeIslands = 'FaroeIslands',
  Fiji = 'Fiji',
  Finland = 'Finland',
  France = 'France',
  FrenchGuiana = 'FrenchGuiana',
  FrenchPolynesia = 'FrenchPolynesia',
  FrenchSouthernTerritories = 'FrenchSouthernTerritories',
  Gabon = 'Gabon',
  Gambia = 'Gambia',
  Georgia = 'Georgia',
  Germany = 'Germany',
  Ghana = 'Ghana',
  Gibraltar = 'Gibraltar',
  Greece = 'Greece',
  Greenland = 'Greenland',
  Grenada = 'Grenada',
  Guadeloupe = 'Guadeloupe',
  Guam = 'Guam',
  Guatemala = 'Guatemala',
  Guernsey = 'Guernsey',
  Guinea = 'Guinea',
  GuineaBissau = 'GuineaBissau',
  Guyana = 'Guyana',
  Haiti = 'Haiti',
  HeardIslandMcdonaldIslands = 'HeardIslandMcdonaldIslands',
  HolySeeVaticanCityState = 'HolySeeVaticanCityState',
  Honduras = 'Honduras',
  HongKong = 'HongKong',
  Hungary = 'Hungary',
  Iceland = 'Iceland',
  India = 'India',
  Indonesia = 'Indonesia',
  Iran = 'Iran',
  Iraq = 'Iraq',
  Ireland = 'Ireland',
  IsleOfMan = 'IsleOfMan',
  Israel = 'Israel',
  Italy = 'Italy',
  Jamaica = 'Jamaica',
  Japan = 'Japan',
  Jersey = 'Jersey',
  Jordan = 'Jordan',
  Kazakhstan = 'Kazakhstan',
  Kenya = 'Kenya',
  Kiribati = 'Kiribati',
  Korea = 'Korea',
  Kuwait = 'Kuwait',
  Kyrgyzstan = 'Kyrgyzstan',
  LaoPeoplesDemocraticRepublic = 'LaoPeoplesDemocraticRepublic',
  Latvia = 'Latvia',
  Lebanon = 'Lebanon',
  Lesotho = 'Lesotho',
  Liberia = 'Liberia',
  LibyanArabJamahiriya = 'LibyanArabJamahiriya',
  Liechtenstein = 'Liechtenstein',
  Lithuania = 'Lithuania',
  Luxembourg = 'Luxembourg',
  Macao = 'Macao',
  Macedonia = 'Macedonia',
  Madagascar = 'Madagascar',
  Malawi = 'Malawi',
  Malaysia = 'Malaysia',
  Maldives = 'Maldives',
  Mali = 'Mali',
  Malta = 'Malta',
  MarshallIslands = 'MarshallIslands',
  Martinique = 'Martinique',
  Mauritania = 'Mauritania',
  Mauritius = 'Mauritius',
  Mayotte = 'Mayotte',
  Mexico = 'Mexico',
  Micronesia = 'Micronesia',
  Moldova = 'Moldova',
  Monaco = 'Monaco',
  Mongolia = 'Mongolia',
  Montenegro = 'Montenegro',
  Montserrat = 'Montserrat',
  Morocco = 'Morocco',
  Mozambique = 'Mozambique',
  Myanmar = 'Myanmar',
  Namibia = 'Namibia',
  Nauru = 'Nauru',
  Nepal = 'Nepal',
  Netherlands = 'Netherlands',
  NetherlandsAntilles = 'NetherlandsAntilles',
  NewCaledonia = 'NewCaledonia',
  NewZealand = 'NewZealand',
  Nicaragua = 'Nicaragua',
  Niger = 'Niger',
  Nigeria = 'Nigeria',
  Niue = 'Niue',
  NorfolkIsland = 'NorfolkIsland',
  NorthernMarianaIslands = 'NorthernMarianaIslands',
  Norway = 'Norway',
  Oman = 'Oman',
  Pakistan = 'Pakistan',
  Palau = 'Palau',
  PalestinianTerritory = 'PalestinianTerritory',
  Panama = 'Panama',
  PapuaNewGuinea = 'PapuaNewGuinea',
  Paraguay = 'Paraguay',
  Peru = 'Peru',
  Philippines = 'Philippines',
  Pitcairn = 'Pitcairn',
  Poland = 'Poland',
  Portugal = 'Portugal',
  PuertoRico = 'PuertoRico',
  Qatar = 'Qatar',
  Reunion = 'Reunion',
  Romania = 'Romania',
  RussianFederation = 'RussianFederation',
  Rwanda = 'Rwanda',
  SaintBarthelemy = 'SaintBarthelemy',
  SaintHelena = 'SaintHelena',
  SaintKittsAndNevis = 'SaintKittsAndNevis',
  SaintLucia = 'SaintLucia',
  SaintMartin = 'SaintMartin',
  SaintPierreAndMiquelon = 'SaintPierreAndMiquelon',
  SaintVincentAndGrenadines = 'SaintVincentAndGrenadines',
  Samoa = 'Samoa',
  SanMarino = 'SanMarino',
  SaoTomeAndPrincipe = 'SaoTomeAndPrincipe',
  SaudiArabia = 'SaudiArabia',
  Senegal = 'Senegal',
  Serbia = 'Serbia',
  Seychelles = 'Seychelles',
  SierraLeone = 'SierraLeone',
  Singapore = 'Singapore',
  Slovakia = 'Slovakia',
  Slovenia = 'Slovenia',
  SolomonIslands = 'SolomonIslands',
  Somalia = 'Somalia',
  SouthAfrica = 'SouthAfrica',
  SouthGeorgiaAndSandwichIsl = 'SouthGeorgiaAndSandwichIsl',
  Spain = 'Spain',
  SriLanka = 'SriLanka',
  Sudan = 'Sudan',
  Suriname = 'Suriname',
  SvalbardAndJanMayen = 'SvalbardAndJanMayen',
  Swaziland = 'Swaziland',
  Sweden = 'Sweden',
  Switzerland = 'Switzerland',
  SyrianArabRepublic = 'SyrianArabRepublic',
  Taiwan = 'Taiwan',
  Tajikistan = 'Tajikistan',
  Tanzania = 'Tanzania',
  Thailand = 'Thailand',
  TimorLeste = 'TimorLeste',
  Togo = 'Togo',
  Tokelau = 'Tokelau',
  Tonga = 'Tonga',
  TrinidadAndTobago = 'TrinidadAndTobago',
  Tunisia = 'Tunisia',
  Turkey = 'Turkey',
  Turkmenistan = 'Turkmenistan',
  TurksAndCaicosIslands = 'TurksAndCaicosIslands',
  Tuvalu = 'Tuvalu',
  Uganda = 'Uganda',
  Ukraine = 'Ukraine',
  UnitedArabEmirates = 'UnitedArabEmirates',
  UnitedKingdom = 'UnitedKingdom',
  UnitedStates = 'UnitedStates',
  UnitedStatesOutlyingIslands = 'UnitedStatesOutlyingIslands',
  Uruguay = 'Uruguay',
  Uzbekistan = 'Uzbekistan',
  Vanuatu = 'Vanuatu',
  Venezuela = 'Venezuela',
  VietNam = 'VietNam',
  VirginIslandsBritish = 'VirginIslandsBritish',
  VirginIslandsUs = 'VirginIslandsUS',
  WallisAndFutuna = 'WallisAndFutuna',
  WesternSahara = 'WesternSahara',
  Yemen = 'Yemen',
  Zambia = 'Zambia',
  Zimbabwe = 'Zimbabwe',
}

export interface CreateAccountInputType {
  cultureCode?: InputMaybe<CultureCode>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  languageCode?: InputMaybe<CultureCode>;
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
}

export interface CreateBusinessEntityArgs {
  name: Scalars['String'];
}

export interface CreateCustomCheckoutInput {
  billingInterval: SubscriptionPeriod;
  countryCode: CountryCode;
  couponId?: InputMaybe<Scalars['String']>;
  currencyCode: CurrencyCode;
  email: Scalars['String'];
  numberOfInvoices: Scalars['Int'];
  planType: SubscriptionPlanType;
  unitAmount: Scalars['Float'];
  userId: Scalars['String'];
  venueId: Scalars['String'];
}

export interface CreateExpenseAccountingInfoInputType {
  accountingCategoryId?: InputMaybe<Scalars['ID']>;
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  invoiceType: InvoiceType;
  paymentMethod?: InputMaybe<ExpensePaymentMethod>;
  senderAddress?: InputMaybe<Scalars['String']>;
  taxPointDate: Scalars['Date'];
  taxes: Array<CreateExpenseTaxInputType>;
  variableSymbol: Scalars['String'];
  vatBreakdown?: InputMaybe<VatBreakdown>;
}

export interface CreateExpenseBankInfoInputType {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  supplierBankAccountId?: InputMaybe<Scalars['ID']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface CreateExpenseTaxInputType {
  baseAmount: Scalars['Int'];
  rate: TaxRate;
  taxAmount: Scalars['Int'];
}

export interface CreateExportResponseType {
  __typename?: 'CreateExportResponseType';
  fileContent?: Maybe<Scalars['String']>;
  xeroResponse?: Maybe<SendToXeroResponseObjectType>;
}

export interface CreateLegalEntityArgs {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyIdentificationNumber?: InputMaybe<Scalars['String']>;
  country: CountryCode;
  currencyCurrencyCode: CurrencyCode;
  district?: InputMaybe<Scalars['String']>;
  einvoiceDocumentSyncEnabled: Scalars['Boolean'];
  einvoiceMappingConfirmed: Scalars['Boolean'];
  einvoiceSmpRegistered?: InputMaybe<Scalars['Boolean']>;
  einvoiceSmpState?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  peppolParticipantId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  taxIdentificationNumber?: InputMaybe<Scalars['String']>;
  venue: CreateVenueArgs;
  vertecoCompanyId?: InputMaybe<Scalars['String']>;
}

export interface CreateRecurrencePatternInput {
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  endDate?: InputMaybe<Scalars['Date']>;
  interval: RecurrenceInterval;
  monthOfYear?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface CreateRevenueInputType {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  mode?: InputMaybe<RevenueMode>;
  revenueSourceId?: InputMaybe<Scalars['ID']>;
  sourceName?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface CreateVenueArgs {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cultureCode: CultureCode;
  defaultTimezone: Scalars['String'];
  district?: InputMaybe<Scalars['String']>;
  languageCode: CultureCode;
  name: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
}

export interface CreatedOrUpdatedByObjectType {
  __typename?: 'CreatedOrUpdatedByObjectType';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export enum CultureCode {
  CsCz = 'cs_CZ',
  EnGb = 'en_GB',
  EnUs = 'en_US',
  PlPl = 'pl_PL',
  SkSk = 'sk_SK',
}

export interface Currency {
  __typename?: 'Currency';
  currencyCode: CurrencyCode;
  precision: Scalars['Int'];
}

export enum CurrencyCode {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL',
}

export interface CurrentUserObjectType {
  __typename?: 'CurrentUserObjectType';
  client_id: Scalars['String'];
  cultureCode: CultureCode;
  currency: Currency;
  email: Scalars['String'];
  family_name: Scalars['String'];
  given_name: Scalars['String'];
  languageCode: CultureCode;
  scope: ScopeObjectType;
  subscriptionData: SubscriptionDataObjectType;
  zoneinfo: Scalars['String'];
}

export interface DailyRevenueDetailObjectType {
  __typename?: 'DailyRevenueDetailObjectType';
  amount: Scalars['Float'];
  amountWithoutVat?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  currencyCode: Scalars['String'];
  date: Scalars['Date'];
  hasMixedSources?: Maybe<Scalars['Boolean']>;
  hour?: Maybe<Scalars['Int']>;
  integrationProvider?: Maybe<IntegrationProvider>;
  isManual: Scalars['Boolean'];
  precision: Scalars['Int'];
  timeSegment?: Maybe<Scalars['String']>;
}

export interface DateFromToInputType {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export enum DayOfWeek {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed',
}

export interface DefaultCompanyDetailsObjectType {
  __typename?: 'DefaultCompanyDetailsObjectType';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyIdentificationNumber?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  source: DefaultCompanyDetailsSource;
  taxIdentificationNumber?: Maybe<Scalars['String']>;
}

export enum DefaultCompanyDetailsSource {
  LegalEntity = 'LegalEntity',
}

export interface Department {
  __typename?: 'Department';
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  employees: Array<Employee>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface DeputyCompanyObjectType {
  __typename?: 'DeputyCompanyObjectType';
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface DeputyConnectionObjectType {
  __typename?: 'DeputyConnectionObjectType';
  laborIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['Date']>;
  region: Scalars['String'];
  selectedCompanies?: Maybe<Array<Scalars['String']>>;
  subdomain: Scalars['String'];
}

export enum DocumentSortKey {
  Amount = 'Amount',
  IssueDate = 'IssueDate',
  RejectedAt = 'RejectedAt',
  UploadTime = 'UploadTime',
}

export enum DocumentStatusFilter {
  Approved = 'Approved',
  AutoApproved = 'AutoApproved',
  ForApproval = 'ForApproval',
  Processing = 'Processing',
  Rejected = 'Rejected',
}

export enum DocumentUploadChannel {
  Email = 'Email',
  Gmail = 'Gmail',
  Outlook = 'Outlook',
  Peppol = 'Peppol',
}

export interface EinvoiceRoutingRule {
  __typename?: 'EinvoiceRoutingRule';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  legalEntityId: Scalars['ID'];
  type: EinvoiceRoutingRuleType;
  value: Scalars['String'];
  venueId: Scalars['ID'];
}

export enum EinvoiceRoutingRuleType {
  BuyerReference = 'BuyerReference',
  DeliveryAddress = 'DeliveryAddress',
  SupplierIco = 'SupplierIco',
}

export interface EinvoicingAdminInbox {
  __typename?: 'EinvoicingAdminInbox';
  connected: Scalars['Boolean'];
  dic?: Maybe<Scalars['String']>;
  ico?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  peppolParticipantId?: Maybe<Scalars['String']>;
  registrationId?: Maybe<Scalars['ID']>;
  status?: Maybe<PeppolRegistrationStatus>;
  venueNames: Array<Scalars['String']>;
}

export interface EinvoicingAdminVenue {
  __typename?: 'EinvoicingAdminVenue';
  connected: Scalars['Boolean'];
  dic?: Maybe<Scalars['String']>;
  ico?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  peppolParticipantId?: Maybe<Scalars['String']>;
}

export interface EinvoicingConnectionStatus {
  __typename?: 'EinvoicingConnectionStatus';
  canAddVenueToInbox: Scalars['Boolean'];
  connected: Scalars['Boolean'];
  documentSyncEnabled: Scalars['Boolean'];
  inboxLegalEntityId?: Maybe<Scalars['ID']>;
  lastPeppolDocumentReceivedAt?: Maybe<Scalars['Date']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  mappingConfirmed: Scalars['Boolean'];
  mappingReviewRequired: Scalars['Boolean'];
  peppolParticipantId?: Maybe<Scalars['String']>;
  portalUrl: Scalars['String'];
  smpRegistered?: Maybe<Scalars['Boolean']>;
  smpState?: Maybe<EinvoicingSmpState>;
  syncSkippedCount: Scalars['Int'];
  venueOnInbox: Scalars['Boolean'];
  venues: Array<EinvoicingConnectionVenue>;
}

export interface EinvoicingConnectionVenue {
  __typename?: 'EinvoicingConnectionVenue';
  id: Scalars['ID'];
  name: Scalars['String'];
}

export enum EinvoicingSmpState {
  Elsewhere = 'Elsewhere',
  External = 'External',
  Pending = 'Pending',
  Registered = 'Registered',
  Rejected = 'Rejected',
}

export interface EmailInvoiceUploadMeta {
  __typename?: 'EmailInvoiceUploadMeta';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  receivedAt: Scalars['Date'];
  receivedFrom: Scalars['String'];
}

export interface Employee {
  __typename?: 'Employee';
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  defaultDepartment?: Maybe<Department>;
  defaultDepartmentId?: Maybe<Scalars['ID']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  integrationType?: Maybe<LaborIntegrationType>;
  lastName?: Maybe<Scalars['String']>;
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface ExistingAccountObjectType {
  __typename?: 'ExistingAccountObjectType';
  accountId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  lastName: Scalars['String'];
  venueNames: Array<Scalars['String']>;
}

export interface Expense {
  __typename?: 'Expense';
  accountingInfo?: Maybe<ExpenseAccountingInfo>;
  accountingInfoId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  bankInfo?: Maybe<ExpenseBankInfo>;
  bankInfoId?: Maybe<Scalars['ID']>;
  bulkPaymentExportedAt?: Maybe<Scalars['Date']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  documentType?: Maybe<InvoiceType>;
  dueDate?: Maybe<Scalars['Date']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  expensePayments: Array<ExpensePaymentJoinTable>;
  hasQrCode?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalDocumentNumber?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceUploadItem?: Maybe<InvoiceUploadItem>;
  invoiceUploadItemId?: Maybe<Scalars['ID']>;
  isEligibleForDomesticBulkPayment?: Maybe<Scalars['Boolean']>;
  /** Identifies a date when this expense will be reflected in accounting */
  issueDate?: Maybe<Scalars['Date']>;
  laborInfo?: Maybe<ExpenseLaborInfo>;
  laborInfoId?: Maybe<Scalars['ID']>;
  legacyCategoryId?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  predecessor?: Maybe<Expense>;
  predecessorId?: Maybe<Scalars['ID']>;
  recurrencePattern?: Maybe<RecurrencePattern>;
  recurrencePatternId?: Maybe<Scalars['ID']>;
  splitFields: Array<ExpenseSplitField>;
  statementEntries: Array<StatementEntry>;
  status: ExpenseStatus;
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']>;
  taxPointDate?: Maybe<Scalars['Date']>;
  timezone: Scalars['String'];
  updatedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  updatedById?: Maybe<Scalars['ID']>;
  validationErrors?: Maybe<Array<Scalars['String']>>;
  variableSymbol?: Maybe<Scalars['String']>;
  venue: Venue;
  venueId: Scalars['ID'];
  xeroTrackingLink?: Maybe<ExpenseXeroTrackingLink>;
  xeroTrackingLinkId?: Maybe<Scalars['ID']>;
}

export interface ExpenseAboExport {
  __typename?: 'ExpenseAboExport';
  aboExport: Scalars['String'];
  ocrExpenses: Array<OcrExpense>;
  unifiedExpenses?: Maybe<Array<Expense>>;
}

export interface ExpenseAccountingInfo {
  __typename?: 'ExpenseAccountingInfo';
  accountingCategoryId?: Maybe<Scalars['ID']>;
  /** @deprecated Denormalised fallback only. Bank identity lives on ExpenseBankInfo.supplierBankAccountId. */
  bankAccountNumber?: Maybe<Scalars['String']>;
  /** @deprecated Denormalised fallback only. Bank identity lives on ExpenseBankInfo.supplierBankAccountId. */
  bankCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  exportedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceType: InvoiceType;
  paymentMethod: ExpensePaymentMethod;
  senderAddress: Scalars['String'];
  taxPointDate: Scalars['Date'];
  taxes: Array<ExpenseTax>;
  variableSymbol?: Maybe<Scalars['String']>;
  vatBreakdown?: Maybe<VatBreakdown>;
}

export interface ExpenseAgenda {
  __typename?: 'ExpenseAgenda';
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  initialCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface ExpenseBankInfo {
  __typename?: 'ExpenseBankInfo';
  /** @deprecated Denormalised fallback only. Read bank identity via supplierBankAccountId / resolveEffectiveBankAccount. */
  bankAccountNumber?: Maybe<Scalars['String']>;
  /** @deprecated Denormalised fallback only. Read bank identity via supplierBankAccountId / resolveEffectiveBankAccount. */
  bankCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isBankInfoVerified?: Maybe<Scalars['Boolean']>;
  supplierBankAccount?: Maybe<SupplierBankAccount>;
  supplierBankAccountId?: Maybe<Scalars['ID']>;
  variableSymbol?: Maybe<Scalars['String']>;
}

export interface ExpenseConnection {
  __typename?: 'ExpenseConnection';
  edges: Array<ExpenseEdge>;
  pageInfo: ExpensePageInfo;
  totalCount?: Maybe<Scalars['Int']>;
}

export enum ExpenseDateFilterType {
  AccountingDate = 'AccountingDate',
  DueDate = 'DueDate',
  IssueDate = 'IssueDate',
}

export interface ExpenseEdge {
  __typename?: 'ExpenseEdge';
  cursor: Scalars['String'];
  node: ExpenseNode;
}

export interface ExpenseLaborInfo {
  __typename?: 'ExpenseLaborInfo';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  insuranceAmount?: Maybe<Scalars['Int']>;
  socialSecurityAmount?: Maybe<Scalars['Int']>;
}

export type ExpenseNode =
  | Expense
  | LaborExpenseTimeSeriesObjectType
  | OneTimeExpense
  | OneTimeLaborExpense
  | RecurringExpenseTimeSeriesObjectType
  | SupplyExpense;

export interface ExpenseOccurrenceInputType {
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
}

export interface ExpensePageInfo {
  __typename?: 'ExpensePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
}

export interface ExpensePaymentJoinTable {
  __typename?: 'ExpensePaymentJoinTable';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  expense?: Maybe<Expense>;
  expenseId: Scalars['ID'];
  id: Scalars['ID'];
  payment: Payment;
  paymentId: Scalars['ID'];
}

export enum ExpensePaymentMethod {
  Cash = 'Cash',
  CashOnDelivery = 'CashOnDelivery',
  Credit = 'Credit',
  Deposit = 'Deposit',
  DirectDebit = 'DirectDebit',
  PaymentCard = 'PaymentCard',
  Transfer = 'Transfer',
}

export enum ExpensePaymentStatus {
  Overdue = 'Overdue',
  Paid = 'Paid',
  Unpaid = 'Unpaid',
}

export interface ExpenseSepaExport {
  __typename?: 'ExpenseSepaExport';
  ocrExpenses: Array<OcrExpense>;
  sepaExport: Scalars['String'];
  unifiedExpenses?: Maybe<Array<Expense>>;
}

export enum ExpenseSortKey {
  Amount = 'AMOUNT',
  Category = 'CATEGORY',
  Date = 'DATE',
  DueDate = 'DUE_DATE',
  Supplier = 'SUPPLIER',
}

export interface ExpenseSplitField {
  __typename?: 'ExpenseSplitField';
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  category: Category;
  categoryId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  expenseId: Scalars['ID'];
  id: Scalars['ID'];
  legacyCategoryId?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface ExpenseStaExport {
  __typename?: 'ExpenseStaExport';
  ocrExpenses: Array<OcrExpense>;
  staExport: Scalars['String'];
  unifiedExpenses?: Maybe<Array<Expense>>;
}

export enum ExpenseStatus {
  Approved = 'Approved',
  Pending = 'Pending',
}

export interface ExpenseStructuredTotalAmountObjectType {
  __typename?: 'ExpenseStructuredTotalAmountObjectType';
  oneTimeExpensesTotalAmount: TotalAmountObjectType;
  oneTimeLaborExpensesTotalAmount: TotalAmountObjectType;
  recurringExpensesTotalAmount: TotalAmountObjectType;
  recurringLaborExpensesTotalAmount: TotalAmountObjectType;
  supplyExpensesTotalAmount: TotalAmountObjectType;
}

export interface ExpenseTax {
  __typename?: 'ExpenseTax';
  baseAmount: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  expenseAccountingInfoId: Scalars['ID'];
  id: Scalars['ID'];
  rate: TaxRate;
  taxAmount: Scalars['Int'];
}

export interface ExpenseTotalByCategoryObjectType {
  __typename?: 'ExpenseTotalByCategoryObjectType';
  amount: Scalars['Float'];
  amountWithoutSpecifiedVat?: Maybe<Scalars['Float']>;
  amountWithoutVat?: Maybe<Scalars['Float']>;
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  currencyCode: CurrencyCode;
  id: Scalars['ID'];
  precision: Scalars['Int'];
  revenueCategoryId: Scalars['ID'];
  revenueCategoryName: Scalars['String'];
}

export enum ExpenseType {
  OneTime = 'OneTime',
  Recurring = 'Recurring',
}

export interface ExpenseXeroTrackingLink {
  __typename?: 'ExpenseXeroTrackingLink';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  trackingCategory: XeroTrackingCategory;
  trackingCategoryId: Scalars['ID'];
  trackingOption: XeroTrackingOption;
  trackingOptionId: Scalars['ID'];
  venueId: Scalars['ID'];
}

export interface ExpensesAmountsWithPaymentByMonthObjectType {
  __typename?: 'ExpensesAmountsWithPaymentByMonthObjectType';
  amount: Scalars['Float'];
  amountPaid: Scalars['Float'];
  amountWithoutSpecifiedVat?: Maybe<Scalars['Float']>;
  amountWithoutVat?: Maybe<Scalars['Float']>;
  currencyCode: CurrencyCode;
  id: Scalars['ID'];
  /** month 1-12 */
  isoMonth: Scalars['Int'];
  /** Year in format YYYY */
  isoYear: Scalars['Int'];
  precision: Scalars['Int'];
}

export interface ExportAllExpensesCsvResponse {
  __typename?: 'ExportAllExpensesCsvResponse';
  /** CSV body prefixed with a UTF-8 BOM so spreadsheet apps detect the encoding correctly */
  fileContent: Scalars['String'];
  filename: Scalars['String'];
  /** True when the export hit the server-side row cap; the file is incomplete and the user should narrow filters and re-export. */
  truncated: Scalars['Boolean'];
}

export interface FakturoidInvoicePaymentDataObjectType {
  __typename?: 'FakturoidInvoicePaymentDataObjectType';
  amount?: Maybe<Scalars['Float']>;
  bankAccount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  qrCodeString?: Maybe<Scalars['String']>;
  variableSymbol?: Maybe<Scalars['String']>;
}

export interface FlowpayApplication {
  __typename?: 'FlowpayApplication';
  cashflowLinkedAccount?: Maybe<CashflowLinkedAccount>;
  cashflowLinkedAccountId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  externalFinancingId?: Maybe<Scalars['String']>;
  flowpayMerchantId: Scalars['ID'];
  id: Scalars['ID'];
  latestLoanDetails?: Maybe<FlowpayLoanDetails>;
  loanPurpose?: Maybe<Scalars['String']>;
  state: FlowpayApplicationState;
  updatedById?: Maybe<Scalars['ID']>;
}

export enum FlowpayApplicationState {
  Canceled = 'Canceled',
  Collection = 'Collection',
  ConfirmingApplicationDetails = 'ConfirmingApplicationDetails',
  ContractSent = 'ContractSent',
  ContractSigned = 'ContractSigned',
  CounterOfferReceived = 'CounterOfferReceived',
  CounterOfferRefused = 'CounterOfferRefused',
  Disbursed = 'Disbursed',
  EvaluatingOffer = 'EvaluatingOffer',
  Failed = 'Failed',
  InitialOfferRejected = 'InitialOfferRejected',
  LoanApplicationApproved = 'LoanApplicationApproved',
  LoanApplicationInReview = 'LoanApplicationInReview',
  LoanApplicationRejected = 'LoanApplicationRejected',
  Overdue = 'Overdue',
  Paid = 'Paid',
  PendingDisbursement = 'PendingDisbursement',
  SelectingBankAccounts = 'SelectingBankAccounts',
  SpecifyingLoanDetails = 'SpecifyingLoanDetails',
  VerifyingExecutives = 'VerifyingExecutives',
}

export interface FlowpayApplicationWithDetailsDto {
  __typename?: 'FlowpayApplicationWithDetailsDto';
  companyId: Scalars['String'];
  flowpayApplication: FlowpayApplication;
  installments?: Maybe<Array<FlowpayInstallmentDto>>;
  isActive: Scalars['Boolean'];
  outstandingAmount?: Maybe<Scalars['Int']>;
  paidAmount?: Maybe<Scalars['Int']>;
  totalAmount?: Maybe<Scalars['Int']>;
  venueNames: Array<Scalars['String']>;
}

export interface FlowpayFinancingPurposeDto {
  __typename?: 'FlowpayFinancingPurposeDto';
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface FlowpayFinancingSignatureInfoDto {
  __typename?: 'FlowpayFinancingSignatureInfoDto';
  rep1Id: Scalars['String'];
  rep1SignatureUrl: Scalars['String'];
  rep1Signed: Scalars['Boolean'];
  rep2Id?: Maybe<Scalars['String']>;
  rep2SignatureUrl?: Maybe<Scalars['String']>;
  rep2Signed?: Maybe<Scalars['Boolean']>;
}

export interface FlowpayInstallmentDto {
  __typename?: 'FlowpayInstallmentDto';
  dueDate?: Maybe<Scalars['Date']>;
  paidAmount?: Maybe<Scalars['Int']>;
  paidDate?: Maybe<Scalars['Date']>;
  state?: Maybe<FlowpayInstallmentState>;
  totalAmount?: Maybe<Scalars['Int']>;
}

export enum FlowpayInstallmentState {
  Canceled = 'Canceled',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Pending = 'Pending',
  Planned = 'Planned',
  Prolonged = 'Prolonged',
  Rescheduled = 'Rescheduled',
}

export interface FlowpayLoanDetails {
  __typename?: 'FlowpayLoanDetails';
  amount: Scalars['Int'];
  createdAt: Scalars['Date'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  externalOfferId: Scalars['String'];
  flowpayApplication: FlowpayApplication;
  flowpayApplicationId: Scalars['ID'];
  id: Scalars['ID'];
  postponedPeriods: Scalars['Int'];
  product: FlowpayProductType;
  prolonged: Scalars['Boolean'];
  proposedByFlowpay: Scalars['Boolean'];
  ratePerc: Scalars['Float'];
  supersededBy?: Maybe<FlowpayLoanDetails>;
  supersededById?: Maybe<Scalars['ID']>;
}

export interface FlowpayMerchant {
  __typename?: 'FlowpayMerchant';
  businessEntityId: Scalars['ID'];
  companyId: Scalars['String'];
  companyWebsite: Scalars['String'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  externalCustomerId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  offerState?: Maybe<FlowpayOfferState>;
  phoneNumber: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
}

export interface FlowpayOffer {
  __typename?: 'FlowpayOffer';
  id: Scalars['String'];
  products: Array<FlowpayOfferProduct>;
}

export interface FlowpayOfferProduct {
  __typename?: 'FlowpayOfferProduct';
  balloon?: Maybe<Scalars['Boolean']>;
  currency: CurrencyCode;
  installmentCount: Scalars['Int'];
  interestRateMultiplier: Scalars['Float'];
  maxAmount: Scalars['Float'];
  maxPostponeLength: Scalars['Int'];
  maxProlongationLength: Scalars['Int'];
  minAmount: Scalars['Float'];
  postponeEnabled: Scalars['Boolean'];
  postponeFeeMultiplier: Scalars['Float'];
  product: FlowpayProductType;
  prolongationEnabled: Scalars['Boolean'];
  prolongationFeeMultiplier: Scalars['Float'];
  ratePerc: Scalars['Float'];
}

export enum FlowpayOfferState {
  Offer = 'OFFER',
  Unqualified = 'UNQUALIFIED',
}

export enum FlowpayProductType {
  M1 = 'M1',
  M3 = 'M3',
  M6 = 'M6',
  M12 = 'M12',
}

export interface FlowpayRepresentative {
  __typename?: 'FlowpayRepresentative';
  createdAt: Scalars['Date'];
  dateOfBirth?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  flowpayApplication: FlowpayApplication;
  flowpayApplicationId: Scalars['ID'];
  id: Scalars['ID'];
  isPoliticallyExposed?: Maybe<Scalars['Boolean']>;
  isSelectedForSigning?: Maybe<Scalars['Boolean']>;
  isVerificationPending?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
}

export interface FlowpayTenant {
  __typename?: 'FlowpayTenant';
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  flowpayMerchantId: Scalars['ID'];
  id: Scalars['ID'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface FormattedOrderItem {
  __typename?: 'FormattedOrderItem';
  category?: Maybe<OrderItemCategory>;
  currentPrice: Scalars['Int'];
  hasInReviewEntry: Scalars['Boolean'];
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  lastPrice: Scalars['Int'];
  lostSaved?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  pinDate?: Maybe<Scalars['Date']>;
  supplierId: Scalars['String'];
  supplierName: Scalars['String'];
  timeSeries: Array<OrderItemTimeSeries>;
  totalPriceWithVat?: Maybe<Scalars['Float']>;
  totalPriceWithoutVat?: Maybe<Scalars['Float']>;
}

export interface GenerateAiInsightsResult {
  __typename?: 'GenerateAiInsightsResult';
  durationMs: Scalars['Int'];
  insightCount: Scalars['Int'];
  runs: Array<AiInsightGenerationRun>;
}

export interface GlobalProfitAndLossObjectType {
  __typename?: 'GlobalProfitAndLossObjectType';
  excludedVenuesCount: Scalars['Int'];
  venues: Array<VenueProfitAndLossObjectType>;
}

export interface GlobalSupplier {
  __typename?: 'GlobalSupplier';
  contactEmails: Array<GlobalSupplierContactEmail>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  emailDomain?: Maybe<Scalars['String']>;
  exceptionFlag: Scalars['Boolean'];
  exceptionReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoicingEmail?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface GlobalSupplierContactEmail {
  __typename?: 'GlobalSupplierContactEmail';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  globalSupplierId: Scalars['ID'];
  id: Scalars['ID'];
}

export interface GmailIntegrationStatusObjectType {
  __typename?: 'GmailIntegrationStatusObjectType';
  emailAddress?: Maybe<Scalars['String']>;
  historicalSyncLimitHit?: Maybe<Scalars['Boolean']>;
  historicalSyncOldestProcessedAt?: Maybe<Scalars['Date']>;
  integrationId?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConnected: Scalars['Boolean'];
  lastSyncAt?: Maybe<Scalars['Date']>;
  syncStartDate?: Maybe<Scalars['Date']>;
}

export interface GroupedCashRegisterEntry {
  __typename?: 'GroupedCashRegisterEntry';
  date: Scalars['Date'];
  entries: Array<CashRegisterEntry>;
}

export interface GroupedRevenueTotals {
  __typename?: 'GroupedRevenueTotals';
  categories: Array<CategoryTotal>;
  date: Scalars['Date'];
}

export enum IcoSource {
  LegalEntity = 'LEGAL_ENTITY',
  PaymentDetails = 'PAYMENT_DETAILS',
}

export interface IdDateInputType {
  date: Scalars['Date'];
  id: Scalars['ID'];
}

export interface InitializeAutoCategorizationMigrationFailureObjectType {
  __typename?: 'InitializeAutoCategorizationMigrationFailureObjectType';
  reason: Scalars['String'];
  venueId: Scalars['ID'];
}

export interface InitializeAutoCategorizationMigrationResultObjectType {
  __typename?: 'InitializeAutoCategorizationMigrationResultObjectType';
  attempted: Scalars['Int'];
  failed: Array<InitializeAutoCategorizationMigrationFailureObjectType>;
  skipped: Array<InitializeAutoCategorizationMigrationFailureObjectType>;
  succeededVenueIds: Array<Scalars['ID']>;
}

export interface Integration {
  __typename?: 'Integration';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  dotyposIntegrationDataId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  provider: IntegrationProvider;
  storyousIntegrationDataId?: Maybe<Scalars['String']>;
}

export interface IntegrationPaymentMethod {
  __typename?: 'IntegrationPaymentMethod';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  integration: Integration;
  integrationId: Scalars['ID'];
  name: Scalars['String'];
}

export enum IntegrationProvider {
  Agnis = 'Agnis',
  Alto = 'Alto',
  Bank = 'Bank',
  DishboardCsv = 'DishboardCsv',
  Dotypos = 'Dotypos',
  EposNow = 'EposNow',
  Halberstat = 'Halberstat',
  Labor = 'Labor',
  Septim = 'Septim',
  Storyous = 'Storyous',
  Tenzo = 'Tenzo',
  Tevalis = 'Tevalis',
  Xero = 'Xero',
}

export interface IntegrationRequest {
  __typename?: 'IntegrationRequest';
  account: Account;
  accountId: Scalars['ID'];
  completedAt?: Maybe<Scalars['Date']>;
  completedById?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  provider: IntegrationProvider;
  startDate: Scalars['Date'];
  status: IntegrationRequestStatus;
  venue: Venue;
  venueId: Scalars['ID'];
}

export enum IntegrationRequestStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export interface IntegrationRevenueCategory {
  __typename?: 'IntegrationRevenueCategory';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  name: Scalars['String'];
  parentIntegrationRevenueCategoryId?: Maybe<Scalars['ID']>;
  revenueCategoryId?: Maybe<Scalars['ID']>;
}

export interface IntegrationSync {
  __typename?: 'IntegrationSync';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  finished?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  integration?: Maybe<Integration>;
  started: Scalars['Date'];
}

export enum InvoiceApprovalMode {
  AlwaysManual = 'AlwaysManual',
  Auto = 'Auto',
  ManualExceptRememberedSuppliers = 'ManualExceptRememberedSuppliers',
}

export interface InvoiceBillingStatus {
  __typename?: 'InvoiceBillingStatus';
  externalCustomerId?: Maybe<Scalars['String']>;
  hasStripeBilling: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  isLegalDataFilledIn?: Maybe<Scalars['Boolean']>;
  venueId?: Maybe<Scalars['String']>;
}

export enum InvoiceType {
  CorrectiveTax = 'CorrectiveTax',
  CreditNote = 'CreditNote',
  IssuedInvoice = 'IssuedInvoice',
  Proforma = 'Proforma',
  Receipt = 'Receipt',
  ReceivedInvoice = 'ReceivedInvoice',
}

export interface InvoiceUpload {
  __typename?: 'InvoiceUpload';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  emailUploadMeta?: Maybe<EmailInvoiceUploadMeta>;
  id: Scalars['ID'];
  items: Array<InvoiceUploadItem>;
  manualUploadMeta?: Maybe<ManualInvoiceUploadMeta>;
  uploadMethod: InvoiceUploadMethod;
  venueId: Scalars['ID'];
}

export interface InvoiceUploadItem {
  __typename?: 'InvoiceUploadItem';
  autoapproveAttempted?: Maybe<Scalars['Boolean']>;
  autoapproved?: Maybe<Scalars['Boolean']>;
  autoapprovedInvoicesNotification?: Maybe<AutoapprovedInvoicesNotification>;
  autoapprovedInvoicesNotificationId?: Maybe<Scalars['ID']>;
  bucket?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  duplicates: Array<UploadItemDuplicate>;
  expense?: Maybe<Expense>;
  externalId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize: Scalars['Int'];
  id: Scalars['ID'];
  invoiceUpload: InvoiceUploadMeta;
  invoiceUploadId: Scalars['ID'];
  isAccountingEnabled?: Maybe<Scalars['Boolean']>;
  isBankInfoEnabled?: Maybe<Scalars['Boolean']>;
  isFromPeppol: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  mergedIntoUploadItemId?: Maybe<Scalars['ID']>;
  mimeType: Scalars['String'];
  ocrExpense?: Maybe<OcrExpense>;
  ocrQueueId?: Maybe<Scalars['String']>;
  originalExternalDocumentId?: Maybe<Scalars['String']>;
  peppolPdfXmlCounterpartId?: Maybe<Scalars['ID']>;
  peppolXmlUploadItemId?: Maybe<Scalars['ID']>;
  qrCodeData?: Maybe<Scalars['String']>;
  rawOcrResponseS3Key?: Maybe<Scalars['ID']>;
  rejectionReason?: Maybe<InvoiceUploadItemRejectionReason>;
  revenue?: Maybe<Revenue>;
  state: UploadedInvoiceState;
  statement?: Maybe<Statement>;
  uploadError?: Maybe<UploadError>;
  wasExported?: Maybe<Scalars['Boolean']>;
}

export interface InvoiceUploadItemCountByFeStateObjectType {
  __typename?: 'InvoiceUploadItemCountByFeStateObjectType';
  processed: Scalars['Int'];
  processing: Scalars['Int'];
  readyForReview: Scalars['Int'];
  rejected: Scalars['Int'];
  rejectedIds: Array<Scalars['String']>;
}

export interface InvoiceUploadItemCountByStateObjectType {
  __typename?: 'InvoiceUploadItemCountByStateObjectType';
  count: Scalars['Int'];
  state: UploadedInvoiceState;
  uploadError?: Maybe<UploadError>;
}

export interface InvoiceUploadItemForExportObjectType {
  __typename?: 'InvoiceUploadItemForExportObjectType';
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  invoiceUploadItem: InvoiceUploadItem;
  name: Scalars['String'];
  purchaseDate?: Maybe<Scalars['Date']>;
}

export enum InvoiceUploadItemRejectionReason {
  Duplicate = 'DUPLICATE',
}

export interface InvoiceUploadItemWithTempUrlObjectType {
  __typename?: 'InvoiceUploadItemWithTempUrlObjectType';
  exportFileName: Scalars['String'];
  id: Scalars['ID'];
  tempUrl: Scalars['String'];
}

export interface InvoiceUploadMeta {
  __typename?: 'InvoiceUploadMeta';
  createdAt: Scalars['Date'];
  emailUploadMeta?: Maybe<PartialEmail>;
  gmailUploadMeta?: Maybe<PartialGmailSync>;
  id: Scalars['ID'];
  manualUploadMeta?: Maybe<PartialManual>;
  outlookUploadMeta?: Maybe<PartialOutlookSync>;
  seznamUploadMeta?: Maybe<PartialSeznamSync>;
  uploadMethod: InvoiceUploadMethod;
}

export enum InvoiceUploadMethod {
  Email = 'EMAIL',
  GmailSync = 'GMAIL_SYNC',
  Manual = 'MANUAL',
  OutlookSync = 'OUTLOOK_SYNC',
  Peppol = 'PEPPOL',
  SeznamSync = 'SEZNAM_SYNC',
}

export interface InvoicesConfigObjectType {
  __typename?: 'InvoicesConfigObjectType';
  invoicesStep: Scalars['Int'];
  maxInvoices: Scalars['Int'];
  minInvoices: Scalars['Int'];
}

export interface LaborExpenseGroupObjectType {
  __typename?: 'LaborExpenseGroupObjectType';
  count: Scalars['Int'];
  currencyCode: Scalars['String'];
  currencyPrecision: Scalars['Int'];
  departmentId?: Maybe<Scalars['ID']>;
  departmentName?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['ID']>;
  employeeName?: Maybe<Scalars['String']>;
  hasMultipleDepartments: Scalars['Boolean'];
  hasUnified: Scalars['Boolean'];
  maxDueDate?: Maybe<Scalars['Date']>;
  maxWorkDate?: Maybe<Scalars['Date']>;
  minDueDate?: Maybe<Scalars['Date']>;
  minWorkDate?: Maybe<Scalars['Date']>;
  totalAmount: Scalars['Int'];
  unpaidAmount: Scalars['Int'];
  unpaidCount: Scalars['Int'];
}

export interface LaborExpenseTimeSeriesObjectType {
  __typename?: 'LaborExpenseTimeSeriesObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  currencyPrecision: Scalars['Int'];
  date: Scalars['Date'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']>;
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']>;
  id: Scalars['String'];
  isCashflowTransactionLinked: Scalars['Boolean'];
  isPaid: Scalars['Boolean'];
  isUnified?: Maybe<Scalars['Boolean']>;
  laborExpense: LaborExpenseUnion;
  laborExpenseId: Scalars['ID'];
  laborExpenseType: ExpenseType;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
}

export type LaborExpenseUnion =
  | Expense
  | OneTimeLaborExpense
  | RepeatingLaborExpense;

export interface LaborIntegration {
  __typename?: 'LaborIntegration';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  integrationType: LaborIntegrationType;
  startDate: Scalars['Date'];
}

export enum LaborIntegrationType {
  Bizimply = 'BIZIMPLY',
  Deputy = 'DEPUTY',
  Planday = 'PLANDAY',
  Rota = 'ROTA',
}

export enum LegacyCategoryMappingAction {
  Archive = 'Archive',
  KeepAsCustom = 'KeepAsCustom',
  MapToCategory = 'MapToCategory',
}

export interface LegacyCategoryMappingInput {
  action: LegacyCategoryMappingAction;
  keepRememberedSuppliers?: InputMaybe<Scalars['Boolean']>;
  legacyCategoryId: Scalars['ID'];
  targetCategoryId?: InputMaybe<Scalars['ID']>;
}

export interface LegacyCategoryRememberedSuppliers {
  __typename?: 'LegacyCategoryRememberedSuppliers';
  legacyCategoryId: Scalars['ID'];
  supplierNames: Array<Scalars['String']>;
}

export interface LegalEntity {
  __typename?: 'LegalEntity';
  address?: Maybe<Scalars['String']>;
  businessEntityId: Scalars['ID'];
  city?: Maybe<Scalars['String']>;
  companyIdentificationNumber?: Maybe<Scalars['String']>;
  country: CountryCode;
  createdAt: Scalars['Date'];
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  district?: Maybe<Scalars['String']>;
  einvoiceDocumentSyncEnabled: Scalars['Boolean'];
  einvoiceMappingConfirmed: Scalars['Boolean'];
  einvoiceSmpRegistered?: Maybe<Scalars['Boolean']>;
  einvoiceSmpState?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legalName?: Maybe<Scalars['String']>;
  peppolParticipantId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  taxIdentificationNumber?: Maybe<Scalars['String']>;
  vertecoCompanyId?: Maybe<Scalars['String']>;
}

export interface ManualApprovalRule {
  __typename?: 'ManualApprovalRule';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  supplierIds?: Maybe<Array<Scalars['ID']>>;
  thresholdAmount?: Maybe<Scalars['Int']>;
  type: ManualApprovalRuleType;
  venueId: Scalars['ID'];
}

export interface ManualApprovalRuleInput {
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  thresholdAmount?: InputMaybe<Scalars['Int']>;
  type: ManualApprovalRuleType;
}

export enum ManualApprovalRuleType {
  Amount = 'Amount',
  Supplier = 'Supplier',
}

export interface ManualInvoiceUploadMeta {
  __typename?: 'ManualInvoiceUploadMeta';
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  updatedById?: Maybe<Scalars['ID']>;
  uploadSource?: Maybe<ManualInvoiceUploadSource>;
}

export enum ManualInvoiceUploadSource {
  Mobile = 'MOBILE',
  Web = 'WEB',
}

export interface MergePeppolPdfXmlInput {
  pdfInvoiceUploadItemId: Scalars['ID'];
  xmlInvoiceUploadItemId: Scalars['ID'];
}

export interface MobileLoginResponseObjectType {
  __typename?: 'MobileLoginResponseObjectType';
  accessToken: Scalars['String'];
  client_id: Scalars['String'];
  cultureCode: CultureCode;
  currency: Currency;
  email: Scalars['String'];
  family_name: Scalars['String'];
  given_name: Scalars['String'];
  languageCode: CultureCode;
  refreshToken: Scalars['String'];
  scope: ScopeObjectType;
  subscriptionData: SubscriptionDataObjectType;
  zoneinfo: Scalars['String'];
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptFlowpayCounteroffer: FlowpayApplication;
  acceptPeppolRegistration: Scalars['Boolean'];
  activateDeputyIntegration: LaborIntegration;
  activateDotyposIntegration: Scalars['Boolean'];
  activateEposNowIntegration: Scalars['Boolean'];
  activateGmailIntegration: GmailIntegrationStatusObjectType;
  activateOutlookIntegration: OutlookIntegrationStatusObjectType;
  activatePlandayIntegration: LaborIntegration;
  activateSeznamIntegration: SeznamIntegrationStatusObjectType;
  activateXeroIntegration: Scalars['Boolean'];
  addGlobalSupplierContactEmail: GlobalSupplier;
  addRevenue: Revenue;
  addRevenues: Array<Revenue>;
  addUserToVenueAsAdmin: User;
  addVenueToEinvoicingInbox: EinvoicingConnectionStatus;
  addVenueToExistingXeroConnection: Scalars['Boolean'];
  advanceProductFlow: ProductFlowStateObjectType;
  advanceVenueSetupFlow: VenueOnboardingStateResponse;
  aiInsightContext: AiInsightContextResult;
  approveExpense: Expense;
  approveIssuedInvoice: Revenue;
  approveStatement: Statement;
  archivePendingAccount: AdminPendingNewAccount;
  askAiInsightQuestion: Scalars['Boolean'];
  assignCashflowToStatementEntries: Scalars['Boolean'];
  assignPeppolInbox: LegalEntity;
  assignRevenueCategory: Category;
  assignSystemCategory: Array<Category>;
  assignUnassignedPeppolDocument: PeppolUnassignedDocument;
  beginAdminMfaEnrollment: AdminMfaEnrollmentBeginObjectType;
  buildCashflowConnectionLink: Scalars['String'];
  buildDeputyConnectionLink: Scalars['String'];
  buildGmailConnectionLink: Scalars['String'];
  buildOutlookConnectionLink: Scalars['String'];
  buildPlandayConnectionLink: Scalars['String'];
  checkAuthState?: Maybe<CurrentUserObjectType>;
  clearAiInsights: ClearAiInsightsResult;
  completeLegacyCategoryMapping: Scalars['Boolean'];
  completeProductFlow: ProductFlowStateObjectType;
  confirmAdminMfaEnrollment: AdminMfaBackupCodesObjectType;
  confirmPendingAccount: AdminPendingNewAccount;
  confirmSubscriptionUpgrade: ConfirmSubscriptionUpgradeResult;
  connectStoryousIntegration: Integration;
  convertIssuedInvoiceToExpense: Expense;
  convertOcrExpenseToOneTimeExpense: Scalars['Boolean'];
  convertOcrExpenseToOneTimeExpenseNew: OneTimeExpense;
  convertOcrExpenseToSplitExpenseNew: SplitExpense;
  convertOcrExpenseToSupplyExpense: Scalars['Boolean'];
  convertOcrExpenseToSupplyExpenseNew: SupplyExpense;
  convertSupplierToEmployee: Supplier;
  createAccountAsAdmin: Account;
  createAccountWithAccess: Account;
  createAccountingCategory: AccountingCategory;
  createAccountingExport: CreateExportResponseType;
  createCashRegisterEntries: Array<CashRegisterEntry>;
  createCashflowManualAccount: CashflowManualAccount;
  createCashflowManualDeposit: CashflowManualTransaction;
  createCashflowManualTransfer: CashflowManualTransaction;
  createCashflowManualWithdrawal: CashflowManualTransaction;
  createCategory: Category;
  createCustomCheckoutLink: Scalars['String'];
  createCustomerPortalSession: Scalars['String'];
  createDepartment: Department;
  createEmployee: Employee;
  createEmployeeSupplier: Supplier;
  createExpense: Expense;
  createGlobalSupplier: GlobalSupplier;
  createOneTimeExpense: OneTimeExpense;
  createOneTimeLaborExpense: OneTimeLaborExpense;
  createOrderItemAlert: OrderItemAlert;
  createPaymentMethod: PaymentMethod;
  createPendingAccount: AdminPendingNewAccount;
  createRepeatingExpense: RepeatingExpense;
  createRepeatingLaborExpense: RepeatingLaborExpense;
  createRepeatingUnifiedExpense: Expense;
  createRevenueCategory: RevenueCategory;
  createRevenueSource: RevenueSource;
  createSageJourtisExport: Scalars['String'];
  createStatementEntry: StatementEntry;
  createSupplier: Supplier;
  createSupplierBankAccount: SupplierBankAccount;
  createSupplyExpense: SupplyExpense;
  createVenue: Venue;
  createVenueBankAccount: VenueBankAccount;
  deleteAiInsight: Scalars['Boolean'];
  deleteCashflowLinkedAccount: CashflowLinkedAccount;
  deleteCashflowManualAccount: CashflowManualAccount;
  deleteCashflowManualTransaction: Scalars['Boolean'];
  deleteOrderItemAlert: Scalars['Boolean'];
  deleteOrderItemEntry: Scalars['Boolean'];
  deleteSupplierBankAccount: Scalars['Boolean'];
  denyPeppolRegistration: Scalars['Boolean'];
  disableAutomatedFollowUps: SupplierIntegrationRequest;
  disconnectGmailIntegration: Scalars['Boolean'];
  disconnectOutlookIntegration: Scalars['Boolean'];
  disconnectSeznamIntegration: Scalars['Boolean'];
  dismissAppNotification: AppNotification;
  dismissOrderItemAlertNotification: Scalars['Boolean'];
  dismissProductFlow: ProductFlowStateObjectType;
  editPendingAccount: AdminPendingNewAccount;
  enableVenueAutoCategorization: Venue;
  /** Generate a CSV export of unified expenses matching the given filters */
  exportAllExpensesAsCsv: ExportAllExpensesCsvResponse;
  generateAiInsights: GenerateAiInsightsResult;
  getKycVerificationToken: Scalars['String'];
  initializeAutoCategorizationMigration: InitializeAutoCategorizationMigrationResultObjectType;
  initiateFlowpayService: FlowpayApplication;
  initiateRotaConnection: LaborIntegration;
  initiateSupplierIntegrations: Array<SupplierIntegrationRequest>;
  linkVenueBillingAccount: Scalars['Boolean'];
  login: CurrentUserObjectType;
  logout: Scalars['Boolean'];
  mapPosCategoriesToRevenueCategory: Scalars['Boolean'];
  markAutoapprovedAsUnseen: Scalars['Boolean'];
  markAutoapprovedBatchAsSeen: Scalars['Boolean'];
  markCashflowLinkedTransactionNotAnExpense: CashflowLinkedTransaction;
  markCashflowManualTransactionNotAnExpense: CashflowManualTransaction;
  markExpensePaid: Expense;
  markLaborExpenseGroupAsPaid: Scalars['Boolean'];
  markLaborExpensesAsPaid: Scalars['Boolean'];
  markOneTimeExpensePayed: OneTimeExpense;
  markOneTimeLaborExpensePayed: OneTimeLaborExpense;
  markOrderItemAlertNotificationAsSeen: Scalars['Boolean'];
  markOrderItemNotificationAsSeen: OrderItemsExtractedNotification;
  markRepeatingExpensePaid: Scalars['Boolean'];
  markRepeatingLaborExpensePaid: Scalars['Boolean'];
  markRepeatingLaborExpensePaidOneByOne: Array<RepeatingLaborExpense>;
  markRevenuePaid: RevenuePayment;
  markSplitExpensePaid: SplitExpense;
  markStoryousIntegrationRequestCompleted: IntegrationRequest;
  markSupplyExpensePayed: SupplyExpense;
  markUnifiedExpensesPaid: Scalars['Boolean'];
  markVerificationStepComplete: FlowpayApplication;
  mergePeppolPdfXmlUploadItems: InvoiceUploadItem;
  mergeSupplierIntoEmployee: Supplier;
  mobileLogin: MobileLoginResponseObjectType;
  mobileRefreshToken: MobileLoginResponseObjectType;
  mobileSwitchVenue: MobileLoginResponseObjectType;
  moveVenueToPaywall: SubscriptionData;
  overwriteRevenue: Revenue;
  pairCashflowLinkedTransactionWithExpense: CashflowLinkedTransaction;
  pairCashflowManualTransactionWithExpense: CashflowManualTransaction;
  pairStatementEntry: StatementEntry;
  processSkippedPeppolDocuments: Scalars['Int'];
  reachProductFlowCheckpoint?: Maybe<ProductFlowStateObjectType>;
  reassignDocumentVenue: Scalars['Boolean'];
  refreshXeroTrackingCategories: Scalars['Boolean'];
  regenToken: CurrentUserObjectType;
  regenerateAiFinding: RegenerateAiFindingResult;
  rejectExpense: Scalars['Boolean'];
  rejectFlowpayCounteroffer: FlowpayApplication;
  rejectInvoiceUploadItem: Scalars['Boolean'];
  rejectInvoiceUploadItems: Array<Scalars['ID']>;
  rejectStoryousIntegrationRequest: IntegrationRequest;
  removeAccountingCategory: Scalars['Boolean'];
  removeCategory: Scalars['Boolean'];
  removeDepartment: Scalars['Boolean'];
  removeEinvoiceRoutingRule: Scalars['Boolean'];
  removeEmployee: Scalars['Boolean'];
  removeExpense: Scalars['Boolean'];
  removeOneTimeExpense: Scalars['Boolean'];
  removeOneTimeLaborExpense: Scalars['Boolean'];
  removePaymentMethod: Scalars['Boolean'];
  removeRepeatingExpense: Scalars['Boolean'];
  removeRepeatingLaborExpense: Scalars['Boolean'];
  removeRevenue: Scalars['Boolean'];
  removeRevenueSource: Scalars['Boolean'];
  removeSplitExpense: Scalars['Boolean'];
  removeStatement: Scalars['Boolean'];
  removeStatementEntry: Scalars['Boolean'];
  removeSupplier: Scalars['Boolean'];
  removeSupplierDefaultCategory: Scalars['Boolean'];
  removeSupplyExpense: Scalars['Boolean'];
  removeUser: User;
  requestInvoiceFiles: Scalars['Boolean'];
  requestPOSIntegration: Scalars['String'];
  rescheduleRepeatingExpense: RepeatingExpense;
  rescheduleRepeatingLaborExpense: RepeatingLaborExpense;
  resetAdminMfaForAccount: Scalars['Boolean'];
  resetOwnAdminMfa: Scalars['Boolean'];
  resetPassword: CurrentUserObjectType;
  resolvePasswordResetToken: PasswordResetTokenValidationResultObjectType;
  restoreAccountingCategory: Scalars['Boolean'];
  restoreCategory: Scalars['Boolean'];
  restoreDepartment: Scalars['Boolean'];
  restoreEmployee: Scalars['Boolean'];
  restorePaymentMethod: Scalars['Boolean'];
  restoreRevenueSource: Scalars['Boolean'];
  restoreSupplier: Scalars['Boolean'];
  reuploadInvoice: InvoiceUpload;
  revertCashflowLinkedTransactionWithdrawal: CashflowLinkedTransaction;
  saveDeputyCompanies: Scalars['Boolean'];
  saveEinvoiceRoutingRule: EinvoiceRoutingRule;
  saveEinvoicingSettings: EinvoicingConnectionStatus;
  savePlandayDepartments: Scalars['Boolean'];
  saveRotaSites: Scalars['Boolean'];
  sendResetPasswordEmail: Scalars['Boolean'];
  sendToXero: SendToXeroResponseObjectType;
  /** @deprecated Use setInvoiceApprovalMode */
  setAlwaysRequireManualInvoiceApproval: Venue;
  setCashflowEnabled: Venue;
  setDefaultCategories: Array<SupplierDefaultCategory>;
  setDefaultCategory: SupplierDefaultCategory;
  setDefaultDepartment: Employee;
  setFlowpayMerchantCashflowAccounts: Scalars['Boolean'];
  setInvoiceApprovalMode: Venue;
  setIssuedInvoiceAdditionalSuppliers: Venue;
  setManualApprovalRules: Venue;
  setNoVatMode: Venue;
  setReportingMode: Venue;
  setVatCustomPeriod: Venue;
  setWarehouseInventoryValue: WarehouseInventoryValue;
  setupInvoiceBilling: InvoiceBillingStatus;
  signUp: SignUpObjectType;
  skipExpenseOccurrence: Scalars['Boolean'];
  skipProductFlowStep: ProductFlowStateObjectType;
  skipRepeatingExpense: RepeatingExpense;
  skipRepeatingLaborExpense: RepeatingLaborExpense;
  skipVenueSetupFlowStep: VenueOnboardingStateResponse;
  softDeleteInvoiceUploadItem: InvoiceUploadItem;
  softDeleteInvoiceUploadItems: Array<InvoiceUploadItem>;
  splitExpense: Expense;
  startCostRadarTrial: CostRadarSubscription;
  startRequisitionSetup: CashflowRequisition;
  submitActiveApplication: FlowpayApplication;
  submitAiInsightFeedback: AiInsightMyFeedback;
  submitEinvoicingMigrationCode: LegalEntity;
  submitLoanDetails: FlowpayApplication;
  switchVenue: CurrentUserObjectType;
  syncFakturoidCompanyDetails: SyncFakturoidCompanyDetailsResultObjectType;
  tempSendToDishboardOcr: Scalars['Boolean'];
  terminateExpense: Expense;
  terminateRepeatingExpense: RepeatingExpense;
  terminateRepeatingLaborExpense: RepeatingLaborExpense;
  toggleOnboardingFlagForAVenue: Scalars['Boolean'];
  togglePinOrderItem: OrderItem;
  trackAnalytics: Scalars['Boolean'];
  trackExpenseAsPaidFromCalendar: Scalars['Boolean'];
  trackPnlSystemCategoriesToggle: Scalars['Boolean'];
  trackUnpairedTransactionOnlyFilter: Scalars['Boolean'];
  unarchivePendingAccount: AdminPendingNewAccount;
  unassignPeppolInbox: Scalars['Boolean'];
  unassignPeppolVenue: Scalars['Boolean'];
  /** Marks a hidden category (and any hidden ancestors in its parent chain) as visible. */
  unhideCategory: Category;
  unmarkExpensePaid: Expense;
  unmarkLaborExpenseGroupAsPaid: Scalars['Boolean'];
  unmarkLaborExpensesAsPaid: Scalars['Boolean'];
  unmarkOneTimeExpensePayed: OneTimeExpense;
  unmarkOneTimeLaborExpensePayed: OneTimeLaborExpense;
  unmarkRepeatingExpensePaid: Scalars['Boolean'];
  unmarkRepeatingLaborExpensePaid: Scalars['Boolean'];
  unmarkRepeatingLaborExpensePaidOneByOne: Array<RepeatingLaborExpense>;
  unmarkRevenuePaid: Scalars['Boolean'];
  unmarkSplitExpensePaid: SplitExpense;
  unmarkSupplyExpensePayed: SupplyExpense;
  unmarkUnifiedExpensesPaid: Scalars['Boolean'];
  unpairCashflowLinkedTransactionFromExpense: CashflowLinkedTransaction;
  unpairCashflowManualTransactionFromExpense: CashflowManualTransaction;
  unpairStatementEntry: StatementEntry;
  unsplitExpense: Expense;
  updateAccountingCategory: AccountingCategory;
  updateCashRegisterEntries: Array<CashRegisterEntry>;
  updateCashflowAccountRole: CashflowAccountRole;
  updateCashflowLinkedAccount: CashflowLinkedAccount;
  updateCashflowLinkedTransaction: CashflowLinkedTransaction;
  updateCashflowManualAccount: CashflowManualAccount;
  updateCashflowManualTransaction: CashflowManualTransaction;
  updateCategory: Category;
  updateCostRadarSubscription: CostRadarSubscription;
  updateCurrentAccount: Account;
  updateCurrentLegalEntity: LegalEntity;
  updateDepartment: Department;
  updateEmployee: Employee;
  updateEmployeeSupplier: Supplier;
  updateExpense: Expense;
  updateExpenseSplitFields: Expense;
  updateFlowpayRepresentative: FlowpayRepresentative;
  updateGlobalSupplier: GlobalSupplier;
  updateInvoiceUploadItemAgenda: InvoiceUploadItem;
  updateIssuedInvoice: Revenue;
  updateLoanPurpose: FlowpayApplication;
  updateNotificationPreferences: NotificationPreference;
  updateOneTimeExpense?: Maybe<OneTimeExpense>;
  updateOneTimeExpenseNew: SupplyAndOneTimeExpenseObjectType;
  updateOneTimeLaborExpense: OneTimeLaborExpense;
  updateOrderItemAlert: OrderItemAlert;
  updateOrderItemEntry: OrderItemEntry;
  updateOrderItemEntryStatus: OrderItemEntry;
  updatePaymentMethod: PaymentMethod;
  updateRepeatingExpense: RepeatingExpense;
  updateRepeatingLaborExpense: RepeatingLaborExpense;
  updateRevenue: Revenue;
  updateRevenueSource: RevenueSource;
  updateSplitExpenseNew: SplitExpense;
  updateSupplier: Supplier;
  updateSupplierBankAccount: SupplierBankAccount;
  updateSupplyExpense?: Maybe<SupplyExpense>;
  updateSupplyExpenseNew: SupplyAndOneTimeExpenseObjectType;
  updateUserRole: User;
  updateVenueAdmin: Venue;
  updateVenueBankAccount: VenueBankAccount;
  updateVenueForwardingEmails: Venue;
  updateVenueGracePeriod: Venue;
  updateVenueInvoiceLimit: SubscriptionData;
  updateVenueNotificationEmails: Venue;
  updateVenueRenewalDay: SubscriptionData;
  updateXeroIntegrationSettings: Scalars['Boolean'];
  upgradeCostRadarTrial: CostRadarSubscription;
  uploadInvoice: InvoiceUpload;
  uploadMatchedSuppliers: Scalars['Boolean'];
  upsertPaymentDetails: Scalars['Boolean'];
  validatePasswordResetToken: Scalars['Boolean'];
  verifyAdminMfa: Scalars['Boolean'];
  verifyAdminMfaBackupCode: Scalars['Boolean'];
}

export interface MutationAcceptPeppolRegistrationArgs {
  registrationId: Scalars['ID'];
}

export interface MutationActivateDeputyIntegrationArgs {
  authCode: Scalars['String'];
  state: Scalars['String'];
}

export interface MutationActivateDotyposIntegrationArgs {
  cloudId: Scalars['String'];
  csrfToken: Scalars['String'];
  token: Scalars['String'];
}

export interface MutationActivateEposNowIntegrationArgs {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  startDate: Scalars['Date'];
}

export interface MutationActivateGmailIntegrationArgs {
  code: Scalars['String'];
  redirectUrl: Scalars['String'];
  state: Scalars['String'];
}

export interface MutationActivateOutlookIntegrationArgs {
  code: Scalars['String'];
  redirectUrl: Scalars['String'];
  state: Scalars['String'];
}

export interface MutationActivatePlandayIntegrationArgs {
  authCode: Scalars['String'];
  redirectUrl: Scalars['String'];
  state: Scalars['String'];
}

export interface MutationActivateSeznamIntegrationArgs {
  emailAddress: Scalars['String'];
  password: Scalars['String'];
  syncStartDate: Scalars['Date'];
}

export interface MutationActivateXeroIntegrationArgs {
  authCode: Scalars['String'];
  redirectUrl: Scalars['String'];
}

export interface MutationAddGlobalSupplierContactEmailArgs {
  email: Scalars['String'];
  supplierId: Scalars['ID'];
}

export interface MutationAddRevenueArgs {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  mode?: InputMaybe<RevenueMode>;
  note?: InputMaybe<Scalars['String']>;
  revenueSourceId: Scalars['ID'];
  shouldRememberTaxRate?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<TaxRate>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationAddRevenuesArgs {
  revenues: Array<CreateRevenueInputType>;
}

export interface MutationAddUserToVenueAsAdminArgs {
  accountId: Scalars['ID'];
  adminPassword: Scalars['String'];
  isNewAccount?: InputMaybe<Scalars['Boolean']>;
  venueId: Scalars['ID'];
}

export interface MutationAddVenueToEinvoicingInboxArgs {
  venueId: Scalars['ID'];
}

export interface MutationAddVenueToExistingXeroConnectionArgs {
  selectedXeroIntegrationDataId: Scalars['ID'];
}

export interface MutationAdvanceProductFlowArgs {
  flowId: ProductFlowId;
  step: Scalars['String'];
}

export interface MutationAdvanceVenueSetupFlowArgs {
  step: VenueOnboardingSetupFlowStep;
}

export interface MutationAiInsightContextArgs {
  id: Scalars['ID'];
  languageCode: Scalars['String'];
}

export interface MutationApproveExpenseArgs {
  id: Scalars['ID'];
  shouldSendToXero?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationApproveIssuedInvoiceArgs {
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expenseId: Scalars['ID'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  rememberRevenueSource?: InputMaybe<Scalars['Boolean']>;
  rememberSupplier?: InputMaybe<Scalars['Boolean']>;
  revenueSourceId: Scalars['ID'];
  supplierId?: InputMaybe<Scalars['ID']>;
  taxPointDate?: InputMaybe<Scalars['Date']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface MutationApproveStatementArgs {
  amount: Scalars['Int'];
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  deletedEntryIds: Array<Scalars['ID']>;
  dueDate: Scalars['Date'];
  entries: Array<StatementEntryInput>;
  issueDate: Scalars['Date'];
  statementId: Scalars['ID'];
  statementNumber: Scalars['String'];
  supplierId: Scalars['ID'];
}

export interface MutationArchivePendingAccountArgs {
  id: Scalars['ID'];
}

export interface MutationAskAiInsightQuestionArgs {
  input: AskAiInsightQuestionInput;
}

export interface MutationAssignCashflowToStatementEntriesArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  statementEntryIds: Array<Scalars['ID']>;
}

export interface MutationAssignPeppolInboxArgs {
  input: AssignPeppolInboxInput;
}

export interface MutationAssignRevenueCategoryArgs {
  expenseCategoryId: Scalars['ID'];
  revenueCategoryId?: InputMaybe<Scalars['ID']>;
}

export interface MutationAssignSystemCategoryArgs {
  categoryIds: Array<Scalars['ID']>;
  systemCategory?: InputMaybe<SystemCategoryType>;
}

export interface MutationAssignUnassignedPeppolDocumentArgs {
  input: AssignUnassignedPeppolDocumentInput;
}

export interface MutationBuildCashflowConnectionLinkArgs {
  institutionId: Scalars['String'];
  redirectPathname?: InputMaybe<Scalars['String']>;
  secondConnection?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationBuildDeputyConnectionLinkArgs {
  region: Scalars['String'];
  subdomain: Scalars['String'];
  syncStartDate: Scalars['Date'];
}

export interface MutationBuildGmailConnectionLinkArgs {
  redirectUrl: Scalars['String'];
  syncStartDate: Scalars['Date'];
}

export interface MutationBuildOutlookConnectionLinkArgs {
  redirectUrl: Scalars['String'];
  syncStartDate: Scalars['Date'];
}

export interface MutationBuildPlandayConnectionLinkArgs {
  redirectUrl: Scalars['String'];
  syncStartDate: Scalars['Date'];
}

export interface MutationClearAiInsightsArgs {
  input: ClearAiInsightsInput;
}

export interface MutationCompleteLegacyCategoryMappingArgs {
  mappings: Array<LegacyCategoryMappingInput>;
}

export interface MutationCompleteProductFlowArgs {
  completionManner?: InputMaybe<ProductFlowCompletionManner>;
  flowId: ProductFlowId;
}

export interface MutationConfirmAdminMfaEnrollmentArgs {
  code: Scalars['String'];
}

export interface MutationConfirmPendingAccountArgs {
  doesAccountExist: Scalars['Boolean'];
  pendingAccountId: Scalars['ID'];
}

export interface MutationConfirmSubscriptionUpgradeArgs {
  input: ConfirmSubscriptionUpgradeInput;
}

export interface MutationConnectStoryousIntegrationArgs {
  merchantId: Scalars['String'];
  placeId: Scalars['String'];
  skipIcoValidation?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  venueId: Scalars['ID'];
}

export interface MutationConvertIssuedInvoiceToExpenseArgs {
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId: Scalars['ID'];
  documentType?: InputMaybe<InvoiceType>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  revenueId: Scalars['ID'];
  supplierId?: InputMaybe<Scalars['ID']>;
  taxPointDate?: InputMaybe<Scalars['Date']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface MutationConvertOcrExpenseToOneTimeExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  dueDate: Scalars['Date'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  ocrExpenseId: Scalars['ID'];
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  shouldSendToXero?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationConvertOcrExpenseToOneTimeExpenseNewArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  dueDate: Scalars['Date'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  ocrExpenseId: Scalars['ID'];
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  shouldSendToXero?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationConvertOcrExpenseToSplitExpenseNewArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  dueDate: Scalars['Date'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber: Scalars['String'];
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  ocrExpenseId: Scalars['ID'];
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  shouldSendToXero?: InputMaybe<Scalars['Boolean']>;
  splitExpenses: Array<SplitExpenseInput>;
  supplierId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationConvertOcrExpenseToSupplyExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  dueDate: Scalars['Date'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  ocrExpenseId: Scalars['ID'];
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  shouldSendToXero?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationConvertOcrExpenseToSupplyExpenseNewArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  dueDate: Scalars['Date'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  ocrExpenseId: Scalars['ID'];
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  shouldSendToXero?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationConvertSupplierToEmployeeArgs {
  defaultCategoryId?: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  supplierId: Scalars['ID'];
}

export interface MutationCreateAccountAsAdminArgs {
  adminPassword: Scalars['String'];
  cultureCode?: InputMaybe<CultureCode>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  languageCode?: InputMaybe<CultureCode>;
  lastName: Scalars['String'];
  password: Scalars['String'];
}

export interface MutationCreateAccountWithAccessArgs {
  cultureCode?: InputMaybe<CultureCode>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  languageCode?: InputMaybe<CultureCode>;
  lastName: Scalars['String'];
  sendInviteEmail?: InputMaybe<Scalars['Boolean']>;
  venueAccess: Array<AccessItemInputType>;
}

export interface MutationCreateAccountingCategoryArgs {
  creditAccount?: InputMaybe<Scalars['String']>;
  debitAccount?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mrpCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface MutationCreateAccountingExportArgs {
  accountingSystem: AccountingSystem;
  documentStatus?: InputMaybe<XeroDocumentStatus>;
  expenseIds?: InputMaybe<Array<Scalars['String']>>;
  exportToXero?: InputMaybe<Scalars['Boolean']>;
  invoiceType: InvoiceType;
  moneyS3Rada?: InputMaybe<Scalars['String']>;
  oneTimeExpenseIds: Array<Scalars['String']>;
  splitExpenseIds: Array<Scalars['String']>;
  supplyExpenseIds: Array<Scalars['String']>;
}

export interface MutationCreateCashRegisterEntriesArgs {
  date: Scalars['Date'];
  entries: Array<CashRegisterEntryInput>;
}

export interface MutationCreateCashflowManualAccountArgs {
  connectedRevenueSourceIds?: InputMaybe<Array<Scalars['ID']>>;
  currencyCode: CurrencyCode;
  displayName: Scalars['String'];
  startingBalance: Scalars['Int'];
}

export interface MutationCreateCashflowManualDepositArgs {
  amount: Scalars['Int'];
  cashflowManualAccountId: Scalars['ID'];
  date: Scalars['Date'];
  note?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateCashflowManualTransferArgs {
  amount: Scalars['Int'];
  date: Scalars['Date'];
  fromCashflowManualAccountId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  toCashflowManualAccountId: Scalars['ID'];
}

export interface MutationCreateCashflowManualWithdrawalArgs {
  amount: Scalars['Int'];
  cashflowManualAccountId: Scalars['ID'];
  date: Scalars['Date'];
  expenseIds?: InputMaybe<Array<Scalars['ID']>>;
  isUnlinkedWithdrawal: Scalars['Boolean'];
  note?: InputMaybe<Scalars['String']>;
  oneTimeExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  oneTimeLaborExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  repeatingExpenseIds?: InputMaybe<Array<IdDateInputType>>;
  repeatingLaborExpenseIds?: InputMaybe<Array<IdDateInputType>>;
  splitExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  statementIds?: InputMaybe<Array<Scalars['ID']>>;
  supplyExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  unifiedRecurringExpenseOccurrences?: InputMaybe<Array<IdDateInputType>>;
  unifiedRecurringLaborExpenseOccurrences?: InputMaybe<Array<IdDateInputType>>;
}

export interface MutationCreateCategoryArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  alsoAddAsRevenueCategory?: InputMaybe<Scalars['Boolean']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nominalAcRef?: InputMaybe<Scalars['String']>;
  parentCategoryId?: InputMaybe<Scalars['ID']>;
  reference?: InputMaybe<Scalars['String']>;
  revenueCategoryId?: InputMaybe<Scalars['ID']>;
  systemCategory?: InputMaybe<SystemCategoryType>;
}

export interface MutationCreateCustomCheckoutLinkArgs {
  input: CreateCustomCheckoutInput;
}

export interface MutationCreateCustomerPortalSessionArgs {
  returnUrl: Scalars['String'];
}

export interface MutationCreateDepartmentArgs {
  name: Scalars['String'];
}

export interface MutationCreateEmployeeArgs {
  departmentId?: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateEmployeeSupplierArgs {
  defaultCategoryId?: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateExpenseArgs {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  documentType?: InputMaybe<InvoiceType>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  insuranceAmount?: InputMaybe<Scalars['Int']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issueDate: Scalars['Date'];
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  socialSecurityAmount?: InputMaybe<Scalars['Int']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateGlobalSupplierArgs {
  contactEmail: Scalars['String'];
  emailDomain?: InputMaybe<Scalars['String']>;
  invoicingEmail?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface MutationCreateOneTimeExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId: Scalars['ID'];
  dueDate: Scalars['Date'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationCreateOneTimeLaborExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  amount: Scalars['Int'];
  departmentId?: InputMaybe<Scalars['ID']>;
  dueDate: Scalars['Date'];
  employeeId?: InputMaybe<Scalars['ID']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateOrderItemAlertArgs {
  changeType: Scalars['String'];
  orderItemId: Scalars['ID'];
  recipientUserIds: Array<Scalars['ID']>;
  thresholdPercentage: Scalars['Int'];
}

export interface MutationCreatePaymentMethodArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nominalAcRef?: InputMaybe<Scalars['String']>;
}

export interface MutationCreatePendingAccountArgs {
  country: CountryCode;
  crmLink?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  useAutoCategorization?: InputMaybe<Scalars['Boolean']>;
  venueName: Scalars['String'];
}

export interface MutationCreateRepeatingExpenseArgs {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId: Scalars['ID'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  recurrencePattern: CreateRecurrencePatternInput;
  supplierId?: InputMaybe<Scalars['ID']>;
}

export interface MutationCreateRepeatingLaborExpenseArgs {
  amount: Scalars['Int'];
  departmentId?: InputMaybe<Scalars['ID']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  recurrencePattern: CreateRecurrencePatternInput;
}

export interface MutationCreateRepeatingUnifiedExpenseArgs {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  insuranceAmount?: InputMaybe<Scalars['Int']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  recurrencePattern: CreateRecurrencePatternInput;
  socialSecurityAmount?: InputMaybe<Scalars['Int']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateRevenueCategoryArgs {
  expenseCategoryId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
}

export interface MutationCreateRevenueSourceArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  isCategory?: InputMaybe<Scalars['Boolean']>;
  isPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nominalAcRef?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateSageJourtisExportArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface MutationCreateStatementEntryArgs {
  amount: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  statementId: Scalars['ID'];
}

export interface MutationCreateSupplierArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  cin?: InputMaybe<Scalars['String']>;
  defaultCategoryId?: InputMaybe<Scalars['ID']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  extractLineItems?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nominalAcRef?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
}

export interface MutationCreateSupplierBankAccountArgs {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  format: BankAccountFormat;
  iban?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
}

export interface MutationCreateSupplyExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId: Scalars['ID'];
  dueDate: Scalars['Date'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  supplierId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationCreateVenueArgs {
  cultureCode?: InputMaybe<CultureCode>;
  defaultTimezone?: InputMaybe<Scalars['String']>;
  languageCode?: InputMaybe<CultureCode>;
  name: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface MutationCreateVenueBankAccountArgs {
  bankAccountNumber: Scalars['String'];
  bankCode?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationDeleteAiInsightArgs {
  id: Scalars['ID'];
}

export interface MutationDeleteCashflowLinkedAccountArgs {
  cashflowLinkedAccountId: Scalars['ID'];
}

export interface MutationDeleteCashflowManualAccountArgs {
  cashflowManualAccountId: Scalars['ID'];
}

export interface MutationDeleteCashflowManualTransactionArgs {
  cashflowManualTransactionId: Scalars['ID'];
  updateBalance?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationDeleteOrderItemAlertArgs {
  alertId: Scalars['ID'];
}

export interface MutationDeleteOrderItemEntryArgs {
  entryId: Scalars['ID'];
}

export interface MutationDeleteSupplierBankAccountArgs {
  id: Scalars['ID'];
}

export interface MutationDenyPeppolRegistrationArgs {
  registrationId: Scalars['ID'];
}

export interface MutationDisableAutomatedFollowUpsArgs {
  requestId: Scalars['ID'];
}

export interface MutationDisconnectGmailIntegrationArgs {
  integrationId: Scalars['ID'];
}

export interface MutationDisconnectOutlookIntegrationArgs {
  integrationId: Scalars['ID'];
}

export interface MutationDisconnectSeznamIntegrationArgs {
  integrationId: Scalars['ID'];
}

export interface MutationDismissAppNotificationArgs {
  id: Scalars['ID'];
}

export interface MutationDismissOrderItemAlertNotificationArgs {
  notificationId: Scalars['ID'];
}

export interface MutationDismissProductFlowArgs {
  completionManner?: InputMaybe<ProductFlowCompletionManner>;
  flowId: ProductFlowId;
}

export interface MutationEditPendingAccountArgs {
  country: CountryCode;
  crmLink?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  venueName: Scalars['String'];
}

export interface MutationEnableVenueAutoCategorizationArgs {
  venueId: Scalars['String'];
}

export interface MutationExportAllExpensesAsCsvArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilter: DateFromToInputType;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeLaborExpenses?: InputMaybe<Scalars['Boolean']>;
  includePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  onlyAutoapproved?: InputMaybe<Scalars['Boolean']>;
  onlyUnseenAutoapproved?: InputMaybe<Scalars['Boolean']>;
  onlyWithInvoiceAttached?: InputMaybe<Scalars['Boolean']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  paymentStatuses?: InputMaybe<Array<ExpensePaymentStatus>>;
  sortBy?: InputMaybe<ExpenseSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  systemCategoryTypes?: InputMaybe<Array<SystemCategoryType>>;
}

export interface MutationGenerateAiInsightsArgs {
  input: AiInsightsRangeInput;
}

export interface MutationGetKycVerificationTokenArgs {
  flowpayRepresentativeId: Scalars['ID'];
}

export interface MutationInitializeAutoCategorizationMigrationArgs {
  venueIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface MutationInitiateFlowpayServiceArgs {
  companyId: Scalars['String'];
  companyWebsite?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
}

export interface MutationInitiateRotaConnectionArgs {
  realmId: Scalars['String'];
  syncStartDate: Scalars['Date'];
}

export interface MutationInitiateSupplierIntegrationsArgs {
  selections: Array<SupplierIntegrationSelectionInput>;
  venueId: Scalars['ID'];
}

export interface MutationLinkVenueBillingAccountArgs {
  billingMethod: BillingMethod;
  externalLink: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  venueId: Scalars['String'];
}

export interface MutationLoginArgs {
  email: Scalars['String'];
  password: Scalars['String'];
}

export interface MutationMapPosCategoriesToRevenueCategoryArgs {
  integrationRevenueCategoryIds: Array<Scalars['ID']>;
  revenueCategoryId?: InputMaybe<Scalars['ID']>;
}

export interface MutationMarkAutoapprovedAsUnseenArgs {
  ids: Array<Scalars['String']>;
}

export interface MutationMarkAutoapprovedBatchAsSeenArgs {
  notificationId: Scalars['String'];
}

export interface MutationMarkCashflowLinkedTransactionNotAnExpenseArgs {
  cashflowLinkedTransactionId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkCashflowManualTransactionNotAnExpenseArgs {
  cashflowManualTransactionId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkExpensePaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkLaborExpenseGroupAsPaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  currencyCode: Scalars['String'];
  dateFilter: DateFromToInputType;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  employeeId?: InputMaybe<Scalars['ID']>;
}

export interface MutationMarkLaborExpensesAsPaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  expenseIds: Array<Scalars['ID']>;
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface MutationMarkOneTimeExpensePayedArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkOneTimeLaborExpensePayedArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkOrderItemAlertNotificationAsSeenArgs {
  notificationId: Scalars['ID'];
}

export interface MutationMarkOrderItemNotificationAsSeenArgs {
  notificationId: Scalars['ID'];
}

export interface MutationMarkRepeatingExpensePaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkRepeatingLaborExpensePaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkRepeatingLaborExpensePaidOneByOneArgs {
  date: Scalars['Date'];
  expenseIds: Array<Scalars['ID']>;
}

export interface MutationMarkRevenuePaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  revenueId: Scalars['ID'];
}

export interface MutationMarkSplitExpensePaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkStoryousIntegrationRequestCompletedArgs {
  id: Scalars['ID'];
}

export interface MutationMarkSupplyExpensePayedArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowPairNotificationId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationMarkUnifiedExpensesPaidArgs {
  occurrences: Array<ExpenseOccurrenceInputType>;
}

export interface MutationMergePeppolPdfXmlUploadItemsArgs {
  input: MergePeppolPdfXmlInput;
}

export interface MutationMergeSupplierIntoEmployeeArgs {
  defaultCategoryId?: InputMaybe<Scalars['ID']>;
  employeeSupplierId: Scalars['ID'];
  supplierId: Scalars['ID'];
}

export interface MutationMobileLoginArgs {
  email: Scalars['String'];
  password: Scalars['String'];
}

export interface MutationMobileRefreshTokenArgs {
  refreshToken: Scalars['String'];
}

export interface MutationMobileSwitchVenueArgs {
  targetVenueId: Scalars['ID'];
}

export interface MutationMoveVenueToPaywallArgs {
  force: Scalars['Boolean'];
  venueId: Scalars['String'];
}

export interface MutationOverwriteRevenueArgs {
  amount: Scalars['Int'];
  categoryId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  mode?: InputMaybe<RevenueMode>;
  revenueSourceId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationPairCashflowLinkedTransactionWithExpenseArgs {
  cashflowLinkedTransactionId: Scalars['ID'];
  expenseIds?: InputMaybe<Array<Scalars['ID']>>;
  note?: InputMaybe<Scalars['String']>;
  oneTimeExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  oneTimeLaborExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  repeatingExpenseIds?: InputMaybe<Array<IdDateInputType>>;
  repeatingLaborExpenseIds?: InputMaybe<Array<IdDateInputType>>;
  splitExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  statementIds?: InputMaybe<Array<Scalars['ID']>>;
  supplyExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  unifiedRecurringExpenseOccurrences?: InputMaybe<Array<IdDateInputType>>;
  unifiedRecurringLaborExpenseOccurrences?: InputMaybe<Array<IdDateInputType>>;
}

export interface MutationPairCashflowManualTransactionWithExpenseArgs {
  cashflowManualTransactionId: Scalars['ID'];
  expenseIds?: InputMaybe<Array<Scalars['ID']>>;
  note?: InputMaybe<Scalars['String']>;
  oneTimeExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  oneTimeLaborExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  repeatingExpenseIds?: InputMaybe<Array<IdDateInputType>>;
  repeatingLaborExpenseIds?: InputMaybe<Array<IdDateInputType>>;
  splitExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  statementIds?: InputMaybe<Array<Scalars['ID']>>;
  supplyExpenseIds?: InputMaybe<Array<Scalars['ID']>>;
  unifiedRecurringExpenseOccurrences?: InputMaybe<Array<IdDateInputType>>;
  unifiedRecurringLaborExpenseOccurrences?: InputMaybe<Array<IdDateInputType>>;
}

export interface MutationPairStatementEntryArgs {
  expenseId: Scalars['ID'];
  expenseType: Scalars['String'];
  statementEntryId: Scalars['ID'];
}

export interface MutationProcessSkippedPeppolDocumentsArgs {
  input: ProcessSkippedEinvoicesInput;
}

export interface MutationReachProductFlowCheckpointArgs {
  flowId: ProductFlowId;
  step: Scalars['String'];
}

export interface MutationReassignDocumentVenueArgs {
  expenseId?: InputMaybe<Scalars['ID']>;
  invoiceUploadItemId?: InputMaybe<Scalars['ID']>;
  revenueId?: InputMaybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface MutationRegenerateAiFindingArgs {
  id: Scalars['ID'];
}

export interface MutationRejectExpenseArgs {
  id: Scalars['ID'];
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRejectInvoiceUploadItemArgs {
  id: Scalars['ID'];
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRejectInvoiceUploadItemsArgs {
  ids: Array<Scalars['ID']>;
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRejectStoryousIntegrationRequestArgs {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
}

export interface MutationRemoveAccountingCategoryArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveCategoryArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveDepartmentArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveEinvoiceRoutingRuleArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveEmployeeArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveExpenseArgs {
  id: Scalars['ID'];
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRemoveOneTimeExpenseArgs {
  id: Scalars['ID'];
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRemoveOneTimeLaborExpenseArgs {
  id: Scalars['ID'];
}

export interface MutationRemovePaymentMethodArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveRepeatingExpenseArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveRepeatingLaborExpenseArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveRevenueArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveRevenueSourceArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveSplitExpenseArgs {
  id: Scalars['ID'];
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRemoveStatementArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveStatementEntryArgs {
  statementEntryId: Scalars['ID'];
}

export interface MutationRemoveSupplierArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveSupplierDefaultCategoryArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveSupplyExpenseArgs {
  id: Scalars['ID'];
  keepItemPrices?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationRemoveUserArgs {
  accountId: Scalars['ID'];
  venueId: Scalars['ID'];
}

export interface MutationRequestInvoiceFilesArgs {
  byPurchaseDate?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['Date'];
}

export interface MutationRequestPosIntegrationArgs {
  integrationProvider: IntegrationProvider;
  notes?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Date'];
}

export interface MutationRescheduleRepeatingExpenseArgs {
  id: Scalars['ID'];
  recurrencePattern: UpdateRecurrencePatternInput;
}

export interface MutationRescheduleRepeatingLaborExpenseArgs {
  id: Scalars['ID'];
  recurrencePattern: UpdateRecurrencePatternInput;
}

export interface MutationResetAdminMfaForAccountArgs {
  accountId: Scalars['ID'];
}

export interface MutationResetOwnAdminMfaArgs {
  backupCode: Scalars['String'];
}

export interface MutationResetPasswordArgs {
  password: Scalars['String'];
  token: Scalars['String'];
}

export interface MutationResolvePasswordResetTokenArgs {
  token: Scalars['String'];
}

export interface MutationRestoreAccountingCategoryArgs {
  id: Scalars['ID'];
}

export interface MutationRestoreCategoryArgs {
  id: Scalars['ID'];
}

export interface MutationRestoreDepartmentArgs {
  id: Scalars['ID'];
}

export interface MutationRestoreEmployeeArgs {
  id: Scalars['ID'];
}

export interface MutationRestorePaymentMethodArgs {
  id: Scalars['ID'];
}

export interface MutationRestoreRevenueSourceArgs {
  id: Scalars['ID'];
}

export interface MutationRestoreSupplierArgs {
  id: Scalars['ID'];
}

export interface MutationReuploadInvoiceArgs {
  id: Scalars['ID'];
}

export interface MutationRevertCashflowLinkedTransactionWithdrawalArgs {
  cashflowLinkedTransactionId: Scalars['ID'];
}

export interface MutationSaveDeputyCompaniesArgs {
  laborIntegrationId: Scalars['String'];
  selectedCompanyIds: Array<Scalars['String']>;
}

export interface MutationSaveEinvoiceRoutingRuleArgs {
  input: SaveEinvoiceRoutingRuleInput;
}

export interface MutationSaveEinvoicingSettingsArgs {
  input: SaveEinvoicingSettingsInput;
}

export interface MutationSavePlandayDepartmentsArgs {
  laborIntegrationId: Scalars['String'];
  selectedDepartmentIds: Array<Scalars['String']>;
}

export interface MutationSaveRotaSitesArgs {
  laborIntegrationId: Scalars['String'];
  selectedSiteIds: Array<Scalars['String']>;
}

export interface MutationSendResetPasswordEmailArgs {
  email: Scalars['String'];
}

export interface MutationSendToXeroArgs {
  documentStatus?: InputMaybe<XeroDocumentStatus>;
  expenseIds?: InputMaybe<Array<Scalars['String']>>;
  invoiceType: InvoiceType;
  oneTimeExpenseIds: Array<Scalars['String']>;
  splitExpenseIds: Array<Scalars['String']>;
  supplyExpenseIds: Array<Scalars['String']>;
}

export interface MutationSetAlwaysRequireManualInvoiceApprovalArgs {
  alwaysRequireManualInvoiceApproval: Scalars['Boolean'];
}

export interface MutationSetCashflowEnabledArgs {
  cashflowEnabled?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationSetDefaultCategoriesArgs {
  defaultCategories: Array<SetDefaultCategoryInputType>;
}

export interface MutationSetDefaultCategoryArgs {
  accountingCategoryId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  expenseAgendaId?: InputMaybe<Scalars['ID']>;
  expenseType?: InputMaybe<SystemCategoryType>;
  isAutoConfirmationEnabled?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
  trackingCategoryId?: InputMaybe<Scalars['String']>;
  trackingOptionId?: InputMaybe<Scalars['String']>;
}

export interface MutationSetDefaultDepartmentArgs {
  departmentId?: InputMaybe<Scalars['ID']>;
  employeeId: Scalars['ID'];
}

export interface MutationSetFlowpayMerchantCashflowAccountsArgs {
  addedLinkedAccountIds: Array<Scalars['ID']>;
  removedLinkedAccountIds: Array<Scalars['ID']>;
}

export interface MutationSetInvoiceApprovalModeArgs {
  invoiceApprovalMode: InvoiceApprovalMode;
}

export interface MutationSetIssuedInvoiceAdditionalSuppliersArgs {
  supplierIds: Array<Scalars['ID']>;
}

export interface MutationSetManualApprovalRulesArgs {
  rules: Array<ManualApprovalRuleInput>;
}

export interface MutationSetNoVatModeArgs {
  noVatMode?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationSetReportingModeArgs {
  reportingMode: ReportingMode;
}

export interface MutationSetVatCustomPeriodArgs {
  end: Scalars['Date'];
  start: Scalars['Date'];
}

export interface MutationSetWarehouseInventoryValueArgs {
  copyMonthEndToNextMonthStart?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['Date'];
  monthEndValue?: InputMaybe<Scalars['Int']>;
  monthStartValue?: InputMaybe<Scalars['Int']>;
}

export interface MutationSetupInvoiceBillingArgs {
  input: SetupInvoiceBillingInput;
}

export interface MutationSignUpArgs {
  account: CreateAccountInputType;
  businessEntity: CreateBusinessEntityArgs;
  legalEntity: CreateLegalEntityArgs;
  secret: Scalars['String'];
}

export interface MutationSkipExpenseOccurrenceArgs {
  date: Scalars['Date'];
  id: Scalars['ID'];
}

export interface MutationSkipProductFlowStepArgs {
  flowId: ProductFlowId;
  step: Scalars['String'];
}

export interface MutationSkipRepeatingExpenseArgs {
  date: Scalars['Date'];
  id: Scalars['ID'];
}

export interface MutationSkipRepeatingLaborExpenseArgs {
  date: Scalars['Date'];
  id: Scalars['ID'];
}

export interface MutationSkipVenueSetupFlowStepArgs {
  step: VenueOnboardingSetupFlowSkippableStep;
}

export interface MutationSoftDeleteInvoiceUploadItemArgs {
  id: Scalars['ID'];
}

export interface MutationSoftDeleteInvoiceUploadItemsArgs {
  ids: Array<Scalars['ID']>;
}

export interface MutationSplitExpenseArgs {
  id: Scalars['ID'];
  splitFields: Array<SplitFieldInput>;
}

export interface MutationStartRequisitionSetupArgs {
  requisitionId: Scalars['ID'];
}

export interface MutationSubmitAiInsightFeedbackArgs {
  input: SubmitAiInsightFeedbackInput;
}

export interface MutationSubmitEinvoicingMigrationCodeArgs {
  input: SubmitEinvoicingMigrationCodeInput;
}

export interface MutationSubmitLoanDetailsArgs {
  amount: Scalars['Int'];
  cashflowLinkedAccountId: Scalars['ID'];
  currencyCode: CurrencyCode;
  externalOfferId: Scalars['String'];
  postponedMonths: Scalars['Int'];
  product: FlowpayProductType;
  ratePerc: Scalars['Float'];
}

export interface MutationSwitchVenueArgs {
  targetVenueId: Scalars['ID'];
}

export interface MutationSyncFakturoidCompanyDetailsArgs {
  venueIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface MutationTempSendToDishboardOcrArgs {
  invoiceUploadItemId: Scalars['ID'];
  matchingSystemPrompt: Scalars['String'];
  orderItems: Scalars['String'];
  systemPrompt: Scalars['String'];
  useGmodel?: InputMaybe<Scalars['Boolean']>;
  webhookUrl: Scalars['String'];
}

export interface MutationTerminateExpenseArgs {
  id: Scalars['ID'];
  terminationDate: Scalars['Date'];
}

export interface MutationTerminateRepeatingExpenseArgs {
  id: Scalars['ID'];
  terminationDate: Scalars['Date'];
}

export interface MutationTerminateRepeatingLaborExpenseArgs {
  id: Scalars['ID'];
  terminationDate: Scalars['Date'];
}

export interface MutationTogglePinOrderItemArgs {
  orderItemId: Scalars['ID'];
}

export interface MutationTrackAnalyticsArgs {
  name: AnalyticsEvent;
  propertiesJson?: InputMaybe<Scalars['String']>;
}

export interface MutationUnarchivePendingAccountArgs {
  id: Scalars['ID'];
}

export interface MutationUnassignPeppolInboxArgs {
  peppolParticipantId: Scalars['String'];
}

export interface MutationUnassignPeppolVenueArgs {
  venueId: Scalars['ID'];
}

export interface MutationUnhideCategoryArgs {
  id: Scalars['ID'];
}

export interface MutationUnmarkExpensePaidArgs {
  date?: InputMaybe<Scalars['Date']>;
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkLaborExpenseGroupAsPaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  currencyCode: Scalars['String'];
  dateFilter: DateFromToInputType;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  employeeId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUnmarkLaborExpensesAsPaidArgs {
  cashflowLinkedTransactionId?: InputMaybe<Scalars['ID']>;
  cashflowManualTransactionId?: InputMaybe<Scalars['ID']>;
  expenseIds: Array<Scalars['ID']>;
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface MutationUnmarkOneTimeExpensePayedArgs {
  date?: InputMaybe<Scalars['Date']>;
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkOneTimeLaborExpensePayedArgs {
  date?: InputMaybe<Scalars['Date']>;
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkRepeatingExpensePaidArgs {
  date: Scalars['Date'];
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkRepeatingLaborExpensePaidArgs {
  date: Scalars['Date'];
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkRepeatingLaborExpensePaidOneByOneArgs {
  date: Scalars['Date'];
  expenseIds: Array<Scalars['ID']>;
}

export interface MutationUnmarkRevenuePaidArgs {
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  revenueId: Scalars['ID'];
}

export interface MutationUnmarkSplitExpensePaidArgs {
  date?: InputMaybe<Scalars['Date']>;
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkSupplyExpensePayedArgs {
  date?: InputMaybe<Scalars['Date']>;
  deletePairedTransaction?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUnmarkUnifiedExpensesPaidArgs {
  occurrences: Array<ExpenseOccurrenceInputType>;
}

export interface MutationUnpairCashflowLinkedTransactionFromExpenseArgs {
  cashflowLinkedTransactionId: Scalars['ID'];
}

export interface MutationUnpairCashflowManualTransactionFromExpenseArgs {
  cashflowManualTransactionId: Scalars['ID'];
}

export interface MutationUnpairStatementEntryArgs {
  statementEntryId: Scalars['ID'];
}

export interface MutationUnsplitExpenseArgs {
  categoryId: Scalars['ID'];
  id: Scalars['ID'];
}

export interface MutationUpdateAccountingCategoryArgs {
  creditAccount?: InputMaybe<Scalars['String']>;
  debitAccount?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mrpCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateCashRegisterEntriesArgs {
  date: Scalars['Date'];
  entries: Array<CashRegisterEntryInput>;
}

export interface MutationUpdateCashflowAccountRoleArgs {
  accountId: Scalars['ID'];
  linkedAccountId?: InputMaybe<Scalars['ID']>;
  manualAccountId?: InputMaybe<Scalars['ID']>;
  role?: InputMaybe<CashflowAccessRole>;
}

export interface MutationUpdateCashflowLinkedAccountArgs {
  addedVenueIds?: InputMaybe<Array<Scalars['ID']>>;
  cashflowLinkedAccountId: Scalars['ID'];
  displayName?: InputMaybe<Scalars['String']>;
  removedVenueIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface MutationUpdateCashflowLinkedTransactionArgs {
  cashflowLinkedTransactionId: Scalars['ID'];
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateCashflowManualAccountArgs {
  addedVenueIds?: InputMaybe<Array<Scalars['ID']>>;
  cashflowManualAccountId: Scalars['ID'];
  connectedRevenueSourceIds?: InputMaybe<Array<Scalars['ID']>>;
  displayName?: InputMaybe<Scalars['String']>;
  removedVenueIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface MutationUpdateCashflowManualTransactionArgs {
  amount?: InputMaybe<Scalars['Int']>;
  cashflowManualTransactionId: Scalars['ID'];
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  updateBalance?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationUpdateCategoryArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  alsoAddAsRevenueCategory?: InputMaybe<Scalars['Boolean']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nominalAcRef?: InputMaybe<Scalars['String']>;
  parentCategoryId?: InputMaybe<Scalars['ID']>;
  reference?: InputMaybe<Scalars['String']>;
  revenueCategoryId?: InputMaybe<Scalars['ID']>;
  systemCategory?: InputMaybe<SystemCategoryType>;
}

export interface MutationUpdateCostRadarSubscriptionArgs {
  state: CostRadarSubscriptionState;
  trialExpiresAt?: InputMaybe<Scalars['Float']>;
  venueId: Scalars['String'];
}

export interface MutationUpdateCurrentAccountArgs {
  cultureCode?: InputMaybe<CultureCode>;
  defaultUserId?: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  languageCode?: InputMaybe<CultureCode>;
  lastName: Scalars['String'];
  noVatAvailable?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateCurrentLegalEntityArgs {
  companyIdentificationNumber: Scalars['String'];
  legalName: Scalars['String'];
  taxIdentificationNumber: Scalars['String'];
}

export interface MutationUpdateDepartmentArgs {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateEmployeeArgs {
  departmentId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateEmployeeSupplierArgs {
  defaultCategoryId?: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateExpenseArgs {
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  documentType?: InputMaybe<InvoiceType>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  insuranceAmount?: InputMaybe<Scalars['Int']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  socialSecurityAmount?: InputMaybe<Scalars['Int']>;
  splitFields?: InputMaybe<Array<SplitFieldInput>>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateExpenseSplitFieldsArgs {
  id: Scalars['ID'];
  splitFields: Array<SplitFieldInput>;
}

export interface MutationUpdateFlowpayRepresentativeArgs {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPoliticallyExposed?: InputMaybe<Scalars['Boolean']>;
  isSelectedForSigning?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateGlobalSupplierArgs {
  emailDomain?: InputMaybe<Scalars['String']>;
  exceptionFlag?: InputMaybe<Scalars['Boolean']>;
  exceptionReason?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invoicingEmail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateInvoiceUploadItemAgendaArgs {
  agendaId: Scalars['ID'];
  invoiceUploadItemId?: InputMaybe<Scalars['ID']>;
  oneTimeExpenseId?: InputMaybe<Scalars['ID']>;
  splitExpenseId?: InputMaybe<Scalars['ID']>;
  supplyExpenseId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateIssuedInvoiceArgs {
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  rememberRevenueSource?: InputMaybe<Scalars['Boolean']>;
  revenueSourceId?: InputMaybe<Scalars['ID']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  taxPointDate?: InputMaybe<Scalars['Date']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateLoanPurposeArgs {
  loanPurpose: Scalars['String'];
}

export interface MutationUpdateNotificationPreferencesArgs {
  dailyPerformanceEnabled?: InputMaybe<Scalars['Boolean']>;
  dailyPerformanceHour?: InputMaybe<Scalars['Int']>;
  dailyPerformanceMinute?: InputMaybe<Scalars['Int']>;
  invoicesDueTodayEnabled?: InputMaybe<Scalars['Boolean']>;
  invoicesDueTodayHour?: InputMaybe<Scalars['Int']>;
  invoicesDueTodayMinute?: InputMaybe<Scalars['Int']>;
}

export interface MutationUpdateOneTimeExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expenseType?: InputMaybe<SplitExpenseType>;
  id: Scalars['ID'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateOneTimeExpenseNewArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expenseType?: InputMaybe<SplitExpenseType>;
  id: Scalars['ID'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateOneTimeLaborExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  amount?: InputMaybe<Scalars['Int']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateOrderItemAlertArgs {
  alertId: Scalars['ID'];
  changeType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  recipientUserIds?: InputMaybe<Array<Scalars['ID']>>;
  thresholdPercentage?: InputMaybe<Scalars['Int']>;
}

export interface MutationUpdateOrderItemEntryArgs {
  entryId: Scalars['ID'];
  issueDate: Scalars['Date'];
  pricePerItemWithoutVat: Scalars['Int'];
  quantity?: InputMaybe<Scalars['Float']>;
  totalPriceWithVat?: InputMaybe<Scalars['Int']>;
  totalPriceWithoutVat?: InputMaybe<Scalars['Int']>;
}

export interface MutationUpdateOrderItemEntryStatusArgs {
  entryId: Scalars['ID'];
  status: OrderItemEntryStatus;
}

export interface MutationUpdatePaymentMethodArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nominalAcRef?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateRepeatingExpenseArgs {
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  onlyCurrentMonth: Scalars['Boolean'];
  recurrencePattern?: InputMaybe<CreateRecurrencePatternInput>;
  supplierId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateRepeatingLaborExpenseArgs {
  amount?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  departmentId?: InputMaybe<Scalars['ID']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  onlyCurrentMonth: Scalars['Boolean'];
  recurrencePattern?: InputMaybe<CreateRecurrencePatternInput>;
}

export interface MutationUpdateRevenueArgs {
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  revenueSourceId?: InputMaybe<Scalars['ID']>;
  shouldRememberTaxRate?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<TaxRate>;
}

export interface MutationUpdateRevenueSourceArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isCategory?: InputMaybe<Scalars['Boolean']>;
  isPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nominalAcRef?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateSplitExpenseNewArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  dueDate: Scalars['Date'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber: Scalars['String'];
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  splitExpenseId: Scalars['ID'];
  splitExpenses: Array<UpdateSplitExpenseInput>;
  supplierId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateSupplierArgs {
  accountReference?: InputMaybe<Scalars['String']>;
  cin?: InputMaybe<Scalars['String']>;
  clearEmployeeData?: InputMaybe<Scalars['Boolean']>;
  defaultCategoryId?: InputMaybe<Scalars['ID']>;
  departmentCode?: InputMaybe<Scalars['String']>;
  extractLineItems?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nominalAcRef?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateSupplierBankAccountArgs {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  format: BankAccountFormat;
  iban?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationUpdateSupplyExpenseArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expenseType?: InputMaybe<SplitExpenseType>;
  id: Scalars['ID'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateSupplyExpenseNewArgs {
  accountingDate?: InputMaybe<Scalars['Date']>;
  accountingInfo?: InputMaybe<CreateExpenseAccountingInfoInputType>;
  amount?: InputMaybe<Scalars['Int']>;
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  bankInfo?: InputMaybe<CreateExpenseBankInfoInputType>;
  categoryId?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expenseType?: InputMaybe<SplitExpenseType>;
  id: Scalars['ID'];
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAlreadyPaid?: InputMaybe<Scalars['Boolean']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  link?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  removeExistingPayment?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  timezone?: InputMaybe<Scalars['String']>;
  trackingCategoryId?: InputMaybe<Scalars['ID']>;
  trackingOptionId?: InputMaybe<Scalars['ID']>;
}

export interface MutationUpdateUserRoleArgs {
  accountId: Scalars['ID'];
  role: UserRole;
  venueId: Scalars['ID'];
}

export interface MutationUpdateVenueAdminArgs {
  input: UpdateVenueAdminInput;
  venueId: Scalars['String'];
}

export interface MutationUpdateVenueBankAccountArgs {
  bankAccountNumber: Scalars['String'];
  bankCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
}

export interface MutationUpdateVenueForwardingEmailsArgs {
  forwardingEmails?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateVenueGracePeriodArgs {
  gracePeriodDays?: InputMaybe<Scalars['Int']>;
  venueId: Scalars['String'];
}

export interface MutationUpdateVenueInvoiceLimitArgs {
  costRadarLimit?: InputMaybe<Scalars['Int']>;
  force?: InputMaybe<Scalars['Boolean']>;
  fromNextCycle?: InputMaybe<Scalars['Boolean']>;
  invoiceLimit?: InputMaybe<Scalars['Int']>;
  oneTime?: InputMaybe<Scalars['Boolean']>;
  planType?: InputMaybe<SubscriptionPlanType>;
  venueId: Scalars['String'];
}

export interface MutationUpdateVenueNotificationEmailsArgs {
  notificationEmails?: InputMaybe<Scalars['String']>;
}

export interface MutationUpdateVenueRenewalDayArgs {
  force?: InputMaybe<Scalars['Boolean']>;
  fromNextCycle?: InputMaybe<Scalars['Boolean']>;
  renewalDay: Scalars['Int'];
  venueId: Scalars['String'];
}

export interface MutationUpdateXeroIntegrationSettingsArgs {
  defaultDocumentStatus: XeroDocumentStatus;
}

export interface MutationUploadInvoiceArgs {
  files: Array<Scalars['Upload']>;
  uploadSource?: InputMaybe<ManualInvoiceUploadSource>;
}

export interface MutationUploadMatchedSuppliersArgs {
  base64String: Scalars['String'];
}

export interface MutationUpsertPaymentDetailsArgs {
  billingDetails?: InputMaybe<BaseSubscriptionPaymentDetailsInput>;
  businessDetails?: InputMaybe<BaseSubscriptionPaymentDetailsInput>;
}

export interface MutationValidatePasswordResetTokenArgs {
  token: Scalars['String'];
}

export interface MutationVerifyAdminMfaArgs {
  code: Scalars['String'];
}

export interface MutationVerifyAdminMfaBackupCodeArgs {
  code: Scalars['String'];
}

export interface NotificationInvoiceGroup {
  __typename?: 'NotificationInvoiceGroup';
  invoiceUploadItem: InvoiceUploadItem;
  orderItemEntries: Array<OrderItemEntry>;
}

export interface NotificationPreference {
  __typename?: 'NotificationPreference';
  accountId: Scalars['ID'];
  createdAt: Scalars['Date'];
  dailyPerformanceEnabled: Scalars['Boolean'];
  dailyPerformanceHour: Scalars['Int'];
  dailyPerformanceMinute: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoicesDueTodayEnabled: Scalars['Boolean'];
  invoicesDueTodayHour: Scalars['Int'];
  invoicesDueTodayMinute: Scalars['Int'];
}

export interface OcrDocumentNumberField {
  __typename?: 'OcrDocumentNumberField';
  value: Scalars['Float'];
}

export interface OcrExpense {
  __typename?: 'OcrExpense';
  accountingDate?: Maybe<Scalars['Date']>;
  accountingInfo?: Maybe<ExpenseAccountingInfo>;
  accountingInfoId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  bankInfo?: Maybe<ExpenseBankInfo>;
  bankInfoId?: Maybe<Scalars['ID']>;
  bulkPaymentExportedAt?: Maybe<Scalars['Date']>;
  cashflowLinkedTransaction?: Maybe<CashflowLinkedTransaction>;
  cashflowLinkedTransactionId?: Maybe<Scalars['ID']>;
  cashflowManualTransaction?: Maybe<CashflowManualTransaction>;
  cashflowManualTransactionId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  dueDate: Scalars['Date'];
  exchangeRate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceUploadItem: InvoiceUploadItem;
  invoiceUploadItemId: Scalars['ID'];
  isAlreadyPaid?: Maybe<Scalars['Boolean']>;
  isBankInfoVerified?: Maybe<Scalars['Boolean']>;
  /** Identifies a date when this expense will be reflected in accounting */
  issueDate: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
  oneTimeExpense?: Maybe<OneTimeExpense>;
  oneTimeExpenseId?: Maybe<Scalars['ID']>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  splitExpense?: Maybe<SplitExpense>;
  statementEntries?: Maybe<Array<StatementEntry>>;
  supplier: Supplier;
  supplierId: Scalars['ID'];
  supplyExpense?: Maybe<SupplyExpense>;
  supplyExpenseId?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface OnboardingChecklistGroup {
  __typename?: 'OnboardingChecklistGroup';
  steps: Array<OnboardingChecklistStep>;
  title: Scalars['String'];
}

export interface OnboardingChecklistStep {
  __typename?: 'OnboardingChecklistStep';
  currentAmount: Scalars['Int'];
  link: Scalars['String'];
  requiredAmount: Scalars['Int'];
  title: Scalars['String'];
}

export interface OneTimeExpense {
  __typename?: 'OneTimeExpense';
  accountingDate?: Maybe<Scalars['Date']>;
  accountingInfo?: Maybe<ExpenseAccountingInfo>;
  accountingInfoId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  bankInfo?: Maybe<ExpenseBankInfo>;
  bankInfoId?: Maybe<Scalars['ID']>;
  category: Category;
  categoryId: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  dueDate: Scalars['Date'];
  exchangeRate?: Maybe<Scalars['Float']>;
  hasQrCode?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalDocumentNumber?: Maybe<Scalars['String']>;
  /** Identifies a date when this expense will be reflected in accounting */
  issueDate: Scalars['Date'];
  legacyCategoryId?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  ocrExpense?: Maybe<OcrExpense>;
  ocrExpenseId?: Maybe<Scalars['ID']>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  splitExpense?: Maybe<SplitExpense>;
  splitExpenseId?: Maybe<Scalars['ID']>;
  statementEntries?: Maybe<Array<StatementEntry>>;
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']>;
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
  xeroTrackingLink?: Maybe<ExpenseXeroTrackingLink>;
  xeroTrackingLinkId?: Maybe<Scalars['ID']>;
}

export interface OneTimeLaborExpense {
  __typename?: 'OneTimeLaborExpense';
  accountingDate?: Maybe<Scalars['Date']>;
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']>;
  dueDate: Scalars['Date'];
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insuranceAmount?: Maybe<Scalars['Int']>;
  /** Identifies a date when this expense will be reflected in accounting */
  issueDate: Scalars['Date'];
  legacyCategoryId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  socialSecurityAmount?: Maybe<Scalars['Int']>;
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface OrderItem {
  __typename?: 'OrderItem';
  category?: Maybe<OrderItemCategory>;
  createdAt: Scalars['Date'];
  currentPriceWithoutVat: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  lastPriceWithoutVat: Scalars['Int'];
  name: Scalars['String'];
  pinDate?: Maybe<Scalars['Date']>;
  supplier?: Maybe<Supplier>;
  supplierId: Scalars['ID'];
  totalPriceWithVat?: Maybe<Scalars['Int']>;
  totalPriceWithoutVat?: Maybe<Scalars['Int']>;
  venueId: Scalars['ID'];
}

export interface OrderItemAlert {
  __typename?: 'OrderItemAlert';
  changeType: Scalars['String'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  lastTriggeredAt?: Maybe<Scalars['Date']>;
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['ID'];
  recipientUserIds: Array<Scalars['ID']>;
  recipients: Array<User>;
  thresholdPercentage: Scalars['Int'];
  venueId: Scalars['ID'];
}

export interface OrderItemAlertNotification {
  __typename?: 'OrderItemAlertNotification';
  alertTrigger?: Maybe<OrderItemAlertTrigger>;
  alertTriggerId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  dismissedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  seenAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
  userId: Scalars['ID'];
  venueId: Scalars['ID'];
}

export interface OrderItemAlertTrigger {
  __typename?: 'OrderItemAlertTrigger';
  alert?: Maybe<OrderItemAlert>;
  alertId: Scalars['ID'];
  changePercentage: Scalars['Int'];
  createdAt: Scalars['Date'];
  currentPrice: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  notificationsSent: Scalars['Boolean'];
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['ID'];
  previousPrice: Scalars['Int'];
  triggeredAt: Scalars['Date'];
  venueId: Scalars['ID'];
}

export enum OrderItemCategory {
  Bar = 'Bar',
  Disposables = 'Disposables',
  Equipment = 'Equipment',
  Food = 'Food',
  Other = 'Other',
  Services = 'Services',
}

export interface OrderItemEntry {
  __typename?: 'OrderItemEntry';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceUploadItem: InvoiceUploadItem;
  invoiceUploadItemId: Scalars['ID'];
  issueDate: Scalars['Date'];
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderItemId?: Maybe<Scalars['ID']>;
  orderItemsExtractedNotificationId?: Maybe<Scalars['ID']>;
  pricePerItemWithoutVat?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['String']>;
  quantityInPackage?: Maybe<Scalars['String']>;
  status: OrderItemEntryStatus;
  totalPriceWithVat?: Maybe<Scalars['Int']>;
  totalPriceWithoutVat?: Maybe<Scalars['Int']>;
  totalVat?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['String']>;
  vatRate?: Maybe<Scalars['String']>;
  venueId: Scalars['ID'];
}

export enum OrderItemEntryStatus {
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED',
}

export interface OrderItemTimeSeries {
  __typename?: 'OrderItemTimeSeries';
  issueDate: Scalars['Date'];
  price: Scalars['Int'];
}

export interface OrderItemsExtractedNotification {
  __typename?: 'OrderItemsExtractedNotification';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceCount: Scalars['Int'];
  invoiceGroups: Array<NotificationInvoiceGroup>;
  orderItemEntries: Array<OrderItemEntry>;
  orderItemEntriesCount: Scalars['Int'];
  seenAt?: Maybe<Scalars['Date']>;
  venueId: Scalars['ID'];
}

export enum OrderItemsSortKey {
  Category = 'Category',
  CurrentPrice = 'CurrentPrice',
  LastPrice = 'LastPrice',
  LostSaved = 'LostSaved',
  Name = 'Name',
  PriceChange = 'PriceChange',
  Supplier = 'Supplier',
  TotalPriceWithVat = 'TotalPriceWithVat',
  TotalPriceWithoutVat = 'TotalPriceWithoutVat',
}

export interface OutlookIntegrationStatusObjectType {
  __typename?: 'OutlookIntegrationStatusObjectType';
  emailAddress?: Maybe<Scalars['String']>;
  historicalSyncLimitHit?: Maybe<Scalars['Boolean']>;
  historicalSyncOldestProcessedAt?: Maybe<Scalars['Date']>;
  integrationId?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConnected: Scalars['Boolean'];
  lastSyncAt?: Maybe<Scalars['Date']>;
  syncStartDate?: Maybe<Scalars['Date']>;
}

export interface PaginatedCategoryObjectType {
  __typename?: 'PaginatedCategoryObjectType';
  count: Scalars['Int'];
  items: Array<Category>;
}

export interface PaginatedDepartmentObjectType {
  __typename?: 'PaginatedDepartmentObjectType';
  count: Scalars['Int'];
  items: Array<Department>;
}

export interface PaginatedEmployeeObjectType {
  __typename?: 'PaginatedEmployeeObjectType';
  count: Scalars['Int'];
  items: Array<Employee>;
}

export interface PaginatedInvoiceUploadItemObjectType {
  __typename?: 'PaginatedInvoiceUploadItemObjectType';
  count: Scalars['Int'];
  items: Array<InvoiceUploadItem>;
  /** Documents in the tab and period before search and filters */
  unfilteredCount: Scalars['Int'];
}

export interface PaginatedOneTimeExpenseObjectType {
  __typename?: 'PaginatedOneTimeExpenseObjectType';
  count: Scalars['Int'];
  items: Array<OneTimeExpense>;
}

export interface PaginatedOneTimeLaborExpenseObjectType {
  __typename?: 'PaginatedOneTimeLaborExpenseObjectType';
  count: Scalars['Int'];
  items: Array<OneTimeLaborExpense>;
}

export interface PaginatedOrderItemObjectType {
  __typename?: 'PaginatedOrderItemObjectType';
  count: Scalars['Int'];
  items: Array<FormattedOrderItem>;
}

export interface PaginatedPaymentMethodObjectType {
  __typename?: 'PaginatedPaymentMethodObjectType';
  count: Scalars['Int'];
  items: Array<PaymentMethod>;
}

export interface PaginatedPaymentObjectType {
  __typename?: 'PaginatedPaymentObjectType';
  count: Scalars['Int'];
  items: Array<Payment>;
}

export interface PaginatedRepeatingExpenseObjectType {
  __typename?: 'PaginatedRepeatingExpenseObjectType';
  count: Scalars['Int'];
  items: Array<RepeatingExpense>;
}

export interface PaginatedRepeatingLaborExpenseObjectType {
  __typename?: 'PaginatedRepeatingLaborExpenseObjectType';
  count: Scalars['Int'];
  items: Array<RepeatingLaborExpense>;
}

export interface PaginatedRevenueCategoryObjectType {
  __typename?: 'PaginatedRevenueCategoryObjectType';
  count: Scalars['Int'];
  items: Array<RevenueCategory>;
}

export interface PaginatedRevenueObjectType {
  __typename?: 'PaginatedRevenueObjectType';
  count: Scalars['Int'];
  items: Array<Revenue>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountWithoutVat?: Maybe<Scalars['Float']>;
}

export interface PaginatedRevenueSourceObjectType {
  __typename?: 'PaginatedRevenueSourceObjectType';
  count: Scalars['Int'];
  items: Array<RevenueSource>;
}

export interface PaginatedSupplierObjectType {
  __typename?: 'PaginatedSupplierObjectType';
  count: Scalars['Int'];
  items: Array<Supplier>;
}

export interface PaginatedSupplyExpenseObjectType {
  __typename?: 'PaginatedSupplyExpenseObjectType';
  count: Scalars['Int'];
  items: Array<SupplyExpense>;
}

export interface PartialEmail {
  __typename?: 'PartialEmail';
  receivedAt: Scalars['Date'];
  receivedFrom: Scalars['String'];
}

export interface PartialGmailSync {
  __typename?: 'PartialGmailSync';
  integrationInboxEmail: Scalars['String'];
  receivedAt: Scalars['Date'];
}

export interface PartialManual {
  __typename?: 'PartialManual';
  createdBy: CreatedOrUpdatedByObjectType;
}

export interface PartialOutlookSync {
  __typename?: 'PartialOutlookSync';
  integrationInboxEmail: Scalars['String'];
  receivedAt: Scalars['Date'];
}

export interface PartialSeznamSync {
  __typename?: 'PartialSeznamSync';
  integrationInboxEmail: Scalars['String'];
  receivedAt: Scalars['Date'];
}

export enum PasswordResetTokenStatus {
  ExpiredLinkSent = 'EXPIRED_LINK_SENT',
  Invalid = 'INVALID',
  Valid = 'VALID',
}

export interface PasswordResetTokenValidationResultObjectType {
  __typename?: 'PasswordResetTokenValidationResultObjectType';
  status: PasswordResetTokenStatus;
}

export interface Payment {
  __typename?: 'Payment';
  amount: Scalars['Int'];
  cashflowLinkedTransaction?: Maybe<CashflowLinkedTransaction>;
  cashflowLinkedTransactionId?: Maybe<Scalars['ID']>;
  cashflowManualTransaction?: Maybe<CashflowManualTransaction>;
  cashflowManualTransactionId?: Maybe<Scalars['ID']>;
  cashflowPairNotificationId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  expensePayments?: Maybe<Array<ExpensePaymentJoinTable>>;
  id: Scalars['ID'];
  oneTimeExpense?: Maybe<OneTimeExpense>;
  oneTimeExpenseId: Scalars['ID'];
  oneTimeLaborExpense?: Maybe<OneTimeLaborExpense>;
  oneTimeLaborExpenseId: Scalars['ID'];
  payedAt: Scalars['Date'];
  paymentDueDate: Scalars['Date'];
  repeatingExpense?: Maybe<RepeatingExpense>;
  repeatingExpenseId: Scalars['ID'];
  repeatingLaborExpense?: Maybe<RepeatingLaborExpense>;
  repeatingLaborExpenseId: Scalars['ID'];
  supplyExpense?: Maybe<SupplyExpense>;
  supplyExpenseId: Scalars['ID'];
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface PaymentDetails {
  __typename?: 'PaymentDetails';
  billingDetails: BasePaymentDetails;
  businessDetails: BasePaymentDetails;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface PaymentFailureStatusObjectType {
  __typename?: 'PaymentFailureStatusObjectType';
  daysRemaining?: Maybe<Scalars['Int']>;
  hasPaymentFailure: Scalars['Boolean'];
  isLockedOut: Scalars['Boolean'];
  paymentType?: Maybe<Scalars['String']>;
}

export interface PaymentMethod {
  __typename?: 'PaymentMethod';
  accountReference?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  departmentCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nominalAcRef?: Maybe<Scalars['String']>;
  updatedById?: Maybe<Scalars['ID']>;
}

export interface PeppolEinvoiceArchiveRow {
  __typename?: 'PeppolEinvoiceArchiveRow';
  canAddToDocuments: Scalars['Boolean'];
  currencyCode?: Maybe<Scalars['String']>;
  fsReportOutcome?: Maybe<PeppolFsReportOutcome>;
  fsReportWillResend?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceUploadItemId?: Maybe<Scalars['ID']>;
  issueDate?: Maybe<Scalars['Date']>;
  parseFailed: Scalars['Boolean'];
  receivedAt: Scalars['Date'];
  supplierName?: Maybe<Scalars['String']>;
  totalMinor?: Maybe<Scalars['Int']>;
  xmlContent?: Maybe<Scalars['String']>;
}

export enum PeppolFsReportOutcome {
  Accepted = 'Accepted',
  AcceptedWithReservations = 'AcceptedWithReservations',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export enum PeppolRegistrationMatchResult {
  Match = 'Match',
  None = 'None',
  Partial = 'Partial',
}

export interface PeppolRegistrationQueueItem {
  __typename?: 'PeppolRegistrationQueueItem';
  dic?: Maybe<Scalars['String']>;
  ico?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legalName?: Maybe<Scalars['String']>;
  matchResult: PeppolRegistrationMatchResult;
  peppolParticipantId?: Maybe<Scalars['String']>;
  receivedAt: Scalars['Date'];
}

export enum PeppolRegistrationStatus {
  Activated = 'Activated',
  Conflict = 'Conflict',
  Denied = 'Denied',
  Pending = 'Pending',
  Unmatched = 'Unmatched',
}

export interface PeppolUnassignedDocument {
  __typename?: 'PeppolUnassignedDocument';
  buyerReference?: Maybe<Scalars['String']>;
  deliveryAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  receivedAt: Scalars['Date'];
  supplierIco?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  xmlContent?: Maybe<Scalars['String']>;
}

export interface PlanFeatureObjectType {
  __typename?: 'PlanFeatureObjectType';
  description?: Maybe<Scalars['String']>;
  featureState: SubscriptionPlanFeatureState;
  name: SubscriptionPlanFeatureType;
}

export interface PlanOptionObjectType {
  __typename?: 'PlanOptionObjectType';
  availableInvoiceOptions: Array<Scalars['Int']>;
  features: Array<PlanFeatureObjectType>;
  pricesByNumberOfInvoices: Array<PriceByInvoiceOptionObjectType>;
  title: Scalars['String'];
  type: SubscriptionPlanType;
  value: Scalars['String'];
}

export interface PlandayConnectionObjectType {
  __typename?: 'PlandayConnectionObjectType';
  laborIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['Date']>;
  organizationId: Scalars['String'];
  selectedDepartments?: Maybe<Array<Scalars['Int']>>;
}

export interface PlandayDepartmentObjectType {
  __typename?: 'PlandayDepartmentObjectType';
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface PnlLaborItemObjectType {
  __typename?: 'PnlLaborItemObjectType';
  employeeId: Scalars['ID'];
  employeeName: Scalars['String'];
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlLossItemObjectType {
  __typename?: 'PnlLossItemObjectType';
  categoryId: Scalars['String'];
  categoryName: Scalars['String'];
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  supplierId: Scalars['String'];
  supplierName: Scalars['String'];
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlLossNewObjectType {
  __typename?: 'PnlLossNewObjectType';
  labor: PnlLossSectionObjectType;
  other: PnlLossSectionObjectType;
  supply: PnlLossSectionObjectType;
}

export interface PnlLossObjectType {
  __typename?: 'PnlLossObjectType';
  labor: PnlLossSectionObjectType;
  new: PnlLossNewObjectType;
  other: PnlLossSectionObjectType;
  supply: PnlLossSectionObjectType;
}

export interface PnlLossSectionObjectType {
  __typename?: 'PnlLossSectionObjectType';
  items: Array<PnlLossItemObjectType>;
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlOtherItemObjectType {
  __typename?: 'PnlOtherItemObjectType';
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlProfitObjectType {
  __typename?: 'PnlProfitObjectType';
  items: Array<PnlRevenueItemObjectType>;
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlRevenueItemObjectType {
  __typename?: 'PnlRevenueItemObjectType';
  revenueSourceId: Scalars['ID'];
  revenueSourceName: Scalars['String'];
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlSupplyItemObjectType {
  __typename?: 'PnlSupplyItemObjectType';
  supplierId: Scalars['ID'];
  supplierName: Scalars['String'];
  timeSeries: Array<PnlTimeSeriesObjectType>;
}

export interface PnlTimeSeriesObjectType {
  __typename?: 'PnlTimeSeriesObjectType';
  amount: Scalars['Float'];
  amountWithoutVat?: Maybe<Scalars['Float']>;
  currencyCode: CurrencyCode;
  date: Scalars['Date'];
  precision: Scalars['Int'];
}

export interface PreviewSubscriptionUpgradeInput {
  numberOfInvoices: Scalars['Int'];
  planType: SubscriptionPlanType;
  withCostRadar: Scalars['Boolean'];
}

export interface PriceByInvoiceOptionObjectType {
  __typename?: 'PriceByInvoiceOptionObjectType';
  numberOfInvoices: Scalars['Int'];
  price: Scalars['Float'];
}

export interface PricingDataObjectType {
  __typename?: 'PricingDataObjectType';
  costRadarPrice: Scalars['Float'];
  invoicesConfig: InvoicesConfigObjectType;
  subscriptionPeriodDiscounts: Array<SubscriptionPeriodDiscountObjectType>;
  subscriptionTiers: Array<PlanOptionObjectType>;
}

export enum PricingModelVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export interface ProcessSkippedEinvoicesInput {
  legalEntityId: Scalars['ID'];
}

export enum ProductFlowCompletionManner {
  FirstLoad = 'first_load',
  HelpCenter = 'help_center',
  Skipped = 'skipped',
}

export enum ProductFlowId {
  AutoCategorizationMigration = 'AutoCategorizationMigration',
  CashflowTour = 'CashflowTour',
  ExpensesTour = 'ExpensesTour',
  OnboardingWorkflowTour = 'OnboardingWorkflowTour',
  PaymentCalendarTour = 'PaymentCalendarTour',
  PnlTour = 'PnlTour',
}

export interface ProductFlowStateObjectType {
  __typename?: 'ProductFlowStateObjectType';
  completedAt?: Maybe<Scalars['Date']>;
  completionManner?: Maybe<ProductFlowCompletionManner>;
  currentStep?: Maybe<Scalars['String']>;
  flowId: ProductFlowId;
  isComplete: Scalars['Boolean'];
  lastCheckpointStep?: Maybe<Scalars['String']>;
  skippedSteps: Array<Scalars['String']>;
}

export interface ProfitAndLossObjectType {
  __typename?: 'ProfitAndLossObjectType';
  loss: PnlLossObjectType;
  profit: PnlProfitObjectType;
}

export interface QrCodeData {
  __typename?: 'QrCodeData';
  amount: Scalars['Float'];
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  detected: Scalars['Boolean'];
  isBankInfoVerified?: Maybe<Scalars['Boolean']>;
  qrCodeString: Scalars['String'];
  variableSymbol?: Maybe<Scalars['String']>;
}

export interface Query {
  __typename?: 'Query';
  accountingCategories: Array<AccountingCategory>;
  accountingExpenses: AccountingExpensesObjectType;
  activeFlowpayApplication?: Maybe<FlowpayApplication>;
  adminMfaStatus: AdminMfaStatusObjectType;
  adminPermissions: AdminAccount;
  adminVenues: Array<Venue>;
  aiInsightLocks: Array<AiInsightLockObjectType>;
  aiInsightsAccess: AiInsightsAccess;
  aiInsightsFeed: Array<AiInsightObjectType>;
  allCashflowInstitutions: Array<CashflowInstitution>;
  /** Get all expenses with unified cursor-based pagination */
  allExpenses: ExpenseConnection;
  /** Get all revenues with cursor-based pagination */
  allRevenues: RevenueConnection;
  appNotifications: Array<AppNotification>;
  approvedStatements: Array<Statement>;
  archivedAiInsights: ArchivedAiInsights;
  availableCashflowVenues: Array<Venue>;
  availableStoryousInstances: Array<StoryousMerchantPlace>;
  barChartData: Array<BarChartDataObjectType>;
  bizimplyLatestSync?: Maybe<OneTimeLaborExpense>;
  cashRegisterEntries: Array<GroupedCashRegisterEntry>;
  cashflowLinkedAccountVenues: Array<Venue>;
  cashflowLinkedAccounts: Array<CashflowLinkedAccountObjectType>;
  cashflowLinkedTransaction: CashflowLinkedTransaction;
  cashflowLinkedTransactions: Array<CashflowLinkedTransactionWithBalanceObjectType>;
  cashflowManualAccountVenues: Array<Venue>;
  cashflowManualAccounts: Array<CashflowManualAccountObjectType>;
  cashflowManualTransactions: Array<CashflowManualTransactionWithBalanceObjectType>;
  cashflowRequisition?: Maybe<CashflowRequisition>;
  cashflowSimilarUnlinkedExpenses: SimilarUnlinkedExpensesObjectType;
  cashflowSimilarUnlinkedTransactions: SimilarUnlinkedTransactionsObjectType;
  cashflowSimilarUnlinkedTransactionsByExpenseId: SimilarUnlinkedTransactionsWithExpenseInfoObjectType;
  cashflowSimilarUnlinkedTransactionsByRevenueId: SimilarUnlinkedTransactionsWithRevenueInfoObjectType;
  cashflowStatementReport?: Maybe<CashflowStatementReportObjectType>;
  cashflowUnifiedTransactions: CashflowUnifiedTransactionConnection;
  categories: PaginatedCategoryObjectType;
  categoriesInBusinessEntity: Array<Category>;
  category: Category;
  costRadarSubscriptionByVenue?: Maybe<CostRadarSubscription>;
  currencies: Array<Currency>;
  currentCostRadarSubscription?: Maybe<CostRadarSubscription>;
  currentFlowpayMerchant?: Maybe<FlowpayMerchant>;
  currentUser: User;
  currentUserAccount: Account;
  currentVenue: Venue;
  /** Get detailed daily revenues with source information */
  dailyRevenueDetails: Array<DailyRevenueDetailObjectType>;
  defaultCompanyDetails?: Maybe<DefaultCompanyDetailsObjectType>;
  defaultVenueBankAccount?: Maybe<VenueBankAccount>;
  deletedAccountingCategories: Array<AccountingCategory>;
  department: Department;
  departments: PaginatedDepartmentObjectType;
  deputyCompanies: Array<DeputyCompanyObjectType>;
  deputyConnections: Array<DeputyConnectionObjectType>;
  doesVenueHaveMappedPosCategories: Scalars['Boolean'];
  doesVenueHavePosIntegration: Scalars['Boolean'];
  einvoiceRoutingRules: Array<EinvoiceRoutingRule>;
  einvoicingAdminInboxes: Array<EinvoicingAdminInbox>;
  einvoicingAdminVenues: Array<EinvoicingAdminVenue>;
  einvoicingConnection: EinvoicingConnectionStatus;
  einvoicingEnabled: Scalars['Boolean'];
  employee: Employee;
  employees: PaginatedEmployeeObjectType;
  existingAccountByEmail?: Maybe<ExistingAccountObjectType>;
  expense: Expense;
  expenseAgendas: Array<ExpenseAgenda>;
  expenseQrCodeData?: Maybe<QrCodeData>;
  expensesAboExport: ExpenseAboExport;
  expensesAmountsByMonthWithPaidAmount: Array<ExpensesAmountsWithPaymentByMonthObjectType>;
  expensesSepaExport: ExpenseSepaExport;
  expensesStaExport: ExpenseStaExport;
  exportSupplierIntegrationsCsv: Scalars['String'];
  flowpayApplication: FlowpayApplication;
  flowpayApplications: Array<FlowpayApplicationWithDetailsDto>;
  flowpayCounterofferInfo: CounterofferInfoDto;
  flowpayFinancingPurposes: Array<FlowpayFinancingPurposeDto>;
  flowpayFinancingSignatureInfo: FlowpayFinancingSignatureInfoDto;
  flowpayMerchantCashflowAccounts: Array<CashflowLinkedAccount>;
  flowpayOffer?: Maybe<FlowpayOffer>;
  flowpayRepresentatives: Array<FlowpayRepresentative>;
  formattedOrderItems: PaginatedOrderItemObjectType;
  futureSubscriptions: Array<SubscriptionData>;
  getFakturoidInvoicePaymentData?: Maybe<FakturoidInvoicePaymentDataObjectType>;
  getOnboardingChecklist: Array<OnboardingChecklistGroup>;
  getPaymentDetails: PaymentDetails;
  getPaymentFailureStatus: PaymentFailureStatusObjectType;
  getPricingData: PricingDataObjectType;
  getProductFlowStates: Array<ProductFlowStateObjectType>;
  getRepeatingExpensePaymentsAfterTerminationDate: Array<Payment>;
  getRepeatingLaborExpensePaymentsAfterTerminationDate: Array<Payment>;
  getSubscriptionPaymentLink: Scalars['String'];
  getSubscriptionPaymentLinkNew: Scalars['String'];
  getSubscriptionUpgradeContext: SubscriptionUpgradeContext;
  getTermsOfServiceAndPrivacyPolicyUrls: TermsOfServiceAndPrivacyPolicyUrlsObjectType;
  getVenueOnboardingState: VenueOnboardingStateResponse;
  globalProfitsAndLoss: GlobalProfitAndLossObjectType;
  globalSuppliers: Array<GlobalSupplier>;
  gmailIntegrationStatus: Array<GmailIntegrationStatusObjectType>;
  groupedWarehouseInventoryValues: Array<WarehouseInventoryValueGroup>;
  hasCashflowAccounts: Scalars['Boolean'];
  hasFlowpayApplications: Scalars['Boolean'];
  hasLegacyCategoriesToMap: Scalars['Boolean'];
  hasUnprocessedCostRadarTrialUploads: Scalars['Boolean'];
  integration?: Maybe<Integration>;
  integrationRevenueCategoryStructure: Array<StructuredIntegrationRevenueCategory>;
  invoiceBillingStatus: InvoiceBillingStatus;
  invoiceUploadItemCountByFeStates: InvoiceUploadItemCountByFeStateObjectType;
  invoiceUploadItemCountByStates: Array<InvoiceUploadItemCountByStateObjectType>;
  invoiceUploadItems: PaginatedInvoiceUploadItemObjectType;
  invoiceUploadItemsForExport: Array<InvoiceUploadItemForExportObjectType>;
  invoiceUploads: Array<InvoiceUpload>;
  invoicesTempUrls: Array<InvoiceUploadItemWithTempUrlObjectType>;
  isEligibleForFinancing: Scalars['Boolean'];
  issuedInvoicesToReceive: Array<Revenue>;
  /** Get labor expense groups aggregated by employee/department for a date range */
  laborExpenseGroups: Array<LaborExpenseGroupObjectType>;
  /** Get paginated labor expenses for a specific employee or department */
  laborExpensesForGroup: ExpenseConnection;
  laborExpensesTimeSeries: Array<LaborExpenseTimeSeriesObjectType>;
  laborExpensesTotalAmount: TotalAmountObjectType;
  latestCashflowLinkedAccountSync: CashflowLinkedAccountLatestSyncObjectType;
  latestIntegrationSync?: Maybe<IntegrationSync>;
  latestIntegrationSyncs: Array<IntegrationSync>;
  myNotificationPreferences: NotificationPreference;
  myOrderItemAlerts: Array<OrderItemAlert>;
  ocrExpense: OcrExpense;
  oneTimeExpense: OneTimeExpense;
  oneTimeExpenses: PaginatedOneTimeExpenseObjectType;
  oneTimeExpensesForBulkExport: Array<OneTimeExpense>;
  oneTimeExpensesTotalAmount: TotalAmountObjectType;
  oneTimeLaborExpense: OneTimeLaborExpense;
  oneTimeLaborExpenseTotalAmount: TotalAmountObjectType;
  oneTimeLaborExpenses: PaginatedOneTimeLaborExpenseObjectType;
  oneTimeLaborExpensesByIds: Array<OneTimeLaborExpense>;
  orderItemAlert?: Maybe<OrderItemAlert>;
  orderItemAlerts: Array<OrderItemAlert>;
  orderItemEntries: Array<OrderItemEntry>;
  orderItemsExtractedNotification: OrderItemsExtractedNotification;
  outlookIntegrationStatus: Array<OutlookIntegrationStatusObjectType>;
  payment: Payment;
  paymentFailureGracePeriodDefault: Scalars['Int'];
  paymentMethod: PaymentMethod;
  paymentMethods: PaginatedPaymentMethodObjectType;
  payments: PaginatedPaymentObjectType;
  paymentsByIds: Array<Payment>;
  pendingAccounts: Array<AdminPendingNewAccount>;
  pendingStoryousIntegrationRequests: Array<IntegrationRequest>;
  peppolEinvoiceArchive: Array<PeppolEinvoiceArchiveRow>;
  peppolRegistrationQueue: Array<PeppolRegistrationQueueItem>;
  peppolUnassignedDocuments: Array<PeppolUnassignedDocument>;
  plandayConnections: Array<PlandayConnectionObjectType>;
  plandayDepartments: Array<PlandayDepartmentObjectType>;
  previewSubscriptionUpgrade: SubscriptionUpgradePreview;
  processedInvoiceCount: Scalars['Int'];
  processedOrderItemsCount: Scalars['Int'];
  profitsAndLoss: ProfitAndLossObjectType;
  recurringExpensesTimeSeries: Array<RecurringExpenseTimeSeriesObjectType>;
  recurringExpensesTotalAmount: TotalAmountObjectType;
  recurringLaborExpensesTotalAmount: TotalAmountObjectType;
  referralLink: Scalars['String'];
  repeatingExpense: RepeatingExpense;
  repeatingExpenses: PaginatedRepeatingExpenseObjectType;
  repeatingLaborExpense: RepeatingLaborExpense;
  repeatingLaborExpenses: PaginatedRepeatingLaborExpenseObjectType;
  repeatingLaborExpensesByIds: Array<RepeatingLaborExpenseDataObjectType>;
  revenue: Revenue;
  revenueCategories: PaginatedRevenueCategoryObjectType;
  revenueCategory: RevenueCategory;
  revenueReconciliationTotalsByCategory: Array<GroupedRevenueTotals>;
  revenueSource: RevenueSource;
  revenueSources: PaginatedRevenueSourceObjectType;
  revenueSourcesByNames: Array<RevenueSource>;
  revenueSourcesForCashflow: Array<RevenueSourcesGroupedByVenueObjectType>;
  revenues: PaginatedRevenueObjectType;
  /** Get revenues aggregated by day for a date range */
  revenuesByDay: Array<RevenueTimeSeriesObjectType>;
  /** Get revenues aggregated by hour for a date range */
  revenuesByHour: Array<RevenueTimeSeriesObjectType>;
  /** Get revenues aggregated by month for a date range */
  revenuesByMonth: Array<RevenueTimeSeriesObjectType>;
  revenuesTotal: TotalAmountObjectType;
  revenuesTotalBySource: Array<RevenueTotalAmountBySourceObjectType>;
  rotaConnections: Array<RotaConnectionObjectType>;
  rotaSites: Array<RotaSiteObjectType>;
  seznamIntegrationStatus: Array<SeznamIntegrationStatusObjectType>;
  shouldUseOldPricing: Scalars['Boolean'];
  similarExpensesByStatementEntry: Array<SimilarExpenseDto>;
  splitExpense: SplitExpense;
  splitExpensesForBulkExport: Array<SplitExpenseForExportObjectType>;
  statement: Statement;
  storyousMatchSuggestions: Array<StoryousMatchSuggestion>;
  structuredTotalExpenses: ExpenseStructuredTotalAmountObjectType;
  subscriptionData: SubscriptionDataObjectType;
  /** Categories that are currently hidden (isHidden = true) for the current venue. Surfaced as 'Suggested' rows in the new Categories settings UI's Add Category / Add Subcategory dialogs. */
  suggestedCategories: Array<Category>;
  supplier: Supplier;
  supplierBankAccounts?: Maybe<Array<SupplierBankAccount>>;
  supplierIntegrationRequests: Array<SupplierIntegrationRequest>;
  suppliers: PaginatedSupplierObjectType;
  suppliersExcelForMatching: Scalars['String'];
  supplyExpense: SupplyExpense;
  supplyExpenses: PaginatedSupplyExpenseObjectType;
  supplyExpensesForBulkExport: Array<SupplyExpense>;
  supplyExpensesTotalAmount: TotalAmountObjectType;
  totalExpenses: TotalAmountObjectType;
  totalExpensesByCategory?: Maybe<Array<ExpenseTotalByCategoryObjectType>>;
  totalProfit: TotalAmountObjectType;
  totalUnpaidExpensesAmount: CashBurdnownObjectType;
  totalUnpaidIssuedInvoicesAmount: UnpaidIssuedInvoicesObjectType;
  unifiedExpensesForBulkExport: Array<Expense>;
  /** One-time approved unified expenses (Supply/Other, plus invoice-backed Labor) filtered by dueDate range, for calendar view */
  unifiedExpensesForCalendar: Array<Expense>;
  unifiedRecurringExpensesForBulkExport: Array<RecurringExpenseTimeSeriesObjectType>;
  usersInChain: Array<User>;
  vatEstimation: VatEstimationObjectType;
  venueBankAccounts: Array<VenueBankAccount>;
  venueDetailsForCheckout?: Maybe<Venue>;
  venueForManagement?: Maybe<Venue>;
  venueGracePeriodInfo: AdminVenueGracePeriodObjectType;
  venueLegacyCategoriesForMigration: Array<Category>;
  venueLegacyCategoryRememberedSuppliers: Array<LegacyCategoryRememberedSuppliers>;
  venuePosCategoriesCount: VenuePosCategoriesCountObjectType;
  venueUsersForBillingLink: Array<User>;
  venueUsersForCheckout: Array<User>;
  venues: Array<VenueWithSubscriptionData>;
  venuesForStoryousConnection: Array<VenueForStoryousConnection>;
  venuesUnderSameBusinessEntity: Array<Venue>;
  venuesWithOwnerOrAdminRole: Array<VenueWithRoleObjectType>;
  warehouseInventoryValue?: Maybe<WarehouseInventoryValue>;
  xeroConnection: XeroConnectionObjectType;
  xeroTrackingCategories: Array<XeroTrackingCategoryObjectType>;
}

export interface QueryAccountingCategoriesArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryAccountingExpensesArgs {
  from: Scalars['Date'];
  invoiceType: InvoiceType;
  to: Scalars['Date'];
}

export interface QueryAllExpensesArgs {
  after?: InputMaybe<Scalars['String']>;
  anchorExpenseId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilter: DateFromToInputType;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeLaborExpenses?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  sortBy?: InputMaybe<ExpenseSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  systemCategoryTypes?: InputMaybe<Array<SystemCategoryType>>;
}

export interface QueryAllRevenuesArgs {
  after?: InputMaybe<Scalars['String']>;
  byCategory?: InputMaybe<Scalars['Boolean']>;
  byPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  dateFilter: DateFromToInputType;
  first?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  revenueSourceChildIds?: InputMaybe<Array<Scalars['ID']>>;
  revenueSourceIds?: InputMaybe<Array<Scalars['ID']>>;
  sum?: InputMaybe<Scalars['String']>;
}

export interface QueryAppNotificationsArgs {
  withDismissed?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryApprovedStatementsArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryArchivedAiInsightsArgs {
  cadences?: InputMaybe<Array<AiInsightCadence>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AiInsightType>>;
}

export interface QueryBarChartDataArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryCashRegisterEntriesArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryCashflowLinkedAccountVenuesArgs {
  cashflowLinkedAccountId: Scalars['ID'];
}

export interface QueryCashflowLinkedTransactionArgs {
  id: Scalars['ID'];
}

export interface QueryCashflowLinkedTransactionsArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryCashflowManualAccountVenuesArgs {
  cashflowManualAccountId: Scalars['ID'];
}

export interface QueryCashflowManualTransactionsArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryCashflowRequisitionArgs {
  requisitionId: Scalars['ID'];
}

export interface QueryCashflowSimilarUnlinkedExpensesArgs {
  amount?: InputMaybe<Scalars['Int']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  date?: InputMaybe<Scalars['Date']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface QueryCashflowSimilarUnlinkedTransactionsArgs {
  amount?: InputMaybe<Scalars['Int']>;
  currencyCode?: InputMaybe<CurrencyCode>;
  date?: InputMaybe<Scalars['Date']>;
  originalAmount?: InputMaybe<Scalars['Int']>;
  originalCurrencyCode?: InputMaybe<CurrencyCode>;
  variableSymbol?: InputMaybe<Scalars['String']>;
}

export interface QueryCashflowSimilarUnlinkedTransactionsByExpenseIdArgs {
  date?: InputMaybe<Scalars['Date']>;
  expenseId?: InputMaybe<Scalars['ID']>;
  oneTimeExpenseId?: InputMaybe<Scalars['ID']>;
  oneTimeLaborExpenseId?: InputMaybe<Scalars['ID']>;
  recurringExpenseDate?: InputMaybe<Scalars['Date']>;
  repeatingExpenseId?: InputMaybe<Scalars['ID']>;
  repeatingLaborExpenseId?: InputMaybe<Scalars['ID']>;
  splitExpenseId?: InputMaybe<Scalars['ID']>;
  supplyExpenseId?: InputMaybe<Scalars['ID']>;
}

export interface QueryCashflowSimilarUnlinkedTransactionsByRevenueIdArgs {
  revenueId: Scalars['ID'];
}

export interface QueryCashflowStatementReportArgs {
  cashflowLinkedAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  cashflowManualAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  period: CashflowStatementReportPeriod;
  to: Scalars['Date'];
}

export interface QueryCashflowUnifiedTransactionsArgs {
  accountId?: InputMaybe<Scalars['ID']>;
  dateFilter: DateFromToInputType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  showOnlyUnpaired?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<CashflowTransactionsSortKey>;
  transactionTypes?: InputMaybe<Array<CashflowTransactionType>>;
  venueIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface QueryCategoriesArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  includeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  listMode?: InputMaybe<CategoryListMode>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  systemCategories?: InputMaybe<Array<SystemCategoryType>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryCategoryArgs {
  id: Scalars['ID'];
}

export interface QueryCostRadarSubscriptionByVenueArgs {
  venueId: Scalars['String'];
}

export interface QueryDailyRevenueDetailsArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryDepartmentArgs {
  id: Scalars['ID'];
}

export interface QueryDepartmentsArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryDeputyCompaniesArgs {
  laborIntegrationId: Scalars['String'];
}

export interface QueryEinvoiceRoutingRulesArgs {
  legalEntityId: Scalars['ID'];
}

export interface QueryEinvoicingConnectionArgs {
  venueId: Scalars['ID'];
}

export interface QueryEinvoicingEnabledArgs {
  venueId: Scalars['ID'];
}

export interface QueryEmployeeArgs {
  id: Scalars['ID'];
}

export interface QueryEmployeesArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryExistingAccountByEmailArgs {
  email: Scalars['String'];
}

export interface QueryExpenseArgs {
  id: Scalars['ID'];
}

export interface QueryExpenseQrCodeDataArgs {
  expenseId?: InputMaybe<Scalars['ID']>;
  ocrExpenseId?: InputMaybe<Scalars['ID']>;
  oneTimeExpenseId?: InputMaybe<Scalars['ID']>;
  splitExpenseId?: InputMaybe<Scalars['ID']>;
  supplyExpenseId?: InputMaybe<Scalars['ID']>;
}

export interface QueryExpensesAboExportArgs {
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  expenseIds?: InputMaybe<Array<Scalars['ID']>>;
  markExpensesAsPaid: Scalars['Boolean'];
  ocrExpenseIds: Array<Scalars['ID']>;
  payByDueDate?: InputMaybe<Scalars['Boolean']>;
  recurringOccurrences?: InputMaybe<Array<ExpenseOccurrenceInputType>>;
}

export interface QueryExpensesAmountsByMonthWithPaidAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  from: Scalars['Date'];
  includeNegative?: InputMaybe<Scalars['Boolean']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  oneTimeExpenses?: InputMaybe<Scalars['Boolean']>;
  oneTimeLaborExpenses?: InputMaybe<Scalars['Boolean']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  recurringExpenses?: InputMaybe<Scalars['Boolean']>;
  repeatingLaborExpenses?: InputMaybe<Scalars['Boolean']>;
  supplyExpenses?: InputMaybe<Scalars['Boolean']>;
  to: Scalars['Date'];
}

export interface QueryExpensesSepaExportArgs {
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  expenseIds?: InputMaybe<Array<Scalars['ID']>>;
  markExpensesAsPaid: Scalars['Boolean'];
  ocrExpenseIds: Array<Scalars['ID']>;
  paymentDate: Scalars['Date'];
  recurringOccurrences?: InputMaybe<Array<ExpenseOccurrenceInputType>>;
}

export interface QueryExpensesStaExportArgs {
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  expenseIds?: InputMaybe<Array<Scalars['ID']>>;
  markExpensesAsPaid: Scalars['Boolean'];
  ocrExpenseIds: Array<Scalars['ID']>;
  recurringOccurrences?: InputMaybe<Array<ExpenseOccurrenceInputType>>;
}

export interface QueryFlowpayApplicationArgs {
  id: Scalars['ID'];
}

export interface QueryFormattedOrderItemsArgs {
  categories?: InputMaybe<Array<OrderItemCategory>>;
  dateFilter?: InputMaybe<DateFromToInputType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchValue?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<OrderItemsSortKey>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface QueryFutureSubscriptionsArgs {
  venueId: Scalars['String'];
}

export interface QueryGetRepeatingExpensePaymentsAfterTerminationDateArgs {
  id: Scalars['ID'];
  terminationDate: Scalars['Date'];
}

export interface QueryGetRepeatingLaborExpensePaymentsAfterTerminationDateArgs {
  id: Scalars['ID'];
  terminationDate: Scalars['Date'];
}

export interface QueryGetSubscriptionPaymentLinkArgs {
  countryCode: Scalars['String'];
  period: Scalars['String'];
  planType: Scalars['String'];
}

export interface QueryGetSubscriptionPaymentLinkNewArgs {
  consentTextVersion?: InputMaybe<Scalars['String']>;
  numberOfInvoices: Scalars['Int'];
  paymentCancelUrl: Scalars['String'];
  paymentSuccessUrl: Scalars['String'];
  planType: SubscriptionPlanType;
  subscriptionPeriod: SubscriptionPeriod;
  withCostRadar?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryGlobalProfitsAndLossArgs {
  byCategory?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryGlobalSuppliersArgs {
  search?: InputMaybe<Scalars['String']>;
}

export interface QueryGroupedWarehouseInventoryValuesArgs {
  date: Scalars['Date'];
}

export interface QueryInvoiceBillingStatusArgs {
  venueId: Scalars['String'];
}

export interface QueryInvoiceUploadItemCountByFeStatesArgs {
  dateFromTo?: InputMaybe<DateFromToInputType>;
}

export interface QueryInvoiceUploadItemsArgs {
  byIssueDate?: InputMaybe<Scalars['Boolean']>;
  createdByMe?: InputMaybe<Scalars['Boolean']>;
  dateFromTo?: InputMaybe<DateFromToInputType>;
  documentTypes?: InputMaybe<Array<InvoiceType>>;
  excludeRejected?: InputMaybe<Scalars['Boolean']>;
  includeStatements?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<DocumentSortKey>;
  statuses?: InputMaybe<Array<DocumentStatusFilter>>;
  supplierNames?: InputMaybe<Array<Scalars['String']>>;
  uploadChannels?: InputMaybe<Array<DocumentUploadChannel>>;
  uploadSource?: InputMaybe<ManualInvoiceUploadSource>;
  uploadedByUserIds?: InputMaybe<Array<Scalars['ID']>>;
  uploadedInvoiceState?: InputMaybe<UploadedInvoiceFeState>;
}

export interface QueryInvoiceUploadItemsForExportArgs {
  byPurchaseDate?: InputMaybe<Scalars['Boolean']>;
  dateFromTo: DateFromToInputType;
}

export interface QueryInvoicesTempUrlsArgs {
  invoiceUploadItemIds: Array<Scalars['ID']>;
  shouldRenameFiles: Scalars['Boolean'];
}

export interface QueryIssuedInvoicesToReceiveArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryLaborExpenseGroupsArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilter: DateFromToInputType;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ExpenseSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
}

export interface QueryLaborExpensesForGroupArgs {
  after?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  currencyCode: Scalars['String'];
  dateFilter: DateFromToInputType;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  employeeId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
}

export interface QueryLaborExpensesTimeSeriesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  to: Scalars['Date'];
}

export interface QueryLaborExpensesTotalAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  to: Scalars['Date'];
}

export interface QueryOcrExpenseArgs {
  id: Scalars['ID'];
}

export interface QueryOneTimeExpenseArgs {
  id: Scalars['ID'];
}

export interface QueryOneTimeExpensesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilter?: InputMaybe<DateFromToInputType>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  limit?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface QueryOneTimeExpensesForBulkExportArgs {
  dateFromTo?: InputMaybe<DateFromToInputType>;
  overdue?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryOneTimeExpensesTotalAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  to: Scalars['Date'];
}

export interface QueryOneTimeLaborExpenseArgs {
  id: Scalars['ID'];
}

export interface QueryOneTimeLaborExpenseTotalAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  to: Scalars['Date'];
}

export interface QueryOneTimeLaborExpensesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilter?: InputMaybe<DateFromToInputType>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
}

export interface QueryOneTimeLaborExpensesByIdsArgs {
  oneTimeLaborExpenseIds: Array<Scalars['ID']>;
}

export interface QueryOrderItemAlertArgs {
  orderItemId: Scalars['ID'];
}

export interface QueryOrderItemEntriesArgs {
  dateFilter?: InputMaybe<DateFromToInputType>;
  orderItemId: Scalars['ID'];
}

export interface QueryOrderItemsExtractedNotificationArgs {
  id: Scalars['ID'];
}

export interface QueryPaymentArgs {
  id: Scalars['ID'];
}

export interface QueryPaymentMethodArgs {
  id: Scalars['ID'];
}

export interface QueryPaymentMethodsArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryPaymentsArgs {
  dateFilter: DateFromToInputType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}

export interface QueryPaymentsByIdsArgs {
  paymentIds: Array<Scalars['ID']>;
}

export interface QueryPeppolEinvoiceArchiveArgs {
  venueId: Scalars['ID'];
}

export interface QueryPeppolUnassignedDocumentsArgs {
  venueId: Scalars['ID'];
}

export interface QueryPlandayDepartmentsArgs {
  laborIntegrationId: Scalars['String'];
}

export interface QueryPreviewSubscriptionUpgradeArgs {
  input: PreviewSubscriptionUpgradeInput;
}

export interface QueryProfitsAndLossArgs {
  byCategory?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryRecurringExpensesTimeSeriesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  to: Scalars['Date'];
}

export interface QueryRecurringExpensesTotalAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  to: Scalars['Date'];
}

export interface QueryRecurringLaborExpensesTotalAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  to: Scalars['Date'];
}

export interface QueryRepeatingExpenseArgs {
  id: Scalars['String'];
}

export interface QueryRepeatingExpensesArgs {
  dateFilter?: InputMaybe<DateFromToInputType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}

export interface QueryRepeatingLaborExpenseArgs {
  id: Scalars['ID'];
}

export interface QueryRepeatingLaborExpensesArgs {
  dateFilter?: InputMaybe<DateFromToInputType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}

export interface QueryRepeatingLaborExpensesByIdsArgs {
  from: Scalars['Date'];
  repeatingLaborExpenseIds: Array<Scalars['ID']>;
  to: Scalars['Date'];
}

export interface QueryRevenueArgs {
  id: Scalars['ID'];
}

export interface QueryRevenueCategoriesArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryRevenueCategoryArgs {
  id: Scalars['ID'];
}

export interface QueryRevenueReconciliationTotalsByCategoryArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryRevenueSourceArgs {
  id: Scalars['ID'];
}

export interface QueryRevenueSourcesArgs {
  categoriesOnly?: InputMaybe<Scalars['Boolean']>;
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentMethodsOnly?: InputMaybe<Scalars['Boolean']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryRevenueSourcesByNamesArgs {
  sourceNames: Array<Scalars['String']>;
}

export interface QueryRevenuesArgs {
  byCategory?: InputMaybe<Scalars['Boolean']>;
  byPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  dateFilter?: InputMaybe<DateFromToInputType>;
  limit?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  revenueSourceChildIds?: InputMaybe<Array<Scalars['ID']>>;
  revenueSourceIds?: InputMaybe<Array<Scalars['ID']>>;
  sum?: InputMaybe<Scalars['String']>;
}

export interface QueryRevenuesByDayArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryRevenuesByHourArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryRevenuesByMonthArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryRevenuesTotalArgs {
  byCategory?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['Date'];
  revenueSourceIds?: InputMaybe<Array<Scalars['ID']>>;
  to: Scalars['Date'];
}

export interface QueryRevenuesTotalBySourceArgs {
  byCategory?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryRotaSitesArgs {
  laborIntegrationId: Scalars['String'];
}

export interface QuerySimilarExpensesByStatementEntryArgs {
  amount: Scalars['Int'];
  documentNumber: Scalars['String'];
  issueDate: Scalars['Date'];
  supplierId: Scalars['ID'];
}

export interface QuerySplitExpenseArgs {
  id: Scalars['ID'];
}

export interface QuerySplitExpensesForBulkExportArgs {
  dateFromTo?: InputMaybe<DateFromToInputType>;
  overdue?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryStatementArgs {
  id: Scalars['ID'];
}

export interface QueryStoryousMatchSuggestionsArgs {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  venueId: Scalars['ID'];
  venueName?: InputMaybe<Scalars['String']>;
}

export interface QueryStructuredTotalExpensesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  to: Scalars['Date'];
}

export interface QuerySubscriptionDataArgs {
  venueId: Scalars['String'];
}

export interface QuerySupplierArgs {
  id: Scalars['ID'];
}

export interface QuerySupplierBankAccountsArgs {
  supplierId: Scalars['ID'];
}

export interface QuerySupplierIntegrationRequestsArgs {
  venueId: Scalars['ID'];
}

export interface QuerySuppliersArgs {
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  isEmployee?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}

export interface QuerySupplyExpenseArgs {
  id: Scalars['ID'];
}

export interface QuerySupplyExpensesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilter?: InputMaybe<DateFromToInputType>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  limit?: InputMaybe<Scalars['Int']>;
  multiSearchValue?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface QuerySupplyExpensesForBulkExportArgs {
  dateFromTo?: InputMaybe<DateFromToInputType>;
  overdue?: InputMaybe<Scalars['Boolean']>;
}

export interface QuerySupplyExpensesTotalAmountArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  to: Scalars['Date'];
}

export interface QueryTotalExpensesArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  to: Scalars['Date'];
}

export interface QueryTotalExpensesByCategoryArgs {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFilterType?: InputMaybe<ExpenseDateFilterType>;
  from: Scalars['Date'];
  multiSearchValue?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<ExpensePaymentMethod>>;
  to: Scalars['Date'];
}

export interface QueryTotalProfitArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryUnifiedExpensesForBulkExportArgs {
  dateFromTo?: InputMaybe<DateFromToInputType>;
  overdue?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryUnifiedExpensesForCalendarArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryUnifiedRecurringExpensesForBulkExportArgs {
  dateFromTo?: InputMaybe<DateFromToInputType>;
  overdue?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryUsersInChainArgs {
  currentVenueOnly?: InputMaybe<Scalars['Boolean']>;
}

export interface QueryVatEstimationArgs {
  from: Scalars['Date'];
  to: Scalars['Date'];
}

export interface QueryVenueDetailsForCheckoutArgs {
  venueId: Scalars['String'];
}

export interface QueryVenueForManagementArgs {
  venueId: Scalars['String'];
}

export interface QueryVenueGracePeriodInfoArgs {
  venueId: Scalars['String'];
}

export interface QueryVenueUsersForBillingLinkArgs {
  venueId: Scalars['String'];
}

export interface QueryVenueUsersForCheckoutArgs {
  venueId: Scalars['String'];
}

export interface QueryWarehouseInventoryValueArgs {
  date: Scalars['Date'];
}

export enum RecurrenceInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export interface RecurrencePattern {
  __typename?: 'RecurrencePattern';
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  dayOfMonth?: Maybe<Scalars['Int']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  interval: RecurrenceInterval;
  monthOfYear?: Maybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  usesLegacyDayOfMonthMatch: Scalars['Boolean'];
}

export interface RecurringExpenseTimeSeriesObjectType {
  __typename?: 'RecurringExpenseTimeSeriesObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  currencyPrecision: Scalars['Int'];
  date: Scalars['Date'];
  id: Scalars['String'];
  isCashflowTransactionLinked: Scalars['Boolean'];
  isPaid: Scalars['Boolean'];
  isUnified?: Maybe<Scalars['Boolean']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  repeatingExpense: RecurringExpenseUnion;
  repeatingExpenseId: Scalars['ID'];
}

export type RecurringExpenseUnion = Expense | RepeatingExpense;

export interface RegenerateAiFindingResult {
  __typename?: 'RegenerateAiFindingResult';
  insightId?: Maybe<Scalars['ID']>;
  outcome: AiFindingsOutcome;
  reason?: Maybe<Scalars['String']>;
}

export interface RepeatingExpense {
  __typename?: 'RepeatingExpense';
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  category: Category;
  categoryId: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  legacyCategoryId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  predecessorId?: Maybe<Scalars['ID']>;
  recurrencePattern: RecurrencePattern;
  recurrencePatternId: Scalars['ID'];
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']>;
  updatedById?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface RepeatingLaborExpense {
  __typename?: 'RepeatingLaborExpense';
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']>;
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  legacyCategoryId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  predecessorId?: Maybe<Scalars['ID']>;
  recurrencePattern: RecurrencePattern;
  recurrencePatternId: Scalars['ID'];
  updatedById?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface RepeatingLaborExpenseDataObjectType {
  __typename?: 'RepeatingLaborExpenseDataObjectType';
  amount: Scalars['Float'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  paymentId?: Maybe<Scalars['ID']>;
}

export enum ReportingMode {
  FourFourFive = 'FourFourFive',
  Standard = 'Standard',
}

export interface Revenue {
  __typename?: 'Revenue';
  accountingInfo?: Maybe<ExpenseAccountingInfo>;
  accountingInfoId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  bankInfo?: Maybe<ExpenseBankInfo>;
  bankInfoId?: Maybe<Scalars['ID']>;
  bulkPaymentExportedAt?: Maybe<Scalars['Date']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  date: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  documentType?: Maybe<InvoiceType>;
  dueDate?: Maybe<Scalars['Date']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  internalDocumentNumber?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceUploadItem?: Maybe<InvoiceUploadItem>;
  invoiceUploadItemId?: Maybe<Scalars['ID']>;
  issueDate?: Maybe<Scalars['Date']>;
  laborInfo?: Maybe<ExpenseLaborInfo>;
  laborInfoId?: Maybe<Scalars['ID']>;
  legacyCategoryId?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  mode: RevenueMode;
  note?: Maybe<Scalars['String']>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  revenuePayment?: Maybe<RevenuePayment>;
  revenueSource: RevenueSource;
  revenueSourceId: Scalars['ID'];
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']>;
  taxPointDate?: Maybe<Scalars['Date']>;
  taxRate?: Maybe<TaxRate>;
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  validationErrors?: Maybe<Array<Scalars['String']>>;
  variableSymbol?: Maybe<Scalars['String']>;
  venueId: Scalars['ID'];
  xeroTrackingLink?: Maybe<ExpenseXeroTrackingLink>;
  xeroTrackingLinkId?: Maybe<Scalars['ID']>;
}

export interface RevenueCategory {
  __typename?: 'RevenueCategory';
  accountReference?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  departmentCode?: Maybe<Scalars['String']>;
  expenseCategories: Array<Category>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nominalAcRef?: Maybe<Scalars['String']>;
  revenueSource?: Maybe<RevenueSource>;
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface RevenueConnection {
  __typename?: 'RevenueConnection';
  edges: Array<RevenueEdge>;
  pageInfo: RevenuePageInfo;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountWithoutVat?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Int']>;
}

export interface RevenueEdge {
  __typename?: 'RevenueEdge';
  cursor: Scalars['String'];
  node: Revenue;
}

export enum RevenueMode {
  Day = 'DAY',
  Month = 'MONTH',
}

export interface RevenuePageInfo {
  __typename?: 'RevenuePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
}

export interface RevenuePayment {
  __typename?: 'RevenuePayment';
  amount: Scalars['Int'];
  cashflowLinkedTransaction?: Maybe<CashflowLinkedTransaction>;
  cashflowLinkedTransactionId?: Maybe<Scalars['ID']>;
  cashflowManualTransaction?: Maybe<CashflowManualTransaction>;
  cashflowManualTransactionId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  paidAt: Scalars['Date'];
  revenueId: Scalars['ID'];
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface RevenueSource {
  __typename?: 'RevenueSource';
  childId: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  integrationPaymentMethod?: Maybe<IntegrationPaymentMethod>;
  integrationPaymentMethodId?: Maybe<Scalars['ID']>;
  integrationProvider?: Maybe<IntegrationProvider>;
  integrationRevenueCategory?: Maybe<IntegrationRevenueCategory>;
  integrationRevenueCategoryId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  revenueCategory?: Maybe<RevenueCategory>;
  revenueCategoryId?: Maybe<Scalars['ID']>;
  taxRate?: Maybe<TaxRate>;
  updatedById?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface RevenueSourceForCashflowObjectType {
  __typename?: 'RevenueSourceForCashflowObjectType';
  connectedToCashflowAccountId?: Maybe<Scalars['ID']>;
  connectedToCashflowAccountName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  venueId: Scalars['ID'];
  venueName: Scalars['String'];
}

export interface RevenueSourceType {
  __typename?: 'RevenueSourceType';
  accountReference: Scalars['String'];
  departmentCode: Scalars['String'];
  nominalAcRef: Scalars['String'];
}

export interface RevenueSourcesGroupedByVenueObjectType {
  __typename?: 'RevenueSourcesGroupedByVenueObjectType';
  revenueSources: Array<RevenueSourceForCashflowObjectType>;
  venueId: Scalars['ID'];
  venueName: Scalars['String'];
}

export interface RevenueTimeSeriesObjectType {
  __typename?: 'RevenueTimeSeriesObjectType';
  /** Total revenue amount in smallest currency unit */
  amount: Scalars['Float'];
  /** Total revenue amount without VAT in smallest currency unit */
  amountWithoutVat?: Maybe<Scalars['Float']>;
  /** Number of revenue entries in this period */
  count?: Maybe<Scalars['Int']>;
  /** Currency code (e.g., GBP, EUR, CZK) */
  currencyCode: Scalars['String'];
  /** Date/time for this aggregation period */
  date: Scalars['Date'];
  /** Currency precision (e.g., 2 for cents) */
  precision: Scalars['Int'];
}

export interface RevenueTotalAmountBySourceObjectType {
  __typename?: 'RevenueTotalAmountBySourceObjectType';
  amount: Scalars['Float'];
  amountWithoutSpecifiedVat?: Maybe<Scalars['Float']>;
  amountWithoutVat?: Maybe<Scalars['Float']>;
  currencyCode: CurrencyCode;
  id: Scalars['ID'];
  precision: Scalars['Int'];
  revenueSourceId: Scalars['ID'];
  revenueSourceName: Scalars['String'];
}

export interface Role {
  __typename?: 'Role';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  name: UserRole;
  permissions: Scalars['String'];
}

export interface RotaConnectionObjectType {
  __typename?: 'RotaConnectionObjectType';
  laborIntegrationId: Scalars['String'];
  lastSyncedAt?: Maybe<Scalars['Date']>;
  realmId: Scalars['String'];
  selectedSites?: Maybe<Array<Scalars['String']>>;
}

export interface RotaSiteObjectType {
  __typename?: 'RotaSiteObjectType';
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface SaveEinvoiceRoutingRuleInput {
  legalEntityId: Scalars['ID'];
  type: EinvoiceRoutingRuleType;
  value: Scalars['String'];
  venueId: Scalars['ID'];
}

export interface SaveEinvoicingSettingsInput {
  documentSyncEnabled: Scalars['Boolean'];
  includedVenueIds: Array<Scalars['ID']>;
  legalEntityId: Scalars['ID'];
  processSkippedDocuments?: InputMaybe<Scalars['Boolean']>;
}

export interface ScopeObjectType {
  __typename?: 'ScopeObjectType';
  allowLaborInvoiceCategorization: Scalars['Boolean'];
  alwaysRequireManualInvoiceApproval: Scalars['Boolean'];
  autoCategorizationMigrationComplete: Scalars['Boolean'];
  cashflowEnabled: Scalars['Boolean'];
  cashflowRouteAvailable?: Maybe<Scalars['Boolean']>;
  currentBusinessEntityId: Scalars['String'];
  currentUserId: Scalars['String'];
  currentUserRole: UserRole;
  currentVenueCountry: CountryCode;
  currentVenueCreatedAt: Scalars['Date'];
  currentVenueId: Scalars['String'];
  currentVenueName: Scalars['String'];
  /** @deprecated Gmail sync is available to every venue. */
  gmailSyncEnabled?: Maybe<Scalars['Boolean']>;
  isOnboardingComplete: Scalars['Boolean'];
  noVatAvailable?: Maybe<Scalars['Boolean']>;
  noVatAvailableFrom?: Maybe<Scalars['Date']>;
  noVatMode: Scalars['Boolean'];
  /** @deprecated Outlook sync is available to every venue. */
  outlookSyncEnabled?: Maybe<Scalars['Boolean']>;
  permissions: Scalars['String'];
  reportingMode?: Maybe<ReportingMode>;
  /** @deprecated Seznam sync follows the venue country. */
  seznamSyncEnabled?: Maybe<Scalars['Boolean']>;
  useAutoCategorization: Scalars['Boolean'];
  useNewExpenseArchitecture: Scalars['Boolean'];
  userIds: Array<Scalars['String']>;
  vatCustomPeriodEnd?: Maybe<Scalars['Date']>;
  vatCustomPeriodStart?: Maybe<Scalars['Date']>;
  vatReportingPeriod?: Maybe<VatReportingPeriod>;
}

export interface SendToXeroResponseObjectType {
  __typename?: 'SendToXeroResponseObjectType';
  failed: Scalars['Int'];
  failures: Array<XeroExportFailureObjectType>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  successful: Scalars['Int'];
}

export interface SetDefaultCategoryInputType {
  accountingCategoryId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  expenseType?: InputMaybe<SystemCategoryType>;
  isAutoConfirmationEnabled?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
  trackingCategoryId?: InputMaybe<Scalars['String']>;
  trackingOptionId?: InputMaybe<Scalars['String']>;
}

export interface SetupInvoiceBillingInput {
  amountWithoutVat: Scalars['Float'];
  billingEmail: Scalars['String'];
  billingFrequencyMonths?: InputMaybe<Scalars['Int']>;
  ccEmail?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  ico?: InputMaybe<Scalars['String']>;
  invoiceItemName?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  vatRate?: InputMaybe<Scalars['Float']>;
  venueId: Scalars['String'];
}

export interface SeznamIntegrationStatusObjectType {
  __typename?: 'SeznamIntegrationStatusObjectType';
  emailAddress?: Maybe<Scalars['String']>;
  historicalSyncLimitHit?: Maybe<Scalars['Boolean']>;
  historicalSyncOldestProcessedAt?: Maybe<Scalars['Date']>;
  integrationId?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConnected: Scalars['Boolean'];
  lastSyncAt?: Maybe<Scalars['Date']>;
  syncStartDate?: Maybe<Scalars['Date']>;
}

export interface SignUpObjectType {
  __typename?: 'SignUpObjectType';
  accountId: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['String'];
  venueId: Scalars['String'];
}

export interface SimilarExpenseDto {
  __typename?: 'SimilarExpenseDto';
  amount: Scalars['Float'];
  category: Scalars['String'];
  dueDate: Scalars['Date'];
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  invoiceUploadItemBucketKey?: Maybe<Scalars['String']>;
  invoiceUploadItemFileName?: Maybe<Scalars['String']>;
  invoiceUploadItemId?: Maybe<Scalars['ID']>;
  invoiceUploadItemMimeType?: Maybe<Scalars['String']>;
  isPaired: Scalars['Boolean'];
  supplierName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
}

export interface SimilarRepeatingExpenseObjectType {
  __typename?: 'SimilarRepeatingExpenseObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  currencyPrecision: Scalars['Int'];
  date: Scalars['Date'];
  id: Scalars['String'];
  isCashflowTransactionLinked: Scalars['Boolean'];
  isPaid: Scalars['Boolean'];
  isUnified?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  repeatingExpense: RecurringExpenseUnion;
  repeatingExpenseId: Scalars['ID'];
}

export interface SimilarRepeatingLaborExpenseObjectType {
  __typename?: 'SimilarRepeatingLaborExpenseObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  currencyPrecision: Scalars['Int'];
  date: Scalars['Date'];
  employeeFirstName?: Maybe<Scalars['String']>;
  employeeLastName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCashflowTransactionLinked: Scalars['Boolean'];
  isPaid: Scalars['Boolean'];
  isUnified?: Maybe<Scalars['Boolean']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  repeatingExpense: RecurringExpenseUnion;
  repeatingExpenseId: Scalars['ID'];
}

export interface SimilarUnlinkedExpensesObjectType {
  __typename?: 'SimilarUnlinkedExpensesObjectType';
  exact: UnlinkedExpensesObjectType;
  similar: UnlinkedExpensesObjectType;
}

export interface SimilarUnlinkedTransactionsObjectType {
  __typename?: 'SimilarUnlinkedTransactionsObjectType';
  exact: UnlinkedTransactionsObjectType;
  similar: UnlinkedTransactionsObjectType;
}

export interface SimilarUnlinkedTransactionsWithExpenseInfoObjectType {
  __typename?: 'SimilarUnlinkedTransactionsWithExpenseInfoObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  date: Scalars['Date'];
  exact: UnlinkedTransactionsObjectType;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  similar: UnlinkedTransactionsObjectType;
  variableSymbol?: Maybe<Scalars['String']>;
}

export interface SimilarUnlinkedTransactionsWithRevenueInfoObjectType {
  __typename?: 'SimilarUnlinkedTransactionsWithRevenueInfoObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  date: Scalars['Date'];
  exact: UnlinkedTransactionsObjectType;
  invoiceNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  similar: UnlinkedTransactionsObjectType;
  variableSymbol?: Maybe<Scalars['String']>;
}

export enum SortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface SplitExpense {
  __typename?: 'SplitExpense';
  accountingDate?: Maybe<Scalars['Date']>;
  accountingInfo?: Maybe<ExpenseAccountingInfo>;
  accountingInfoId?: Maybe<Scalars['ID']>;
  bankInfo?: Maybe<ExpenseBankInfo>;
  bankInfoId?: Maybe<Scalars['ID']>;
  businessEntityId: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  hasQrCode?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalDocumentNumber?: Maybe<Scalars['String']>;
  /** Identifies a date when this expense will be reflected in accounting */
  issueDate?: Maybe<Scalars['Date']>;
  note?: Maybe<Scalars['String']>;
  ocrExpense: OcrExpense;
  ocrExpenseId: Scalars['ID'];
  oneTimeExpenses: Array<OneTimeExpense>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  statementEntries?: Maybe<Array<StatementEntry>>;
  supplyExpenses: Array<SupplyExpense>;
  updatedById?: Maybe<Scalars['ID']>;
  xeroTrackingLink?: Maybe<ExpenseXeroTrackingLink>;
  xeroTrackingLinkId?: Maybe<Scalars['ID']>;
}

export interface SplitExpenseForExportObjectType {
  __typename?: 'SplitExpenseForExportObjectType';
  amount: Scalars['Float'];
  dueDate: Scalars['Date'];
  name: Scalars['String'];
  splitExpense: SplitExpense;
}

export interface SplitExpenseInput {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId: Scalars['ID'];
  type: SplitExpenseType;
  venueId?: InputMaybe<Scalars['ID']>;
}

export enum SplitExpenseType {
  OneTime = 'OneTime',
  Supply = 'Supply',
}

export interface SplitFieldInput {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId: Scalars['ID'];
  venueId: Scalars['ID'];
}

export interface Statement {
  __typename?: 'Statement';
  amount: Scalars['Int'];
  bankAccountNumber: Scalars['String'];
  bankCode: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  entries: Array<StatementEntry>;
  id: Scalars['ID'];
  invoiceUploadItem: InvoiceUploadItem;
  invoiceUploadItemId: Scalars['ID'];
  issueDate: Scalars['Date'];
  statementNumber: Scalars['String'];
  supplier: Supplier;
  supplierId: Scalars['ID'];
  venueId: Scalars['ID'];
}

export interface StatementEntry {
  __typename?: 'StatementEntry';
  amount: Scalars['Int'];
  cashflowLinkedTransaction?: Maybe<CashflowLinkedTransaction>;
  cashflowLinkedTransactionId?: Maybe<Scalars['ID']>;
  cashflowManualTransaction?: Maybe<CashflowManualTransaction>;
  cashflowManualTransactionId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  documentNumber: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  issueDate?: Maybe<Scalars['Date']>;
  ocrExpense?: Maybe<OcrExpense>;
  ocrExpenseId?: Maybe<Scalars['ID']>;
  oneTimeExpense?: Maybe<OneTimeExpense>;
  oneTimeExpenseId?: Maybe<Scalars['ID']>;
  splitExpense?: Maybe<SplitExpense>;
  splitExpenseId?: Maybe<Scalars['ID']>;
  statement: Statement;
  statementId: Scalars['ID'];
  supplyExpense?: Maybe<SupplyExpense>;
  supplyExpenseId?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface StatementEntryInput {
  amount: Scalars['Int'];
  description: Scalars['String'];
  documentNumber: Scalars['String'];
  expenseId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  oneTimeExpenseId?: InputMaybe<Scalars['ID']>;
  splitExpenseId?: InputMaybe<Scalars['ID']>;
  supplyExpenseId?: InputMaybe<Scalars['ID']>;
}

export interface StatementPaymentBundleObjectType {
  __typename?: 'StatementPaymentBundleObjectType';
  amount: Scalars['Int'];
  currencyCode: CurrencyCode;
  dueDate?: Maybe<Scalars['Date']>;
  invoiceUploadItemId?: Maybe<Scalars['ID']>;
  issueDate: Scalars['Date'];
  statementId: Scalars['ID'];
  statementNumber: Scalars['String'];
  supplierName: Scalars['String'];
}

export interface StoryousExistingConnection {
  __typename?: 'StoryousExistingConnection';
  merchantId: Scalars['String'];
  placeId: Scalars['String'];
  placeName: Scalars['String'];
}

export interface StoryousMatchSuggestion {
  __typename?: 'StoryousMatchSuggestion';
  icoMatch: Scalars['Boolean'];
  matchScore: Scalars['Int'];
  matchedOn: Scalars['String'];
  merchantPlace: StoryousMerchantPlace;
}

export interface StoryousMerchantPlace {
  __typename?: 'StoryousMerchantPlace';
  businessId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  connectedVenueId?: Maybe<Scalars['ID']>;
  connectedVenueName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  isAlreadyConnected: Scalars['Boolean'];
  merchantId: Scalars['String'];
  merchantName: Scalars['String'];
  placeId: Scalars['String'];
  placeName: Scalars['String'];
  placeState: Scalars['String'];
}

export interface StructuredIntegrationRevenueCategory {
  __typename?: 'StructuredIntegrationRevenueCategory';
  children: Array<StructuredIntegrationRevenueCategory>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  name: Scalars['String'];
  revenueCategoryName?: Maybe<Scalars['String']>;
}

export interface SubmitAiInsightFeedbackInput {
  comment?: InputMaybe<Scalars['String']>;
  insightId: Scalars['ID'];
  rating: AiInsightFeedbackRating;
  reason?: InputMaybe<Scalars['String']>;
}

export interface SubmitEinvoicingMigrationCodeInput {
  legalEntityId: Scalars['ID'];
  migrationCode: Scalars['String'];
}

export interface SubscriptionData {
  __typename?: 'SubscriptionData';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
  fakturoidLastCheckedAt?: Maybe<Scalars['Date']>;
  fakturoidPaymentFailureStartedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceRecognitionsPerMonth?: Maybe<Scalars['Int']>;
  orderItemsPerMonth?: Maybe<Scalars['Int']>;
  overrideAutomaticUpdates?: Maybe<Scalars['Boolean']>;
  paymentFailureStartedAt?: Maybe<Scalars['Date']>;
  pricingModelVersion: PricingModelVersion;
  start: Scalars['Date'];
  stripeSubscriptionStatus?: Maybe<Scalars['String']>;
  subscriptionPeriod?: Maybe<SubscriptionPeriod>;
  subscriptionPlanType: SubscriptionPlanType;
  venueId: Scalars['ID'];
}

export interface SubscriptionDataObjectType {
  __typename?: 'SubscriptionDataObjectType';
  accountingEnabled: Scalars['Boolean'];
  bankInfoEnabled: Scalars['Boolean'];
  cashflowAvailable: Scalars['Boolean'];
  end?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceEmail: Scalars['String'];
  /** @deprecated Use "invoiceEmail" instead */
  invoiceEmailAddress: Scalars['String'];
  invoiceRecognitionEnabled: Scalars['Boolean'];
  invoiceRecognitionsPerMonth: Scalars['Int'];
  orderItemsPerMonth: Scalars['Int'];
  overrideAutomaticUpdates?: Maybe<Scalars['Boolean']>;
  pricingModelVersion: PricingModelVersion;
  start: Scalars['Date'];
  subscriptionPeriod?: Maybe<SubscriptionPeriod>;
  subscriptionPlanType: SubscriptionPlanType;
  venueId: Scalars['ID'];
}

export enum SubscriptionPeriod {
  Monthly = 'Monthly',
  MonthlyWithAnnualCommitment = 'MonthlyWithAnnualCommitment',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
}

export interface SubscriptionPeriodDiscountObjectType {
  __typename?: 'SubscriptionPeriodDiscountObjectType';
  discountPercentage: Scalars['Int'];
  period: SubscriptionPeriod;
}

export enum SubscriptionPlanFeatureState {
  Included = 'INCLUDED',
  NotIncluded = 'NOT_INCLUDED',
  UnderConstruction = 'UNDER_CONSTRUCTION',
}

export enum SubscriptionPlanFeatureType {
  AccountingIntegration = 'ACCOUNTING_INTEGRATION',
  AdvancedFoodBarCostReporting = 'ADVANCED_FOOD_BAR_COST_REPORTING',
  AutomaticCostCalculation = 'AUTOMATIC_COST_CALCULATION',
  BankIntegration = 'BANK_INTEGRATION',
  BulkPayments = 'BULK_PAYMENTS',
  CashFlow = 'CASH_FLOW',
  GlobalAdminView = 'GLOBAL_ADMIN_VIEW',
  NoVatMode = 'NO_VAT_MODE',
  PaymentCalendar = 'PAYMENT_CALENDAR',
  PersonalizedOnboarding = 'PERSONALIZED_ONBOARDING',
  PosIntegration = 'POS_INTEGRATION',
  QrCodes = 'QR_CODES',
  RealTimePnl = 'REAL_TIME_PNL',
  VatPrediction = 'VAT_PREDICTION',
}

export enum SubscriptionPlanType {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Tier_1 = 'TIER_1',
  Tier_1Acc = 'TIER_1_ACC',
  Tier_2 = 'TIER_2',
  Tier_2Acc = 'TIER_2_ACC',
  Tier_3 = 'TIER_3',
  Trial = 'TRIAL',
}

export interface SubscriptionUpgradeContext {
  __typename?: 'SubscriptionUpgradeContext';
  billingPeriod?: Maybe<SubscriptionPeriod>;
  canShowCurrentPrice: Scalars['Boolean'];
  currencyCode: CurrencyCode;
  currentMonthlyAmount?: Maybe<Scalars['Float']>;
  handling: SubscriptionUpgradeHandling;
  manualReason?: Maybe<SubscriptionUpgradeManualReason>;
}

export enum SubscriptionUpgradeHandling {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
}

export enum SubscriptionUpgradeManualReason {
  CostRadarMismatch = 'COST_RADAR_MISMATCH',
  Coupon = 'COUPON',
  CustomPrice = 'CUSTOM_PRICE',
  EntitlementWriteFailed = 'ENTITLEMENT_WRITE_FAILED',
  MetadataInvalid = 'METADATA_INVALID',
  MultiItem = 'MULTI_ITEM',
  NotActive = 'NOT_ACTIVE',
  NotV2 = 'NOT_V2',
  NoStripeCustomer = 'NO_STRIPE_CUSTOMER',
  NoSubscriptionId = 'NO_SUBSCRIPTION_ID',
  OverrideAutomaticUpdates = 'OVERRIDE_AUTOMATIC_UPDATES',
  Paused = 'PAUSED',
  PeriodMismatch = 'PERIOD_MISMATCH',
  SharedSubscription = 'SHARED_SUBSCRIPTION',
  StripeError = 'STRIPE_ERROR',
}

export interface SubscriptionUpgradePreview {
  __typename?: 'SubscriptionUpgradePreview';
  additionalMonthlyAmount: Scalars['Float'];
  billingPeriod?: Maybe<SubscriptionPeriod>;
  canShowCurrentPrice: Scalars['Boolean'];
  currencyCode: CurrencyCode;
  currentMonthlyAmount?: Maybe<Scalars['Float']>;
  handling: SubscriptionUpgradeHandling;
  nextMonthlyAmount?: Maybe<Scalars['Float']>;
}

export interface Supplier {
  __typename?: 'Supplier';
  accountReference?: Maybe<Scalars['String']>;
  cin?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: CreatedOrUpdatedByObjectType;
  createdById: Scalars['ID'];
  defaultCategory?: Maybe<SupplierDefaultCategory>;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<CreatedOrUpdatedByObjectType>;
  deletedById?: Maybe<Scalars['ID']>;
  departmentCode?: Maybe<Scalars['String']>;
  employeeData?: Maybe<SupplierEmployeeData>;
  employeeDataId?: Maybe<Scalars['ID']>;
  extractLineItems: Scalars['Boolean'];
  hasLaborExpenses: Scalars['Boolean'];
  id: Scalars['ID'];
  integrationType?: Maybe<LaborIntegrationType>;
  isEmployee: Scalars['Boolean'];
  isIssuedInvoiceSupplier: Scalars['Boolean'];
  name: Scalars['String'];
  nominalAcRef?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['String'];
}

export interface SupplierBankAccount {
  __typename?: 'SupplierBankAccount';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  format: BankAccountFormat;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  isVerified?: Maybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
  updatedById?: Maybe<Scalars['ID']>;
}

export interface SupplierDefaultCategory {
  __typename?: 'SupplierDefaultCategory';
  accountingCategory?: Maybe<AccountingCategory>;
  accountingCategoryId?: Maybe<Scalars['ID']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  expenseAgendaId?: Maybe<Scalars['ID']>;
  expenseType?: Maybe<SystemCategoryType>;
  id: Scalars['ID'];
  isAutoConfirmationEnabled?: Maybe<Scalars['Boolean']>;
  revenueSource?: Maybe<RevenueSource>;
  revenueSourceId?: Maybe<Scalars['ID']>;
  supplierId: Scalars['ID'];
  trackingCategoryId?: Maybe<Scalars['String']>;
  trackingOptionId?: Maybe<Scalars['String']>;
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['String'];
}

export interface SupplierEmployeeData {
  __typename?: 'SupplierEmployeeData';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationEmployeeId?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
}

export interface SupplierIntegrationRequest {
  __typename?: 'SupplierIntegrationRequest';
  automatedFollowUpsStopTooltip?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  firstThreadRootMessageId?: Maybe<Scalars['String']>;
  followUpsManuallyDisabledAt?: Maybe<Scalars['Date']>;
  globalSupplier: GlobalSupplier;
  globalSupplierId: Scalars['ID'];
  id: Scalars['ID'];
  initiatedByEmail: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastContactDate: Scalars['Date'];
  nextEmailInDays?: Maybe<Scalars['Int']>;
  outreachFromDisplayName: Scalars['String'];
  outreachFromEmail: Scalars['String'];
  status: SupplierIntegrationStatus;
  supplierReplyDetectedAt?: Maybe<Scalars['Date']>;
  venue: Venue;
  venueId: Scalars['ID'];
}

export interface SupplierIntegrationSelectionInput {
  contactEmail: Scalars['String'];
  globalSupplierId: Scalars['ID'];
}

export enum SupplierIntegrationStatus {
  FirstRequestSent = 'FIRST_REQUEST_SENT',
  ManualInterventionNeeded = 'MANUAL_INTERVENTION_NEEDED',
  SecondRequestSent = 'SECOND_REQUEST_SENT',
  ThirdRequestSent = 'THIRD_REQUEST_SENT',
}

export interface SupplyAndOneTimeExpenseObjectType {
  __typename?: 'SupplyAndOneTimeExpenseObjectType';
  oneTimeExpense?: Maybe<OneTimeExpense>;
  supplyExpense?: Maybe<SupplyExpense>;
}

export interface SupplyExpense {
  __typename?: 'SupplyExpense';
  accountingDate?: Maybe<Scalars['Date']>;
  accountingInfo?: Maybe<ExpenseAccountingInfo>;
  accountingInfoId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  amountWithoutVat?: Maybe<Scalars['Int']>;
  bankInfo?: Maybe<ExpenseBankInfo>;
  bankInfoId?: Maybe<Scalars['ID']>;
  category: Category;
  categoryId: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  currency: Currency;
  currencyCurrencyCode: CurrencyCode;
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  dueDate: Scalars['Date'];
  exchangeRate?: Maybe<Scalars['Float']>;
  hasQrCode?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalDocumentNumber?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Identifies a date when this expense will be reflected in accounting */
  issueDate: Scalars['Date'];
  legacyCategoryId?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  ocrExpense?: Maybe<OcrExpense>;
  ocrExpenseId?: Maybe<Scalars['ID']>;
  originalAmount?: Maybe<Scalars['Int']>;
  originalCurrencyCode?: Maybe<CurrencyCode>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  splitExpense?: Maybe<SplitExpense>;
  splitExpenseId?: Maybe<Scalars['ID']>;
  statementEntries?: Maybe<Array<StatementEntry>>;
  supplier: Supplier;
  supplierId: Scalars['ID'];
  timezone: Scalars['String'];
  updatedById?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['ID'];
  xeroTrackingLink?: Maybe<ExpenseXeroTrackingLink>;
  xeroTrackingLinkId?: Maybe<Scalars['ID']>;
}

export interface SyncFakturoidCompanyDetailsResultObjectType {
  __typename?: 'SyncFakturoidCompanyDetailsResultObjectType';
  failed: Scalars['Int'];
  synced: Scalars['Int'];
}

export enum SystemCategoryType {
  Labor = 'Labor',
  Other = 'Other',
  Supply = 'Supply',
}

export enum TaxRate {
  Tax_0 = 'TAX_0',
  Tax_4 = 'TAX_4',
  Tax_4_8 = 'TAX_4_8',
  Tax_5 = 'TAX_5',
  Tax_6 = 'TAX_6',
  Tax_8 = 'TAX_8',
  Tax_9 = 'TAX_9',
  Tax_10 = 'TAX_10',
  Tax_12 = 'TAX_12',
  Tax_13_5 = 'TAX_13_5',
  Tax_15 = 'TAX_15',
  Tax_19 = 'TAX_19',
  Tax_20 = 'TAX_20',
  Tax_21 = 'TAX_21',
  Tax_23 = 'TAX_23',
  Tax_25 = 'TAX_25',
  TaxManual = 'TAX_MANUAL',
}

export interface TermsOfServiceAndPrivacyPolicyUrlsObjectType {
  __typename?: 'TermsOfServiceAndPrivacyPolicyUrlsObjectType';
  privacyPolicyUrl: Scalars['String'];
  termsOfServiceUrl: Scalars['String'];
}

export interface TotalAmountObjectType {
  __typename?: 'TotalAmountObjectType';
  amount: Scalars['Float'];
  amountWithoutSpecifiedVat?: Maybe<Scalars['Float']>;
  amountWithoutVat?: Maybe<Scalars['Float']>;
  currencyCode: CurrencyCode;
  id: Scalars['ID'];
  precision: Scalars['Int'];
}

export enum TrackingStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export interface UnlinkedExpensesObjectType {
  __typename?: 'UnlinkedExpensesObjectType';
  oneTimeExpenses: Array<OneTimeExpense>;
  oneTimeLaborExpenses: Array<OneTimeLaborExpense>;
  repeatingExpenses: Array<SimilarRepeatingExpenseObjectType>;
  repeatingLaborExpenses: Array<SimilarRepeatingLaborExpenseObjectType>;
  splitExpenses: Array<SplitExpense>;
  statementPaymentBundles: Array<StatementPaymentBundleObjectType>;
  supplyExpenses: Array<SupplyExpense>;
  unifiedExpenses: Array<Expense>;
}

export interface UnlinkedTransactionsObjectType {
  __typename?: 'UnlinkedTransactionsObjectType';
  cashflowLinkedTransactions: Array<CashflowLinkedTransaction>;
  cashflowManualTransactions: Array<CashflowManualTransaction>;
}

export interface UnpaidIssuedInvoicesObjectType {
  __typename?: 'UnpaidIssuedInvoicesObjectType';
  totalAmount: Scalars['Float'];
  windowDays: Scalars['Int'];
}

export interface UpdateRecurrencePatternInput {
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  endDate?: InputMaybe<Scalars['Date']>;
  interval?: InputMaybe<RecurrenceInterval>;
  monthOfYear?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  timezone?: InputMaybe<Scalars['String']>;
}

export interface UpdateSplitExpenseInput {
  amount: Scalars['Int'];
  amountWithoutVat?: InputMaybe<Scalars['Int']>;
  categoryId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  internalDocumentNumber?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  type: SplitExpenseType;
  venueId?: InputMaybe<Scalars['ID']>;
}

export interface UpdateVenueAdminInput {
  crmLink?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  stripeCouponId?: InputMaybe<Scalars['String']>;
}

export enum UploadError {
  FileTooBig = 'FILE_TOO_BIG',
  FormatNotSupported = 'FORMAT_NOT_SUPPORTED',
}

export interface UploadItemDuplicate {
  __typename?: 'UploadItemDuplicate';
  createdAt: Scalars['Date'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  mimeType: Scalars['String'];
  ocrExpense?: Maybe<OcrExpense>;
  state: UploadedInvoiceState;
  uploadError?: Maybe<UploadError>;
}

export enum UploadedInvoiceFeState {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  ReadyForReview = 'READY_FOR_REVIEW',
  Rejected = 'REJECTED',
}

export enum UploadedInvoiceState {
  Approved = 'APPROVED',
  Error = 'ERROR',
  Failed = 'FAILED',
  FailedImport = 'FAILED_IMPORT',
  OverTheLimit = 'OVER_THE_LIMIT',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  RejectedFiltered = 'REJECTED_FILTERED',
  Uploaded = 'UPLOADED',
}

export interface User {
  __typename?: 'User';
  account: Account;
  accountId: Scalars['ID'];
  cashflowRoles: Array<CashflowAccountRole>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  role: Role;
  roleName: UserRole;
  venue: Venue;
}

export enum UserRole {
  CostRadarOnly = 'CostRadarOnly',
  InvoiceOnly = 'InvoiceOnly',
  VenueAdmin = 'VenueAdmin',
  VenueManager = 'VenueManager',
  VenueOwner = 'VenueOwner',
}

export enum VatBreakdown {
  PDosDan = 'PDosDan',
  PDslRegEu = 'PDslRegEu',
  PDzboziEu = 'PDzboziEu',
  Pd = 'Pd',
  Pdb2 = 'Pdb2',
  Pn = 'Pn',
}

export interface VatEstimationObjectType {
  __typename?: 'VatEstimationObjectType';
  currencyCode: CurrencyCode;
  estimatedVat: Scalars['Int'];
  expensesVatAmount: Scalars['Int'];
  expensesVatNotSpecifiedAmount: Scalars['Int'];
  precision: Scalars['Int'];
  revenuesVatAmount: Scalars['Int'];
  revenuesVatNotSpecifiedAmount: Scalars['Int'];
}

export enum VatReportingPeriod {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
}

export interface Venue {
  __typename?: 'Venue';
  address?: Maybe<Scalars['String']>;
  agnisRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  allowLaborInvoiceCategorization?: Maybe<Scalars['Boolean']>;
  altoRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use invoiceApprovalMode */
  alwaysRequireManualInvoiceApproval?: Maybe<Scalars['Boolean']>;
  autoCategorizationMigrationComplete?: Maybe<Scalars['Boolean']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bizimplyLabourCostAutomationEnabled?: Maybe<Scalars['Boolean']>;
  cashflowDisabled?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  crmLink?: Maybe<Scalars['String']>;
  cultureCode: CultureCode;
  currentSubscriptionPlanType?: Maybe<SubscriptionPlanType>;
  defaultTimezone: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  dishboardCsvRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  district?: Maybe<Scalars['String']>;
  einvoicingEnabled: Scalars['Boolean'];
  forwardingEmails?: Maybe<Scalars['String']>;
  halberstatRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceApprovalMode: InvoiceApprovalMode;
  invoiceEmail: Scalars['String'];
  isCashflowSandboxAvailable?: Maybe<Scalars['Boolean']>;
  isOnboardingComplete?: Maybe<Scalars['Boolean']>;
  isTest: Scalars['Boolean'];
  issuedInvoiceAdditionalSupplierIds?: Maybe<Array<Scalars['String']>>;
  languageCode: CultureCode;
  legalEntity: LegalEntity;
  manualApprovalRules: Array<ManualApprovalRule>;
  name: Scalars['String'];
  noVatAvailable?: Maybe<Scalars['Boolean']>;
  noVatMode?: Maybe<Scalars['Boolean']>;
  notificationEmails?: Maybe<Scalars['String']>;
  paymentFailureGracePeriodDays?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  reportingMode?: Maybe<ReportingMode>;
  septimRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  stripeCouponId?: Maybe<Scalars['String']>;
  useAutoCategorization?: Maybe<Scalars['Boolean']>;
  useNewExpenseArchitecture?: Maybe<Scalars['Boolean']>;
  vatCustomPeriodEnd?: Maybe<Scalars['Date']>;
  vatCustomPeriodStart?: Maybe<Scalars['Date']>;
  vatReportingPeriod?: Maybe<VatReportingPeriod>;
}

export interface VenueBankAccount {
  __typename?: 'VenueBankAccount';
  bankAccountNumber: Scalars['String'];
  bankCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  updatedById?: Maybe<Scalars['ID']>;
  venueId: Scalars['ID'];
}

export interface VenueForStoryousConnection {
  __typename?: 'VenueForStoryousConnection';
  existingStoryousConnections: Array<StoryousExistingConnection>;
  ico?: Maybe<Scalars['String']>;
  icoSource?: Maybe<IcoSource>;
  id: Scalars['ID'];
  legalName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}

export enum VenueOnboardingSetupChecklistStep {
  DownloadMobileApp = 'DOWNLOAD_MOBILE_APP',
  InviteTeam = 'INVITE_TEAM',
  SetupCashFlow = 'SETUP_CASH_FLOW',
  SetupExpenses = 'SETUP_EXPENSES',
  SetupLabour = 'SETUP_LABOUR',
  SetupRevenues = 'SETUP_REVENUES',
}

export enum VenueOnboardingSetupFlowSkippableStep {
  ConnectBank = 'CONNECT_BANK',
  ConnectPos = 'CONNECT_POS',
  ConnectWorkforce = 'CONNECT_WORKFORCE',
  DownloadMobileApp = 'DOWNLOAD_MOBILE_APP',
  InviteTeam = 'INVITE_TEAM',
}

export enum VenueOnboardingSetupFlowStep {
  Completed = 'COMPLETED',
  ConnectBank = 'CONNECT_BANK',
  ConnectPos = 'CONNECT_POS',
  ConnectPosInProgress = 'CONNECT_POS_IN_PROGRESS',
  ConnectPosSuccess = 'CONNECT_POS_SUCCESS',
  ConnectWorkforce = 'CONNECT_WORKFORCE',
  DownloadMobileApp = 'DOWNLOAD_MOBILE_APP',
  InviteTeam = 'INVITE_TEAM',
  UploadInvoices = 'UPLOAD_INVOICES',
  UploadInvoicesSuccess = 'UPLOAD_INVOICES_SUCCESS',
  Welcome = 'WELCOME',
}

export interface VenueOnboardingStateResponse {
  __typename?: 'VenueOnboardingStateResponse';
  isEnabled: Scalars['Boolean'];
  setupChecklist: VenueSetupChecklistState;
  setupFlow: VenueSetupFlowState;
}

export interface VenuePosCategoriesCountObjectType {
  __typename?: 'VenuePosCategoriesCountObjectType';
  mappedCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  unmappedCount: Scalars['Int'];
}

export interface VenueProfitAndLossObjectType {
  __typename?: 'VenueProfitAndLossObjectType';
  profitAndLoss: ProfitAndLossObjectType;
  venueId: Scalars['ID'];
  venueName: Scalars['String'];
}

export interface VenueSetupChecklistState {
  __typename?: 'VenueSetupChecklistState';
  completedCount: Scalars['Int'];
  isVisible: Scalars['Boolean'];
  remainingCount: Scalars['Int'];
  steps: Array<VenueSetupChecklistStepState>;
  totalCount: Scalars['Int'];
}

export interface VenueSetupChecklistStepState {
  __typename?: 'VenueSetupChecklistStepState';
  currentAmount: Scalars['Int'];
  descriptionKey: Scalars['String'];
  isDone: Scalars['Boolean'];
  link: Scalars['String'];
  requiredAmount: Scalars['Int'];
  step: VenueOnboardingSetupChecklistStep;
  titleKey: Scalars['String'];
}

export interface VenueSetupFlowState {
  __typename?: 'VenueSetupFlowState';
  canProceedFromCurrentStep: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['Date']>;
  currentStep: VenueOnboardingSetupFlowStep;
  isActive: Scalars['Boolean'];
  isModalOpen: Scalars['Boolean'];
  progressPercent: Scalars['Int'];
  skippedSteps: Array<Scalars['String']>;
  uploadedInvoicesCount: Scalars['Int'];
}

export interface VenueWithRoleObjectType {
  __typename?: 'VenueWithRoleObjectType';
  role: UserRole;
  venue: Venue;
}

export interface VenueWithSubscriptionData {
  __typename?: 'VenueWithSubscriptionData';
  address?: Maybe<Scalars['String']>;
  agnisRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  allowLaborInvoiceCategorization?: Maybe<Scalars['Boolean']>;
  altoRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use invoiceApprovalMode */
  alwaysRequireManualInvoiceApproval?: Maybe<Scalars['Boolean']>;
  autoCategorizationMigrationComplete?: Maybe<Scalars['Boolean']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bizimplyLabourCostAutomationEnabled?: Maybe<Scalars['Boolean']>;
  cashflowDisabled?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  crmLink?: Maybe<Scalars['String']>;
  cultureCode: CultureCode;
  currentSubscriptionPlanType?: Maybe<SubscriptionPlanType>;
  defaultTimezone: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  dishboardCsvRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  district?: Maybe<Scalars['String']>;
  einvoicingEnabled: Scalars['Boolean'];
  forwardingEmails?: Maybe<Scalars['String']>;
  halberstatRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceApprovalMode: InvoiceApprovalMode;
  invoiceEmail: Scalars['String'];
  isCashflowSandboxAvailable?: Maybe<Scalars['Boolean']>;
  isOnboardingComplete?: Maybe<Scalars['Boolean']>;
  isTest: Scalars['Boolean'];
  issuedInvoiceAdditionalSupplierIds?: Maybe<Array<Scalars['String']>>;
  languageCode: CultureCode;
  legalEntity: LegalEntity;
  manualApprovalRules: Array<ManualApprovalRule>;
  name: Scalars['String'];
  noVatAvailable?: Maybe<Scalars['Boolean']>;
  noVatMode?: Maybe<Scalars['Boolean']>;
  notificationEmails?: Maybe<Scalars['String']>;
  paymentFailureGracePeriodDays?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  reportingMode?: Maybe<ReportingMode>;
  septimRevenueAutomationEnabled?: Maybe<Scalars['Boolean']>;
  stripeCouponId?: Maybe<Scalars['String']>;
  subscriptionsData?: Maybe<Array<SubscriptionData>>;
  useAutoCategorization?: Maybe<Scalars['Boolean']>;
  useNewExpenseArchitecture?: Maybe<Scalars['Boolean']>;
  vatCustomPeriodEnd?: Maybe<Scalars['Date']>;
  vatCustomPeriodStart?: Maybe<Scalars['Date']>;
  vatReportingPeriod?: Maybe<VatReportingPeriod>;
}

export interface WarehouseInventoryValue {
  __typename?: 'WarehouseInventoryValue';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  month: Scalars['Int'];
  monthEndValue?: Maybe<Scalars['Int']>;
  monthStartValue?: Maybe<Scalars['Int']>;
  venueId: Scalars['ID'];
  year: Scalars['Int'];
}

export interface WarehouseInventoryValueGroup {
  __typename?: 'WarehouseInventoryValueGroup';
  month: Scalars['Int'];
  monthEndValue?: Maybe<Scalars['Int']>;
  monthStartValue?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
}

export interface XeroConnectionObjectType {
  __typename?: 'XeroConnectionObjectType';
  businessConnections: Array<BusinessConnection>;
  defaultDocumentStatus?: Maybe<XeroDocumentStatus>;
  isConnected: Scalars['Boolean'];
  shouldReconnect: Scalars['Boolean'];
}

export enum XeroDocumentStatus {
  Authorised = 'AUTHORISED',
  Draft = 'DRAFT',
}

export interface XeroExportFailureObjectType {
  __typename?: 'XeroExportFailureObjectType';
  error: Scalars['String'];
  expenseId: Scalars['String'];
  invoiceNumber: Scalars['String'];
  supplierName: Scalars['String'];
}

export interface XeroIntegrationData {
  __typename?: 'XeroIntegrationData';
  businessEntityId: Scalars['ID'];
  createdAt: Scalars['Date'];
  defaultDocumentStatus: XeroDocumentStatus;
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  refreshTokenEndDate: Scalars['Date'];
  trackingCategories?: Maybe<Array<XeroTrackingCategory>>;
}

export interface XeroNotification {
  __typename?: 'XeroNotification';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  venueId: Scalars['ID'];
}

export interface XeroTrackingCategory {
  __typename?: 'XeroTrackingCategory';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  options: Array<XeroTrackingOption>;
  status: TrackingStatus;
  trackingCategoryId: Scalars['String'];
  xeroIntegrationData: XeroIntegrationData;
}

export interface XeroTrackingCategoryObjectType {
  __typename?: 'XeroTrackingCategoryObjectType';
  name: Scalars['String'];
  options: Array<XeroTrackingOptionObjectType>;
  status: TrackingStatus;
  trackingCategoryId: Scalars['String'];
}

export interface XeroTrackingOption {
  __typename?: 'XeroTrackingOption';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasValidationErrors: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  status: TrackingStatus;
  trackingCategory: XeroTrackingCategory;
  trackingOptionId: Scalars['String'];
}

export interface XeroTrackingOptionObjectType {
  __typename?: 'XeroTrackingOptionObjectType';
  hasValidationErrors: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  status: TrackingStatus;
  trackingOptionId: Scalars['String'];
}

export type CurrentUserFragment = {
  __typename?: 'CurrentUserObjectType';
  client_id: string;
  given_name: string;
  family_name: string;
  email: string;
  zoneinfo: string;
  cultureCode: CultureCode;
  languageCode: CultureCode;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type CheckAuthStateMutationVariables = Exact<{ [key: string]: never }>;

export type CheckAuthStateMutation = {
  __typename?: 'Mutation';
  checkAuthState?: {
    __typename?: 'CurrentUserObjectType';
    client_id: string;
    given_name: string;
    family_name: string;
    email: string;
    zoneinfo: string;
    cultureCode: CultureCode;
    languageCode: CultureCode;
  } | null;
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'CurrentUserObjectType';
    client_id: string;
    given_name: string;
    family_name: string;
    email: string;
    zoneinfo: string;
    cultureCode: CultureCode;
    languageCode: CultureCode;
  };
};

export type RegenTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RegenTokenMutation = {
  __typename?: 'Mutation';
  regenToken: {
    __typename?: 'CurrentUserObjectType';
    client_id: string;
    given_name: string;
    family_name: string;
    email: string;
    zoneinfo: string;
    cultureCode: CultureCode;
    languageCode: CultureCode;
  };
};

export type BeginAdminMfaEnrollmentMutationVariables = Exact<{
  [key: string]: never;
}>;

export type BeginAdminMfaEnrollmentMutation = {
  __typename?: 'Mutation';
  beginAdminMfaEnrollment: {
    __typename?: 'AdminMfaEnrollmentBeginObjectType';
    otpauthUri: string;
    qrCodeDataUrl: string;
    secret: string;
  };
};

export type ConfirmAdminMfaEnrollmentMutationVariables = Exact<{
  code: Scalars['String'];
}>;

export type ConfirmAdminMfaEnrollmentMutation = {
  __typename?: 'Mutation';
  confirmAdminMfaEnrollment: {
    __typename?: 'AdminMfaBackupCodesObjectType';
    backupCodes: Array<string>;
  };
};

export type VerifyAdminMfaMutationVariables = Exact<{
  code: Scalars['String'];
}>;

export type VerifyAdminMfaMutation = {
  __typename?: 'Mutation';
  verifyAdminMfa: boolean;
};

export type VerifyAdminMfaBackupCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;

export type VerifyAdminMfaBackupCodeMutation = {
  __typename?: 'Mutation';
  verifyAdminMfaBackupCode: boolean;
};

export type ResetOwnAdminMfaMutationVariables = Exact<{
  backupCode: Scalars['String'];
}>;

export type ResetOwnAdminMfaMutation = {
  __typename?: 'Mutation';
  resetOwnAdminMfa: boolean;
};

export type CurrentUserAdminPermissionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentUserAdminPermissionsQuery = {
  __typename?: 'Query';
  adminPermissions: {
    __typename?: 'AdminAccount';
    id: string;
    accountId: string;
    canCreateNewVenues: boolean;
    canMoveVenueToPaywall: boolean;
    canModifyInvoiceLimit: boolean;
    canModifyCostRadarTrial: boolean;
    canConnectStoryousIntegration: boolean;
    canManageVenues: boolean;
    canCreateCustomCheckout: boolean;
    canManageInvoiceBilling: boolean;
    canManageSupplierIntegrations: boolean;
    canModifyPaymentFailureGracePeriod: boolean;
    canMigrateAutoCategorization: boolean;
  };
};

export type AdminMfaStatusQueryVariables = Exact<{ [key: string]: never }>;

export type AdminMfaStatusQuery = {
  __typename?: 'Query';
  adminMfaStatus: {
    __typename?: 'AdminMfaStatusObjectType';
    isAdmin: boolean;
    enrolled: boolean;
    verified: boolean;
    isServiceAccount: boolean;
  };
};

export type UpdateCostRadarSubscriptionMutationVariables = Exact<{
  venueId: Scalars['String'];
  state: CostRadarSubscriptionState;
  trialExpiresAt?: InputMaybe<Scalars['Float']>;
}>;

export type UpdateCostRadarSubscriptionMutation = {
  __typename?: 'Mutation';
  updateCostRadarSubscription: {
    __typename?: 'CostRadarSubscription';
    id: string;
    trialStartedAt?: any | null;
    trialExpiresAt?: any | null;
    state: CostRadarSubscriptionState;
    venueId: string;
  };
};

export type CostRadarSubscriptionByVenueQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type CostRadarSubscriptionByVenueQuery = {
  __typename?: 'Query';
  costRadarSubscriptionByVenue?: {
    __typename?: 'CostRadarSubscription';
    id: string;
    trialStartedAt?: any | null;
    trialExpiresAt?: any | null;
    paidAt?: any | null;
    state: CostRadarSubscriptionState;
    venueId: string;
  } | null;
};

export type CreateCustomCheckoutLinkMutationVariables = Exact<{
  input: CreateCustomCheckoutInput;
}>;

export type CreateCustomCheckoutLinkMutation = {
  __typename?: 'Mutation';
  createCustomCheckoutLink: string;
};

export type VenueDetailsForCheckoutQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type VenueDetailsForCheckoutQuery = {
  __typename?: 'Query';
  venueDetailsForCheckout?: {
    __typename?: 'Venue';
    id: string;
    name: string;
    legalEntity: { __typename?: 'LegalEntity'; country: CountryCode };
  } | null;
  venueUsersForCheckout: Array<{
    __typename?: 'User';
    id: string;
    roleName: UserRole;
    account: {
      __typename?: 'Account';
      id: string;
      email: string;
      firstName: string;
      lastName: string;
    };
  }>;
};

export type SyncFakturoidCompanyDetailsMutationVariables = Exact<{
  venueIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;

export type SyncFakturoidCompanyDetailsMutation = {
  __typename?: 'Mutation';
  syncFakturoidCompanyDetails: {
    __typename?: 'SyncFakturoidCompanyDetailsResultObjectType';
    synced: number;
    failed: number;
  };
};

export type AssignPeppolInboxMutationVariables = Exact<{
  input: AssignPeppolInboxInput;
}>;

export type AssignPeppolInboxMutation = {
  __typename?: 'Mutation';
  assignPeppolInbox: {
    __typename?: 'LegalEntity';
    id: string;
    peppolParticipantId?: string | null;
  };
};

export type UnassignPeppolVenueMutationVariables = Exact<{
  venueId: Scalars['ID'];
}>;

export type UnassignPeppolVenueMutation = {
  __typename?: 'Mutation';
  unassignPeppolVenue: boolean;
};

export type UnassignPeppolInboxMutationVariables = Exact<{
  peppolParticipantId: Scalars['String'];
}>;

export type UnassignPeppolInboxMutation = {
  __typename?: 'Mutation';
  unassignPeppolInbox: boolean;
};

export type DenyPeppolRegistrationMutationVariables = Exact<{
  registrationId: Scalars['ID'];
}>;

export type DenyPeppolRegistrationMutation = {
  __typename?: 'Mutation';
  denyPeppolRegistration: boolean;
};

export type AcceptPeppolRegistrationMutationVariables = Exact<{
  registrationId: Scalars['ID'];
}>;

export type AcceptPeppolRegistrationMutation = {
  __typename?: 'Mutation';
  acceptPeppolRegistration: boolean;
};

export type EinvoicingAdminDataQueryVariables = Exact<{ [key: string]: never }>;

export type EinvoicingAdminDataQuery = {
  __typename?: 'Query';
  einvoicingAdminVenues: Array<{
    __typename?: 'EinvoicingAdminVenue';
    id: string;
    name: string;
    connected: boolean;
    peppolParticipantId?: string | null;
    ico?: string | null;
    dic?: string | null;
  }>;
  einvoicingAdminInboxes: Array<{
    __typename?: 'EinvoicingAdminInbox';
    registrationId?: string | null;
    peppolParticipantId?: string | null;
    legalName?: string | null;
    ico?: string | null;
    dic?: string | null;
    status?: PeppolRegistrationStatus | null;
    connected: boolean;
    venueNames: Array<string>;
  }>;
  peppolRegistrationQueue: Array<{
    __typename?: 'PeppolRegistrationQueueItem';
    id: string;
    legalName?: string | null;
    ico?: string | null;
    dic?: string | null;
    peppolParticipantId?: string | null;
    matchResult: PeppolRegistrationMatchResult;
    receivedAt: any;
  }>;
};

export type UpdateVenueGracePeriodMutationVariables = Exact<{
  venueId: Scalars['String'];
  gracePeriodDays?: InputMaybe<Scalars['Int']>;
}>;

export type UpdateVenueGracePeriodMutation = {
  __typename?: 'Mutation';
  updateVenueGracePeriod: {
    __typename?: 'Venue';
    id: string;
    name: string;
    paymentFailureGracePeriodDays?: number | null;
  };
};

export type VenueGracePeriodInfoQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type VenueGracePeriodInfoQuery = {
  __typename?: 'Query';
  venueGracePeriodInfo: {
    __typename?: 'AdminVenueGracePeriodObjectType';
    gracePeriodDays?: number | null;
    hasPaymentFailure: boolean;
    paymentFailureStartedAt?: string | null;
    daysRemaining?: number | null;
    isLockedOut: boolean;
    paymentType?: string | null;
    overdueInvoiceAmount?: number | null;
    overdueInvoiceCurrency?: string | null;
    overdueInvoiceDueDate?: string | null;
    overdueInvoiceVariableSymbol?: string | null;
  };
};

export type PaymentFailureGracePeriodDefaultQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PaymentFailureGracePeriodDefaultQuery = {
  __typename?: 'Query';
  paymentFailureGracePeriodDefault: number;
};

export type VenuesQueryVariables = Exact<{ [key: string]: never }>;

export type VenuesQuery = {
  __typename?: 'Query';
  venues: Array<{
    __typename?: 'VenueWithSubscriptionData';
    id: string;
    name: string;
    useAutoCategorization?: boolean | null;
  }>;
};

export type SetupInvoiceBillingMutationVariables = Exact<{
  input: SetupInvoiceBillingInput;
}>;

export type SetupInvoiceBillingMutation = {
  __typename?: 'Mutation';
  setupInvoiceBilling: {
    __typename?: 'InvoiceBillingStatus';
    isEnabled: boolean;
    externalCustomerId?: string | null;
    isLegalDataFilledIn?: boolean | null;
    venueId?: string | null;
    hasStripeBilling: boolean;
  };
};

export type InvoiceBillingStatusQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type InvoiceBillingStatusQuery = {
  __typename?: 'Query';
  invoiceBillingStatus: {
    __typename?: 'InvoiceBillingStatus';
    isEnabled: boolean;
    externalCustomerId?: string | null;
    isLegalDataFilledIn?: boolean | null;
    venueId?: string | null;
    hasStripeBilling: boolean;
  };
};

export type CreatePendingAccountMutationVariables = Exact<{
  venueName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  country: CountryCode;
  isTest?: InputMaybe<Scalars['Boolean']>;
  crmLink?: InputMaybe<Scalars['String']>;
  useAutoCategorization?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreatePendingAccountMutation = {
  __typename?: 'Mutation';
  createPendingAccount: {
    __typename?: 'AdminPendingNewAccount';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    isSent: boolean;
    adminAccountId: string;
    venue: {
      __typename?: 'Venue';
      id: string;
      name: string;
      crmLink?: string | null;
      legalEntity: { __typename?: 'LegalEntity'; country: CountryCode };
    };
  };
};

export type EditPendingAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  venueName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  country: CountryCode;
  crmLink?: InputMaybe<Scalars['String']>;
}>;

export type EditPendingAccountMutation = {
  __typename?: 'Mutation';
  editPendingAccount: {
    __typename?: 'AdminPendingNewAccount';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    isSent: boolean;
    adminAccountId: string;
    venue: {
      __typename?: 'Venue';
      id: string;
      name: string;
      crmLink?: string | null;
      legalEntity: { __typename?: 'LegalEntity'; country: CountryCode };
    };
  };
};

export type ArchivePendingAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ArchivePendingAccountMutation = {
  __typename?: 'Mutation';
  archivePendingAccount: {
    __typename?: 'AdminPendingNewAccount';
    id: string;
    deletedAt?: any | null;
  };
};

export type UnarchivePendingAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UnarchivePendingAccountMutation = {
  __typename?: 'Mutation';
  unarchivePendingAccount: {
    __typename?: 'AdminPendingNewAccount';
    id: string;
    deletedAt?: any | null;
  };
};

export type ConfirmPendingAccountMutationVariables = Exact<{
  pendingAccountId: Scalars['ID'];
  doesAccountExist: Scalars['Boolean'];
}>;

export type ConfirmPendingAccountMutation = {
  __typename?: 'Mutation';
  confirmPendingAccount: {
    __typename?: 'AdminPendingNewAccount';
    id: string;
    isSent: boolean;
  };
};

export type ExistingAccountByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type ExistingAccountByEmailQuery = {
  __typename?: 'Query';
  existingAccountByEmail?: {
    __typename?: 'ExistingAccountObjectType';
    accountId: string;
    email: string;
    firstName: string;
    lastName: string;
    venueNames: Array<string>;
    isDeleted: boolean;
  } | null;
};

export type PendingAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type PendingAccountsQuery = {
  __typename?: 'Query';
  pendingAccounts: Array<{
    __typename?: 'AdminPendingNewAccount';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    isSent: boolean;
    adminAccountId: string;
    deletedAt?: any | null;
    createdAt: any;
    venue: {
      __typename?: 'Venue';
      id: string;
      name: string;
      isTest: boolean;
      crmLink?: string | null;
      legalEntity: { __typename?: 'LegalEntity'; country: CountryCode };
    };
  }>;
};

export type MoveVenueToPaywallMutationVariables = Exact<{
  venueId: Scalars['String'];
  force: Scalars['Boolean'];
}>;

export type MoveVenueToPaywallMutation = {
  __typename?: 'Mutation';
  moveVenueToPaywall: {
    __typename?: 'SubscriptionData';
    id: string;
    start: any;
    end?: any | null;
    subscriptionPlanType: SubscriptionPlanType;
    pricingModelVersion: PricingModelVersion;
    invoiceRecognitionsPerMonth?: number | null;
    subscriptionPeriod?: SubscriptionPeriod | null;
  };
};

export type SubscriptionDataQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type SubscriptionDataQuery = {
  __typename?: 'Query';
  subscriptionData: {
    __typename?: 'SubscriptionDataObjectType';
    id: string;
    start: any;
    end?: any | null;
    pricingModelVersion: PricingModelVersion;
    subscriptionPlanType: SubscriptionPlanType;
    subscriptionPeriod?: SubscriptionPeriod | null;
    invoiceRecognitionsPerMonth: number;
    overrideAutomaticUpdates?: boolean | null;
  };
};

export type ConnectStoryousIntegrationMutationVariables = Exact<{
  venueId: Scalars['ID'];
  merchantId: Scalars['String'];
  placeId: Scalars['String'];
  startDate: Scalars['String'];
  skipIcoValidation?: InputMaybe<Scalars['Boolean']>;
}>;

export type ConnectStoryousIntegrationMutation = {
  __typename?: 'Mutation';
  connectStoryousIntegration: {
    __typename?: 'Integration';
    id: string;
    provider: IntegrationProvider;
  };
};

export type MarkStoryousIntegrationRequestCompletedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MarkStoryousIntegrationRequestCompletedMutation = {
  __typename?: 'Mutation';
  markStoryousIntegrationRequestCompleted: {
    __typename?: 'IntegrationRequest';
    id: string;
    status: IntegrationRequestStatus;
    completedAt?: any | null;
  };
};

export type RejectStoryousIntegrationRequestMutationVariables = Exact<{
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
}>;

export type RejectStoryousIntegrationRequestMutation = {
  __typename?: 'Mutation';
  rejectStoryousIntegrationRequest: {
    __typename?: 'IntegrationRequest';
    id: string;
    status: IntegrationRequestStatus;
    completedAt?: any | null;
    notes?: string | null;
  };
};

export type AvailableStoryousInstancesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableStoryousInstancesQuery = {
  __typename?: 'Query';
  availableStoryousInstances: Array<{
    __typename?: 'StoryousMerchantPlace';
    merchantId: string;
    merchantName: string;
    placeId: string;
    placeName: string;
    placeState: string;
    businessId?: string | null;
    city?: string | null;
    country?: string | null;
    isAlreadyConnected: boolean;
    connectedVenueName?: string | null;
    connectedVenueId?: string | null;
  }>;
};

export type StoryousMatchSuggestionsQueryVariables = Exact<{
  venueId: Scalars['ID'];
  searchTerm?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  venueName?: InputMaybe<Scalars['String']>;
}>;

export type StoryousMatchSuggestionsQuery = {
  __typename?: 'Query';
  storyousMatchSuggestions: Array<{
    __typename?: 'StoryousMatchSuggestion';
    matchScore: number;
    matchedOn: string;
    icoMatch: boolean;
    merchantPlace: {
      __typename?: 'StoryousMerchantPlace';
      merchantId: string;
      merchantName: string;
      placeId: string;
      placeName: string;
      placeState: string;
      businessId?: string | null;
      city?: string | null;
      country?: string | null;
      isAlreadyConnected: boolean;
      connectedVenueName?: string | null;
      connectedVenueId?: string | null;
    };
  }>;
};

export type VenuesForStoryousConnectionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VenuesForStoryousConnectionQuery = {
  __typename?: 'Query';
  venuesForStoryousConnection: Array<{
    __typename?: 'VenueForStoryousConnection';
    id: string;
    name: string;
    ico?: string | null;
    icoSource?: IcoSource | null;
    legalName?: string | null;
    existingStoryousConnections: Array<{
      __typename?: 'StoryousExistingConnection';
      merchantId: string;
      placeId: string;
      placeName: string;
    }>;
  }>;
};

export type PendingStoryousIntegrationRequestsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PendingStoryousIntegrationRequestsQuery = {
  __typename?: 'Query';
  pendingStoryousIntegrationRequests: Array<{
    __typename?: 'IntegrationRequest';
    id: string;
    createdAt: any;
    venueId: string;
    accountId: string;
    provider: IntegrationProvider;
    startDate: any;
    status: IntegrationRequestStatus;
    venue: {
      __typename?: 'Venue';
      id: string;
      name: string;
      legalEntity: {
        __typename?: 'LegalEntity';
        legalName?: string | null;
        companyIdentificationNumber?: string | null;
      };
    };
    account: { __typename?: 'Account'; email: string };
  }>;
};

export type UpdateVenueInvoiceLimitMutationVariables = Exact<{
  venueId: Scalars['String'];
  invoiceLimit?: InputMaybe<Scalars['Int']>;
  costRadarLimit?: InputMaybe<Scalars['Int']>;
  planType?: InputMaybe<SubscriptionPlanType>;
  fromNextCycle?: InputMaybe<Scalars['Boolean']>;
  oneTime?: InputMaybe<Scalars['Boolean']>;
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateVenueInvoiceLimitMutation = {
  __typename?: 'Mutation';
  updateVenueInvoiceLimit: {
    __typename?: 'SubscriptionData';
    id: string;
    start: any;
    end?: any | null;
    subscriptionPlanType: SubscriptionPlanType;
    pricingModelVersion: PricingModelVersion;
    invoiceRecognitionsPerMonth?: number | null;
    orderItemsPerMonth?: number | null;
    subscriptionPeriod?: SubscriptionPeriod | null;
  };
};

export type EnableVenueAutoCategorizationMutationVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type EnableVenueAutoCategorizationMutation = {
  __typename?: 'Mutation';
  enableVenueAutoCategorization: {
    __typename?: 'Venue';
    id: string;
    useAutoCategorization?: boolean | null;
  };
};

export type UpdateVenueRenewalDayMutationVariables = Exact<{
  venueId: Scalars['String'];
  renewalDay: Scalars['Int'];
  fromNextCycle?: InputMaybe<Scalars['Boolean']>;
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateVenueRenewalDayMutation = {
  __typename?: 'Mutation';
  updateVenueRenewalDay: {
    __typename?: 'SubscriptionData';
    id: string;
    start: any;
    end?: any | null;
    subscriptionPlanType: SubscriptionPlanType;
    pricingModelVersion: PricingModelVersion;
    invoiceRecognitionsPerMonth?: number | null;
    orderItemsPerMonth?: number | null;
    subscriptionPeriod?: SubscriptionPeriod | null;
  };
};

export type LinkVenueBillingAccountMutationVariables = Exact<{
  venueId: Scalars['String'];
  billingMethod: BillingMethod;
  externalLink: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
}>;

export type LinkVenueBillingAccountMutation = {
  __typename?: 'Mutation';
  linkVenueBillingAccount: boolean;
};

export type SubscriptionLimitDataQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type SubscriptionLimitDataQuery = {
  __typename?: 'Query';
  subscriptionData: {
    __typename?: 'SubscriptionDataObjectType';
    id: string;
    start: any;
    end?: any | null;
    subscriptionPlanType: SubscriptionPlanType;
    subscriptionPeriod?: SubscriptionPeriod | null;
    pricingModelVersion: PricingModelVersion;
    invoiceRecognitionsPerMonth: number;
    orderItemsPerMonth: number;
  };
};

export type VenuesForSubscriptionLimitQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VenuesForSubscriptionLimitQuery = {
  __typename?: 'Query';
  venues: Array<{
    __typename?: 'VenueWithSubscriptionData';
    id: string;
    name: string;
    isTest: boolean;
    useAutoCategorization?: boolean | null;
  }>;
};

export type PricingDataQueryVariables = Exact<{ [key: string]: never }>;

export type PricingDataQuery = {
  __typename?: 'Query';
  getPricingData: {
    __typename?: 'PricingDataObjectType';
    subscriptionTiers: Array<{
      __typename?: 'PlanOptionObjectType';
      type: SubscriptionPlanType;
      value: string;
    }>;
  };
};

export type FutureSubscriptionsQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type FutureSubscriptionsQuery = {
  __typename?: 'Query';
  futureSubscriptions: Array<{
    __typename?: 'SubscriptionData';
    id: string;
    start: any;
    end?: any | null;
    subscriptionPlanType: SubscriptionPlanType;
    pricingModelVersion: PricingModelVersion;
    invoiceRecognitionsPerMonth?: number | null;
    orderItemsPerMonth?: number | null;
  }>;
};

export type VenueUsersForBillingLinkQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type VenueUsersForBillingLinkQuery = {
  __typename?: 'Query';
  venueUsersForBillingLink: Array<{
    __typename?: 'User';
    id: string;
    roleName: UserRole;
    account: {
      __typename?: 'Account';
      id: string;
      email: string;
      firstName: string;
      lastName: string;
    };
  }>;
};

export type CreateGlobalSupplierMutationVariables = Exact<{
  name: Scalars['String'];
  contactEmail: Scalars['String'];
  emailDomain?: InputMaybe<Scalars['String']>;
  invoicingEmail?: InputMaybe<Scalars['String']>;
}>;

export type CreateGlobalSupplierMutation = {
  __typename?: 'Mutation';
  createGlobalSupplier: {
    __typename?: 'GlobalSupplier';
    id: string;
    name: string;
    emailDomain?: string | null;
    invoicingEmail?: string | null;
    exceptionFlag: boolean;
    exceptionReason?: string | null;
    contactEmails: Array<{
      __typename?: 'GlobalSupplierContactEmail';
      id: string;
      email: string;
    }>;
  };
};

export type UpdateGlobalSupplierMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  emailDomain?: InputMaybe<Scalars['String']>;
  invoicingEmail?: InputMaybe<Scalars['String']>;
  exceptionFlag?: InputMaybe<Scalars['Boolean']>;
  exceptionReason?: InputMaybe<Scalars['String']>;
}>;

export type UpdateGlobalSupplierMutation = {
  __typename?: 'Mutation';
  updateGlobalSupplier: {
    __typename?: 'GlobalSupplier';
    id: string;
    name: string;
    emailDomain?: string | null;
    invoicingEmail?: string | null;
    exceptionFlag: boolean;
    exceptionReason?: string | null;
    contactEmails: Array<{
      __typename?: 'GlobalSupplierContactEmail';
      id: string;
      email: string;
    }>;
  };
};

export type AddGlobalSupplierContactEmailMutationVariables = Exact<{
  supplierId: Scalars['ID'];
  email: Scalars['String'];
}>;

export type AddGlobalSupplierContactEmailMutation = {
  __typename?: 'Mutation';
  addGlobalSupplierContactEmail: {
    __typename?: 'GlobalSupplier';
    id: string;
    name: string;
    contactEmails: Array<{
      __typename?: 'GlobalSupplierContactEmail';
      id: string;
      email: string;
    }>;
  };
};

export type InitiateSupplierIntegrationsMutationVariables = Exact<{
  venueId: Scalars['ID'];
  selections:
    | Array<SupplierIntegrationSelectionInput>
    | SupplierIntegrationSelectionInput;
}>;

export type InitiateSupplierIntegrationsMutation = {
  __typename?: 'Mutation';
  initiateSupplierIntegrations: Array<{
    __typename?: 'SupplierIntegrationRequest';
    id: string;
    venueId: string;
    globalSupplierId: string;
    contactEmail: string;
    initiatedByEmail: string;
    status: SupplierIntegrationStatus;
    isActive: boolean;
    lastContactDate: any;
    followUpsManuallyDisabledAt?: any | null;
    supplierReplyDetectedAt?: any | null;
    nextEmailInDays?: number | null;
    automatedFollowUpsStopTooltip?: string | null;
    globalSupplier: { __typename?: 'GlobalSupplier'; id: string; name: string };
  }>;
};

export type DisableAutomatedFollowUpsMutationVariables = Exact<{
  requestId: Scalars['ID'];
}>;

export type DisableAutomatedFollowUpsMutation = {
  __typename?: 'Mutation';
  disableAutomatedFollowUps: {
    __typename?: 'SupplierIntegrationRequest';
    id: string;
    followUpsManuallyDisabledAt?: any | null;
    automatedFollowUpsStopTooltip?: string | null;
    nextEmailInDays?: number | null;
  };
};

export type GlobalSuppliersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;

export type GlobalSuppliersQuery = {
  __typename?: 'Query';
  globalSuppliers: Array<{
    __typename?: 'GlobalSupplier';
    id: string;
    name: string;
    emailDomain?: string | null;
    invoicingEmail?: string | null;
    exceptionFlag: boolean;
    exceptionReason?: string | null;
    contactEmails: Array<{
      __typename?: 'GlobalSupplierContactEmail';
      id: string;
      email: string;
      globalSupplierId: string;
    }>;
  }>;
};

export type SupplierIntegrationRequestsQueryVariables = Exact<{
  venueId: Scalars['ID'];
}>;

export type SupplierIntegrationRequestsQuery = {
  __typename?: 'Query';
  supplierIntegrationRequests: Array<{
    __typename?: 'SupplierIntegrationRequest';
    id: string;
    venueId: string;
    globalSupplierId: string;
    contactEmail: string;
    initiatedByEmail: string;
    status: SupplierIntegrationStatus;
    isActive: boolean;
    lastContactDate: any;
    createdAt: any;
    followUpsManuallyDisabledAt?: any | null;
    supplierReplyDetectedAt?: any | null;
    nextEmailInDays?: number | null;
    automatedFollowUpsStopTooltip?: string | null;
    globalSupplier: {
      __typename?: 'GlobalSupplier';
      id: string;
      name: string;
      emailDomain?: string | null;
      invoicingEmail?: string | null;
      exceptionFlag: boolean;
      exceptionReason?: string | null;
      contactEmails: Array<{
        __typename?: 'GlobalSupplierContactEmail';
        id: string;
        email: string;
      }>;
    };
  }>;
};

export type ExportSupplierIntegrationsCsvQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ExportSupplierIntegrationsCsvQuery = {
  __typename?: 'Query';
  exportSupplierIntegrationsCsv: string;
};

export type VenuesForSupplierIntegrationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VenuesForSupplierIntegrationsQuery = {
  __typename?: 'Query';
  adminVenues: Array<{
    __typename?: 'Venue';
    id: string;
    name: string;
    city?: string | null;
    invoiceEmail: string;
  }>;
};

export type UpdateVenueAdminMutationVariables = Exact<{
  venueId: Scalars['String'];
  input: UpdateVenueAdminInput;
}>;

export type UpdateVenueAdminMutation = {
  __typename?: 'Mutation';
  updateVenueAdmin: {
    __typename?: 'Venue';
    id: string;
    name: string;
    isTest: boolean;
    stripeCouponId?: string | null;
    crmLink?: string | null;
  };
};

export type VenueForManagementQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;

export type VenueForManagementQuery = {
  __typename?: 'Query';
  venueForManagement?: {
    __typename?: 'Venue';
    id: string;
    name: string;
    isTest: boolean;
    stripeCouponId?: string | null;
    crmLink?: string | null;
    city?: string | null;
    legalEntity: {
      __typename?: 'LegalEntity';
      legalName?: string | null;
      country: CountryCode;
    };
  } | null;
};

export const CurrentUserFragmentDoc = gql`
  fragment CurrentUser on CurrentUserObjectType {
    client_id
    given_name
    family_name
    email
    zoneinfo
    cultureCode
    languageCode
  }
`;
export const LogoutDocument = gql`
  mutation Logout {
    logout
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<
  LogoutMutation,
  LogoutMutationVariables
>;
export type LogoutComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    LogoutMutation,
    LogoutMutationVariables
  >,
  'mutation'
>;

export const LogoutComponent = (props: LogoutComponentProps) => (
  <ApolloReactComponents.Mutation<LogoutMutation, LogoutMutationVariables>
    mutation={LogoutDocument}
    {...props}
  />
);

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options,
  );
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>;
export const CheckAuthStateDocument = gql`
  mutation CheckAuthState {
    checkAuthState {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`;
export type CheckAuthStateMutationFn = Apollo.MutationFunction<
  CheckAuthStateMutation,
  CheckAuthStateMutationVariables
>;
export type CheckAuthStateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CheckAuthStateMutation,
    CheckAuthStateMutationVariables
  >,
  'mutation'
>;

export const CheckAuthStateComponent = (
  props: CheckAuthStateComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CheckAuthStateMutation,
    CheckAuthStateMutationVariables
  >
    mutation={CheckAuthStateDocument}
    {...props}
  />
);

/**
 * __useCheckAuthStateMutation__
 *
 * To run a mutation, you first call `useCheckAuthStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckAuthStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkAuthStateMutation, { data, loading, error }] = useCheckAuthStateMutation({
 *   variables: {
 *   },
 * });
 */
export function useCheckAuthStateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CheckAuthStateMutation,
    CheckAuthStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CheckAuthStateMutation,
    CheckAuthStateMutationVariables
  >(CheckAuthStateDocument, options);
}
export type CheckAuthStateMutationHookResult = ReturnType<
  typeof useCheckAuthStateMutation
>;
export type CheckAuthStateMutationResult =
  Apollo.MutationResult<CheckAuthStateMutation>;
export type CheckAuthStateMutationOptions = Apollo.BaseMutationOptions<
  CheckAuthStateMutation,
  CheckAuthStateMutationVariables
>;
export const LoginDocument = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`;
export type LoginMutationFn = Apollo.MutationFunction<
  LoginMutation,
  LoginMutationVariables
>;
export type LoginComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    LoginMutation,
    LoginMutationVariables
  >,
  'mutation'
>;

export const LoginComponent = (props: LoginComponentProps) => (
  <ApolloReactComponents.Mutation<LoginMutation, LoginMutationVariables>
    mutation={LoginDocument}
    {...props}
  />
);

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LoginMutation,
    LoginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(
    LoginDocument,
    options,
  );
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
  LoginMutation,
  LoginMutationVariables
>;
export const RegenTokenDocument = gql`
  mutation RegenToken {
    regenToken {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`;
export type RegenTokenMutationFn = Apollo.MutationFunction<
  RegenTokenMutation,
  RegenTokenMutationVariables
>;
export type RegenTokenComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RegenTokenMutation,
    RegenTokenMutationVariables
  >,
  'mutation'
>;

export const RegenTokenComponent = (props: RegenTokenComponentProps) => (
  <ApolloReactComponents.Mutation<
    RegenTokenMutation,
    RegenTokenMutationVariables
  >
    mutation={RegenTokenDocument}
    {...props}
  />
);

/**
 * __useRegenTokenMutation__
 *
 * To run a mutation, you first call `useRegenTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenTokenMutation, { data, loading, error }] = useRegenTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegenTokenMutation,
    RegenTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    RegenTokenMutation,
    RegenTokenMutationVariables
  >(RegenTokenDocument, options);
}
export type RegenTokenMutationHookResult = ReturnType<
  typeof useRegenTokenMutation
>;
export type RegenTokenMutationResult =
  Apollo.MutationResult<RegenTokenMutation>;
export type RegenTokenMutationOptions = Apollo.BaseMutationOptions<
  RegenTokenMutation,
  RegenTokenMutationVariables
>;
export const BeginAdminMfaEnrollmentDocument = gql`
  mutation BeginAdminMfaEnrollment {
    beginAdminMfaEnrollment {
      otpauthUri
      qrCodeDataUrl
      secret
    }
  }
`;
export type BeginAdminMfaEnrollmentMutationFn = Apollo.MutationFunction<
  BeginAdminMfaEnrollmentMutation,
  BeginAdminMfaEnrollmentMutationVariables
>;
export type BeginAdminMfaEnrollmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BeginAdminMfaEnrollmentMutation,
    BeginAdminMfaEnrollmentMutationVariables
  >,
  'mutation'
>;

export const BeginAdminMfaEnrollmentComponent = (
  props: BeginAdminMfaEnrollmentComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    BeginAdminMfaEnrollmentMutation,
    BeginAdminMfaEnrollmentMutationVariables
  >
    mutation={BeginAdminMfaEnrollmentDocument}
    {...props}
  />
);

/**
 * __useBeginAdminMfaEnrollmentMutation__
 *
 * To run a mutation, you first call `useBeginAdminMfaEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginAdminMfaEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginAdminMfaEnrollmentMutation, { data, loading, error }] = useBeginAdminMfaEnrollmentMutation({
 *   variables: {
 *   },
 * });
 */
export function useBeginAdminMfaEnrollmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BeginAdminMfaEnrollmentMutation,
    BeginAdminMfaEnrollmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    BeginAdminMfaEnrollmentMutation,
    BeginAdminMfaEnrollmentMutationVariables
  >(BeginAdminMfaEnrollmentDocument, options);
}
export type BeginAdminMfaEnrollmentMutationHookResult = ReturnType<
  typeof useBeginAdminMfaEnrollmentMutation
>;
export type BeginAdminMfaEnrollmentMutationResult =
  Apollo.MutationResult<BeginAdminMfaEnrollmentMutation>;
export type BeginAdminMfaEnrollmentMutationOptions = Apollo.BaseMutationOptions<
  BeginAdminMfaEnrollmentMutation,
  BeginAdminMfaEnrollmentMutationVariables
>;
export const ConfirmAdminMfaEnrollmentDocument = gql`
  mutation ConfirmAdminMfaEnrollment($code: String!) {
    confirmAdminMfaEnrollment(code: $code) {
      backupCodes
    }
  }
`;
export type ConfirmAdminMfaEnrollmentMutationFn = Apollo.MutationFunction<
  ConfirmAdminMfaEnrollmentMutation,
  ConfirmAdminMfaEnrollmentMutationVariables
>;
export type ConfirmAdminMfaEnrollmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConfirmAdminMfaEnrollmentMutation,
    ConfirmAdminMfaEnrollmentMutationVariables
  >,
  'mutation'
>;

export const ConfirmAdminMfaEnrollmentComponent = (
  props: ConfirmAdminMfaEnrollmentComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    ConfirmAdminMfaEnrollmentMutation,
    ConfirmAdminMfaEnrollmentMutationVariables
  >
    mutation={ConfirmAdminMfaEnrollmentDocument}
    {...props}
  />
);

/**
 * __useConfirmAdminMfaEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmAdminMfaEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAdminMfaEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAdminMfaEnrollmentMutation, { data, loading, error }] = useConfirmAdminMfaEnrollmentMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmAdminMfaEnrollmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfirmAdminMfaEnrollmentMutation,
    ConfirmAdminMfaEnrollmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ConfirmAdminMfaEnrollmentMutation,
    ConfirmAdminMfaEnrollmentMutationVariables
  >(ConfirmAdminMfaEnrollmentDocument, options);
}
export type ConfirmAdminMfaEnrollmentMutationHookResult = ReturnType<
  typeof useConfirmAdminMfaEnrollmentMutation
>;
export type ConfirmAdminMfaEnrollmentMutationResult =
  Apollo.MutationResult<ConfirmAdminMfaEnrollmentMutation>;
export type ConfirmAdminMfaEnrollmentMutationOptions =
  Apollo.BaseMutationOptions<
    ConfirmAdminMfaEnrollmentMutation,
    ConfirmAdminMfaEnrollmentMutationVariables
  >;
export const VerifyAdminMfaDocument = gql`
  mutation VerifyAdminMfa($code: String!) {
    verifyAdminMfa(code: $code)
  }
`;
export type VerifyAdminMfaMutationFn = Apollo.MutationFunction<
  VerifyAdminMfaMutation,
  VerifyAdminMfaMutationVariables
>;
export type VerifyAdminMfaComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    VerifyAdminMfaMutation,
    VerifyAdminMfaMutationVariables
  >,
  'mutation'
>;

export const VerifyAdminMfaComponent = (
  props: VerifyAdminMfaComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    VerifyAdminMfaMutation,
    VerifyAdminMfaMutationVariables
  >
    mutation={VerifyAdminMfaDocument}
    {...props}
  />
);

/**
 * __useVerifyAdminMfaMutation__
 *
 * To run a mutation, you first call `useVerifyAdminMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAdminMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAdminMfaMutation, { data, loading, error }] = useVerifyAdminMfaMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyAdminMfaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyAdminMfaMutation,
    VerifyAdminMfaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    VerifyAdminMfaMutation,
    VerifyAdminMfaMutationVariables
  >(VerifyAdminMfaDocument, options);
}
export type VerifyAdminMfaMutationHookResult = ReturnType<
  typeof useVerifyAdminMfaMutation
>;
export type VerifyAdminMfaMutationResult =
  Apollo.MutationResult<VerifyAdminMfaMutation>;
export type VerifyAdminMfaMutationOptions = Apollo.BaseMutationOptions<
  VerifyAdminMfaMutation,
  VerifyAdminMfaMutationVariables
>;
export const VerifyAdminMfaBackupCodeDocument = gql`
  mutation VerifyAdminMfaBackupCode($code: String!) {
    verifyAdminMfaBackupCode(code: $code)
  }
`;
export type VerifyAdminMfaBackupCodeMutationFn = Apollo.MutationFunction<
  VerifyAdminMfaBackupCodeMutation,
  VerifyAdminMfaBackupCodeMutationVariables
>;
export type VerifyAdminMfaBackupCodeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    VerifyAdminMfaBackupCodeMutation,
    VerifyAdminMfaBackupCodeMutationVariables
  >,
  'mutation'
>;

export const VerifyAdminMfaBackupCodeComponent = (
  props: VerifyAdminMfaBackupCodeComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    VerifyAdminMfaBackupCodeMutation,
    VerifyAdminMfaBackupCodeMutationVariables
  >
    mutation={VerifyAdminMfaBackupCodeDocument}
    {...props}
  />
);

/**
 * __useVerifyAdminMfaBackupCodeMutation__
 *
 * To run a mutation, you first call `useVerifyAdminMfaBackupCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAdminMfaBackupCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAdminMfaBackupCodeMutation, { data, loading, error }] = useVerifyAdminMfaBackupCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyAdminMfaBackupCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyAdminMfaBackupCodeMutation,
    VerifyAdminMfaBackupCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    VerifyAdminMfaBackupCodeMutation,
    VerifyAdminMfaBackupCodeMutationVariables
  >(VerifyAdminMfaBackupCodeDocument, options);
}
export type VerifyAdminMfaBackupCodeMutationHookResult = ReturnType<
  typeof useVerifyAdminMfaBackupCodeMutation
>;
export type VerifyAdminMfaBackupCodeMutationResult =
  Apollo.MutationResult<VerifyAdminMfaBackupCodeMutation>;
export type VerifyAdminMfaBackupCodeMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyAdminMfaBackupCodeMutation,
    VerifyAdminMfaBackupCodeMutationVariables
  >;
export const ResetOwnAdminMfaDocument = gql`
  mutation ResetOwnAdminMfa($backupCode: String!) {
    resetOwnAdminMfa(backupCode: $backupCode)
  }
`;
export type ResetOwnAdminMfaMutationFn = Apollo.MutationFunction<
  ResetOwnAdminMfaMutation,
  ResetOwnAdminMfaMutationVariables
>;
export type ResetOwnAdminMfaComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ResetOwnAdminMfaMutation,
    ResetOwnAdminMfaMutationVariables
  >,
  'mutation'
>;

export const ResetOwnAdminMfaComponent = (
  props: ResetOwnAdminMfaComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    ResetOwnAdminMfaMutation,
    ResetOwnAdminMfaMutationVariables
  >
    mutation={ResetOwnAdminMfaDocument}
    {...props}
  />
);

/**
 * __useResetOwnAdminMfaMutation__
 *
 * To run a mutation, you first call `useResetOwnAdminMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOwnAdminMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOwnAdminMfaMutation, { data, loading, error }] = useResetOwnAdminMfaMutation({
 *   variables: {
 *      backupCode: // value for 'backupCode'
 *   },
 * });
 */
export function useResetOwnAdminMfaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResetOwnAdminMfaMutation,
    ResetOwnAdminMfaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ResetOwnAdminMfaMutation,
    ResetOwnAdminMfaMutationVariables
  >(ResetOwnAdminMfaDocument, options);
}
export type ResetOwnAdminMfaMutationHookResult = ReturnType<
  typeof useResetOwnAdminMfaMutation
>;
export type ResetOwnAdminMfaMutationResult =
  Apollo.MutationResult<ResetOwnAdminMfaMutation>;
export type ResetOwnAdminMfaMutationOptions = Apollo.BaseMutationOptions<
  ResetOwnAdminMfaMutation,
  ResetOwnAdminMfaMutationVariables
>;
export const CurrentUserAdminPermissionsDocument = gql`
  query CurrentUserAdminPermissions {
    adminPermissions {
      id
      accountId
      canCreateNewVenues
      canMoveVenueToPaywall
      canModifyInvoiceLimit
      canModifyCostRadarTrial
      canConnectStoryousIntegration
      canManageVenues
      canCreateCustomCheckout
      canManageInvoiceBilling
      canManageSupplierIntegrations
      canModifyPaymentFailureGracePeriod
      canMigrateAutoCategorization
    }
  }
`;
export type CurrentUserAdminPermissionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CurrentUserAdminPermissionsQuery,
    CurrentUserAdminPermissionsQueryVariables
  >,
  'query'
>;

export const CurrentUserAdminPermissionsComponent = (
  props: CurrentUserAdminPermissionsComponentProps,
) => (
  <ApolloReactComponents.Query<
    CurrentUserAdminPermissionsQuery,
    CurrentUserAdminPermissionsQueryVariables
  >
    query={CurrentUserAdminPermissionsDocument}
    {...props}
  />
);

/**
 * __useCurrentUserAdminPermissionsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAdminPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAdminPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAdminPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAdminPermissionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CurrentUserAdminPermissionsQuery,
    CurrentUserAdminPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    CurrentUserAdminPermissionsQuery,
    CurrentUserAdminPermissionsQueryVariables
  >(CurrentUserAdminPermissionsDocument, options);
}
export function useCurrentUserAdminPermissionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CurrentUserAdminPermissionsQuery,
    CurrentUserAdminPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    CurrentUserAdminPermissionsQuery,
    CurrentUserAdminPermissionsQueryVariables
  >(CurrentUserAdminPermissionsDocument, options);
}
export type CurrentUserAdminPermissionsQueryHookResult = ReturnType<
  typeof useCurrentUserAdminPermissionsQuery
>;
export type CurrentUserAdminPermissionsLazyQueryHookResult = ReturnType<
  typeof useCurrentUserAdminPermissionsLazyQuery
>;
export type CurrentUserAdminPermissionsQueryResult = Apollo.QueryResult<
  CurrentUserAdminPermissionsQuery,
  CurrentUserAdminPermissionsQueryVariables
>;
export function refetchCurrentUserAdminPermissionsQuery(
  variables?: CurrentUserAdminPermissionsQueryVariables,
) {
  return { query: CurrentUserAdminPermissionsDocument, variables: variables };
}
export const AdminMfaStatusDocument = gql`
  query AdminMfaStatus {
    adminMfaStatus {
      isAdmin
      enrolled
      verified
      isServiceAccount
    }
  }
`;
export type AdminMfaStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AdminMfaStatusQuery,
    AdminMfaStatusQueryVariables
  >,
  'query'
>;

export const AdminMfaStatusComponent = (
  props: AdminMfaStatusComponentProps,
) => (
  <ApolloReactComponents.Query<
    AdminMfaStatusQuery,
    AdminMfaStatusQueryVariables
  >
    query={AdminMfaStatusDocument}
    {...props}
  />
);

/**
 * __useAdminMfaStatusQuery__
 *
 * To run a query within a React component, call `useAdminMfaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMfaStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMfaStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMfaStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminMfaStatusQuery,
    AdminMfaStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminMfaStatusQuery,
    AdminMfaStatusQueryVariables
  >(AdminMfaStatusDocument, options);
}
export function useAdminMfaStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminMfaStatusQuery,
    AdminMfaStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminMfaStatusQuery,
    AdminMfaStatusQueryVariables
  >(AdminMfaStatusDocument, options);
}
export type AdminMfaStatusQueryHookResult = ReturnType<
  typeof useAdminMfaStatusQuery
>;
export type AdminMfaStatusLazyQueryHookResult = ReturnType<
  typeof useAdminMfaStatusLazyQuery
>;
export type AdminMfaStatusQueryResult = Apollo.QueryResult<
  AdminMfaStatusQuery,
  AdminMfaStatusQueryVariables
>;
export function refetchAdminMfaStatusQuery(
  variables?: AdminMfaStatusQueryVariables,
) {
  return { query: AdminMfaStatusDocument, variables: variables };
}
export const UpdateCostRadarSubscriptionDocument = gql`
  mutation UpdateCostRadarSubscription(
    $venueId: String!
    $state: CostRadarSubscriptionState!
    $trialExpiresAt: Float
  ) {
    updateCostRadarSubscription(
      venueId: $venueId
      state: $state
      trialExpiresAt: $trialExpiresAt
    ) {
      id
      trialStartedAt
      trialExpiresAt
      state
      venueId
    }
  }
`;
export type UpdateCostRadarSubscriptionMutationFn = Apollo.MutationFunction<
  UpdateCostRadarSubscriptionMutation,
  UpdateCostRadarSubscriptionMutationVariables
>;
export type UpdateCostRadarSubscriptionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCostRadarSubscriptionMutation,
    UpdateCostRadarSubscriptionMutationVariables
  >,
  'mutation'
>;

export const UpdateCostRadarSubscriptionComponent = (
  props: UpdateCostRadarSubscriptionComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateCostRadarSubscriptionMutation,
    UpdateCostRadarSubscriptionMutationVariables
  >
    mutation={UpdateCostRadarSubscriptionDocument}
    {...props}
  />
);

/**
 * __useUpdateCostRadarSubscription__
 *
 * To run a mutation, you first call `useUpdateCostRadarSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostRadarSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostRadarSubscription, { data, loading, error }] = useUpdateCostRadarSubscription({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      state: // value for 'state'
 *      trialExpiresAt: // value for 'trialExpiresAt'
 *   },
 * });
 */
export function useUpdateCostRadarSubscription(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateCostRadarSubscriptionMutation,
    UpdateCostRadarSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateCostRadarSubscriptionMutation,
    UpdateCostRadarSubscriptionMutationVariables
  >(UpdateCostRadarSubscriptionDocument, options);
}
export type UpdateCostRadarSubscriptionHookResult = ReturnType<
  typeof useUpdateCostRadarSubscription
>;
export type UpdateCostRadarSubscriptionMutationResult =
  Apollo.MutationResult<UpdateCostRadarSubscriptionMutation>;
export type UpdateCostRadarSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCostRadarSubscriptionMutation,
    UpdateCostRadarSubscriptionMutationVariables
  >;
export const CostRadarSubscriptionByVenueDocument = gql`
  query CostRadarSubscriptionByVenue($venueId: String!) {
    costRadarSubscriptionByVenue(venueId: $venueId) {
      id
      trialStartedAt
      trialExpiresAt
      paidAt
      state
      venueId
    }
  }
`;
export type CostRadarSubscriptionByVenueComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CostRadarSubscriptionByVenueQuery,
    CostRadarSubscriptionByVenueQueryVariables
  >,
  'query'
> &
  (
    | { variables: CostRadarSubscriptionByVenueQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CostRadarSubscriptionByVenueComponent = (
  props: CostRadarSubscriptionByVenueComponentProps,
) => (
  <ApolloReactComponents.Query<
    CostRadarSubscriptionByVenueQuery,
    CostRadarSubscriptionByVenueQueryVariables
  >
    query={CostRadarSubscriptionByVenueDocument}
    {...props}
  />
);

/**
 * __useCostRadarSubscriptionByVenue__
 *
 * To run a query within a React component, call `useCostRadarSubscriptionByVenue` and pass it any options that fit your needs.
 * When your component renders, `useCostRadarSubscriptionByVenue` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostRadarSubscriptionByVenue({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useCostRadarSubscriptionByVenue(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CostRadarSubscriptionByVenueQuery,
    CostRadarSubscriptionByVenueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    CostRadarSubscriptionByVenueQuery,
    CostRadarSubscriptionByVenueQueryVariables
  >(CostRadarSubscriptionByVenueDocument, options);
}
export function useCostRadarSubscriptionByVenueLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CostRadarSubscriptionByVenueQuery,
    CostRadarSubscriptionByVenueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    CostRadarSubscriptionByVenueQuery,
    CostRadarSubscriptionByVenueQueryVariables
  >(CostRadarSubscriptionByVenueDocument, options);
}
export type CostRadarSubscriptionByVenueHookResult = ReturnType<
  typeof useCostRadarSubscriptionByVenue
>;
export type CostRadarSubscriptionByVenueLazyQueryHookResult = ReturnType<
  typeof useCostRadarSubscriptionByVenueLazyQuery
>;
export type CostRadarSubscriptionByVenueQueryResult = Apollo.QueryResult<
  CostRadarSubscriptionByVenueQuery,
  CostRadarSubscriptionByVenueQueryVariables
>;
export function refetchCostRadarSubscriptionByVenue(
  variables: CostRadarSubscriptionByVenueQueryVariables,
) {
  return { query: CostRadarSubscriptionByVenueDocument, variables: variables };
}
export const CreateCustomCheckoutLinkDocument = gql`
  mutation CreateCustomCheckoutLink($input: CreateCustomCheckoutInput!) {
    createCustomCheckoutLink(input: $input)
  }
`;
export type CreateCustomCheckoutLinkMutationFn = Apollo.MutationFunction<
  CreateCustomCheckoutLinkMutation,
  CreateCustomCheckoutLinkMutationVariables
>;
export type CreateCustomCheckoutLinkComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCustomCheckoutLinkMutation,
    CreateCustomCheckoutLinkMutationVariables
  >,
  'mutation'
>;

export const CreateCustomCheckoutLinkComponent = (
  props: CreateCustomCheckoutLinkComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateCustomCheckoutLinkMutation,
    CreateCustomCheckoutLinkMutationVariables
  >
    mutation={CreateCustomCheckoutLinkDocument}
    {...props}
  />
);

/**
 * __useCreateCustomCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useCreateCustomCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomCheckoutLinkMutation, { data, loading, error }] = useCreateCustomCheckoutLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomCheckoutLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateCustomCheckoutLinkMutation,
    CreateCustomCheckoutLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateCustomCheckoutLinkMutation,
    CreateCustomCheckoutLinkMutationVariables
  >(CreateCustomCheckoutLinkDocument, options);
}
export type CreateCustomCheckoutLinkMutationHookResult = ReturnType<
  typeof useCreateCustomCheckoutLinkMutation
>;
export type CreateCustomCheckoutLinkMutationResult =
  Apollo.MutationResult<CreateCustomCheckoutLinkMutation>;
export type CreateCustomCheckoutLinkMutationOptions =
  Apollo.BaseMutationOptions<
    CreateCustomCheckoutLinkMutation,
    CreateCustomCheckoutLinkMutationVariables
  >;
export const VenueDetailsForCheckoutDocument = gql`
  query VenueDetailsForCheckout($venueId: String!) {
    venueDetailsForCheckout(venueId: $venueId) {
      id
      name
      legalEntity {
        country
      }
    }
    venueUsersForCheckout(venueId: $venueId) {
      id
      roleName
      account {
        id
        email
        firstName
        lastName
      }
    }
  }
`;
export type VenueDetailsForCheckoutComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenueDetailsForCheckoutQuery,
    VenueDetailsForCheckoutQueryVariables
  >,
  'query'
> &
  (
    | { variables: VenueDetailsForCheckoutQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const VenueDetailsForCheckoutComponent = (
  props: VenueDetailsForCheckoutComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenueDetailsForCheckoutQuery,
    VenueDetailsForCheckoutQueryVariables
  >
    query={VenueDetailsForCheckoutDocument}
    {...props}
  />
);

/**
 * __useVenueDetailsForCheckoutQuery__
 *
 * To run a query within a React component, call `useVenueDetailsForCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueDetailsForCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueDetailsForCheckoutQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueDetailsForCheckoutQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    VenueDetailsForCheckoutQuery,
    VenueDetailsForCheckoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenueDetailsForCheckoutQuery,
    VenueDetailsForCheckoutQueryVariables
  >(VenueDetailsForCheckoutDocument, options);
}
export function useVenueDetailsForCheckoutLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenueDetailsForCheckoutQuery,
    VenueDetailsForCheckoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenueDetailsForCheckoutQuery,
    VenueDetailsForCheckoutQueryVariables
  >(VenueDetailsForCheckoutDocument, options);
}
export type VenueDetailsForCheckoutQueryHookResult = ReturnType<
  typeof useVenueDetailsForCheckoutQuery
>;
export type VenueDetailsForCheckoutLazyQueryHookResult = ReturnType<
  typeof useVenueDetailsForCheckoutLazyQuery
>;
export type VenueDetailsForCheckoutQueryResult = Apollo.QueryResult<
  VenueDetailsForCheckoutQuery,
  VenueDetailsForCheckoutQueryVariables
>;
export function refetchVenueDetailsForCheckoutQuery(
  variables: VenueDetailsForCheckoutQueryVariables,
) {
  return { query: VenueDetailsForCheckoutDocument, variables: variables };
}
export const SyncFakturoidCompanyDetailsDocument = gql`
  mutation SyncFakturoidCompanyDetails($venueIds: [ID!]) {
    syncFakturoidCompanyDetails(venueIds: $venueIds) {
      synced
      failed
    }
  }
`;
export type SyncFakturoidCompanyDetailsMutationFn = Apollo.MutationFunction<
  SyncFakturoidCompanyDetailsMutation,
  SyncFakturoidCompanyDetailsMutationVariables
>;
export type SyncFakturoidCompanyDetailsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SyncFakturoidCompanyDetailsMutation,
    SyncFakturoidCompanyDetailsMutationVariables
  >,
  'mutation'
>;

export const SyncFakturoidCompanyDetailsComponent = (
  props: SyncFakturoidCompanyDetailsComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    SyncFakturoidCompanyDetailsMutation,
    SyncFakturoidCompanyDetailsMutationVariables
  >
    mutation={SyncFakturoidCompanyDetailsDocument}
    {...props}
  />
);

/**
 * __useSyncFakturoidCompanyDetailsMutation__
 *
 * To run a mutation, you first call `useSyncFakturoidCompanyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFakturoidCompanyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFakturoidCompanyDetailsMutation, { data, loading, error }] = useSyncFakturoidCompanyDetailsMutation({
 *   variables: {
 *      venueIds: // value for 'venueIds'
 *   },
 * });
 */
export function useSyncFakturoidCompanyDetailsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SyncFakturoidCompanyDetailsMutation,
    SyncFakturoidCompanyDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    SyncFakturoidCompanyDetailsMutation,
    SyncFakturoidCompanyDetailsMutationVariables
  >(SyncFakturoidCompanyDetailsDocument, options);
}
export type SyncFakturoidCompanyDetailsMutationHookResult = ReturnType<
  typeof useSyncFakturoidCompanyDetailsMutation
>;
export type SyncFakturoidCompanyDetailsMutationResult =
  Apollo.MutationResult<SyncFakturoidCompanyDetailsMutation>;
export type SyncFakturoidCompanyDetailsMutationOptions =
  Apollo.BaseMutationOptions<
    SyncFakturoidCompanyDetailsMutation,
    SyncFakturoidCompanyDetailsMutationVariables
  >;
export const AssignPeppolInboxDocument = gql`
  mutation AssignPeppolInbox($input: AssignPeppolInboxInput!) {
    assignPeppolInbox(input: $input) {
      id
      peppolParticipantId
    }
  }
`;
export type AssignPeppolInboxMutationFn = Apollo.MutationFunction<
  AssignPeppolInboxMutation,
  AssignPeppolInboxMutationVariables
>;
export type AssignPeppolInboxComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AssignPeppolInboxMutation,
    AssignPeppolInboxMutationVariables
  >,
  'mutation'
>;

export const AssignPeppolInboxComponent = (
  props: AssignPeppolInboxComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AssignPeppolInboxMutation,
    AssignPeppolInboxMutationVariables
  >
    mutation={AssignPeppolInboxDocument}
    {...props}
  />
);

/**
 * __useAssignPeppolInboxMutation__
 *
 * To run a mutation, you first call `useAssignPeppolInboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPeppolInboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPeppolInboxMutation, { data, loading, error }] = useAssignPeppolInboxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPeppolInboxMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignPeppolInboxMutation,
    AssignPeppolInboxMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AssignPeppolInboxMutation,
    AssignPeppolInboxMutationVariables
  >(AssignPeppolInboxDocument, options);
}
export type AssignPeppolInboxMutationHookResult = ReturnType<
  typeof useAssignPeppolInboxMutation
>;
export type AssignPeppolInboxMutationResult =
  Apollo.MutationResult<AssignPeppolInboxMutation>;
export type AssignPeppolInboxMutationOptions = Apollo.BaseMutationOptions<
  AssignPeppolInboxMutation,
  AssignPeppolInboxMutationVariables
>;
export const UnassignPeppolVenueDocument = gql`
  mutation UnassignPeppolVenue($venueId: ID!) {
    unassignPeppolVenue(venueId: $venueId)
  }
`;
export type UnassignPeppolVenueMutationFn = Apollo.MutationFunction<
  UnassignPeppolVenueMutation,
  UnassignPeppolVenueMutationVariables
>;
export type UnassignPeppolVenueComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UnassignPeppolVenueMutation,
    UnassignPeppolVenueMutationVariables
  >,
  'mutation'
>;

export const UnassignPeppolVenueComponent = (
  props: UnassignPeppolVenueComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UnassignPeppolVenueMutation,
    UnassignPeppolVenueMutationVariables
  >
    mutation={UnassignPeppolVenueDocument}
    {...props}
  />
);

/**
 * __useUnassignPeppolVenueMutation__
 *
 * To run a mutation, you first call `useUnassignPeppolVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPeppolVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPeppolVenueMutation, { data, loading, error }] = useUnassignPeppolVenueMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useUnassignPeppolVenueMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnassignPeppolVenueMutation,
    UnassignPeppolVenueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UnassignPeppolVenueMutation,
    UnassignPeppolVenueMutationVariables
  >(UnassignPeppolVenueDocument, options);
}
export type UnassignPeppolVenueMutationHookResult = ReturnType<
  typeof useUnassignPeppolVenueMutation
>;
export type UnassignPeppolVenueMutationResult =
  Apollo.MutationResult<UnassignPeppolVenueMutation>;
export type UnassignPeppolVenueMutationOptions = Apollo.BaseMutationOptions<
  UnassignPeppolVenueMutation,
  UnassignPeppolVenueMutationVariables
>;
export const UnassignPeppolInboxDocument = gql`
  mutation UnassignPeppolInbox($peppolParticipantId: String!) {
    unassignPeppolInbox(peppolParticipantId: $peppolParticipantId)
  }
`;
export type UnassignPeppolInboxMutationFn = Apollo.MutationFunction<
  UnassignPeppolInboxMutation,
  UnassignPeppolInboxMutationVariables
>;
export type UnassignPeppolInboxComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UnassignPeppolInboxMutation,
    UnassignPeppolInboxMutationVariables
  >,
  'mutation'
>;

export const UnassignPeppolInboxComponent = (
  props: UnassignPeppolInboxComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UnassignPeppolInboxMutation,
    UnassignPeppolInboxMutationVariables
  >
    mutation={UnassignPeppolInboxDocument}
    {...props}
  />
);

/**
 * __useUnassignPeppolInboxMutation__
 *
 * To run a mutation, you first call `useUnassignPeppolInboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPeppolInboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPeppolInboxMutation, { data, loading, error }] = useUnassignPeppolInboxMutation({
 *   variables: {
 *      peppolParticipantId: // value for 'peppolParticipantId'
 *   },
 * });
 */
export function useUnassignPeppolInboxMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnassignPeppolInboxMutation,
    UnassignPeppolInboxMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UnassignPeppolInboxMutation,
    UnassignPeppolInboxMutationVariables
  >(UnassignPeppolInboxDocument, options);
}
export type UnassignPeppolInboxMutationHookResult = ReturnType<
  typeof useUnassignPeppolInboxMutation
>;
export type UnassignPeppolInboxMutationResult =
  Apollo.MutationResult<UnassignPeppolInboxMutation>;
export type UnassignPeppolInboxMutationOptions = Apollo.BaseMutationOptions<
  UnassignPeppolInboxMutation,
  UnassignPeppolInboxMutationVariables
>;
export const DenyPeppolRegistrationDocument = gql`
  mutation DenyPeppolRegistration($registrationId: ID!) {
    denyPeppolRegistration(registrationId: $registrationId)
  }
`;
export type DenyPeppolRegistrationMutationFn = Apollo.MutationFunction<
  DenyPeppolRegistrationMutation,
  DenyPeppolRegistrationMutationVariables
>;
export type DenyPeppolRegistrationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DenyPeppolRegistrationMutation,
    DenyPeppolRegistrationMutationVariables
  >,
  'mutation'
>;

export const DenyPeppolRegistrationComponent = (
  props: DenyPeppolRegistrationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    DenyPeppolRegistrationMutation,
    DenyPeppolRegistrationMutationVariables
  >
    mutation={DenyPeppolRegistrationDocument}
    {...props}
  />
);

/**
 * __useDenyPeppolRegistrationMutation__
 *
 * To run a mutation, you first call `useDenyPeppolRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyPeppolRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyPeppolRegistrationMutation, { data, loading, error }] = useDenyPeppolRegistrationMutation({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useDenyPeppolRegistrationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DenyPeppolRegistrationMutation,
    DenyPeppolRegistrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DenyPeppolRegistrationMutation,
    DenyPeppolRegistrationMutationVariables
  >(DenyPeppolRegistrationDocument, options);
}
export type DenyPeppolRegistrationMutationHookResult = ReturnType<
  typeof useDenyPeppolRegistrationMutation
>;
export type DenyPeppolRegistrationMutationResult =
  Apollo.MutationResult<DenyPeppolRegistrationMutation>;
export type DenyPeppolRegistrationMutationOptions = Apollo.BaseMutationOptions<
  DenyPeppolRegistrationMutation,
  DenyPeppolRegistrationMutationVariables
>;
export const AcceptPeppolRegistrationDocument = gql`
  mutation AcceptPeppolRegistration($registrationId: ID!) {
    acceptPeppolRegistration(registrationId: $registrationId)
  }
`;
export type AcceptPeppolRegistrationMutationFn = Apollo.MutationFunction<
  AcceptPeppolRegistrationMutation,
  AcceptPeppolRegistrationMutationVariables
>;
export type AcceptPeppolRegistrationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AcceptPeppolRegistrationMutation,
    AcceptPeppolRegistrationMutationVariables
  >,
  'mutation'
>;

export const AcceptPeppolRegistrationComponent = (
  props: AcceptPeppolRegistrationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AcceptPeppolRegistrationMutation,
    AcceptPeppolRegistrationMutationVariables
  >
    mutation={AcceptPeppolRegistrationDocument}
    {...props}
  />
);

/**
 * __useAcceptPeppolRegistrationMutation__
 *
 * To run a mutation, you first call `useAcceptPeppolRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPeppolRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPeppolRegistrationMutation, { data, loading, error }] = useAcceptPeppolRegistrationMutation({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useAcceptPeppolRegistrationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AcceptPeppolRegistrationMutation,
    AcceptPeppolRegistrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AcceptPeppolRegistrationMutation,
    AcceptPeppolRegistrationMutationVariables
  >(AcceptPeppolRegistrationDocument, options);
}
export type AcceptPeppolRegistrationMutationHookResult = ReturnType<
  typeof useAcceptPeppolRegistrationMutation
>;
export type AcceptPeppolRegistrationMutationResult =
  Apollo.MutationResult<AcceptPeppolRegistrationMutation>;
export type AcceptPeppolRegistrationMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptPeppolRegistrationMutation,
    AcceptPeppolRegistrationMutationVariables
  >;
export const EinvoicingAdminDataDocument = gql`
  query EinvoicingAdminData {
    einvoicingAdminVenues {
      id
      name
      connected
      peppolParticipantId
      ico
      dic
    }
    einvoicingAdminInboxes {
      registrationId
      peppolParticipantId
      legalName
      ico
      dic
      status
      connected
      venueNames
    }
    peppolRegistrationQueue {
      id
      legalName
      ico
      dic
      peppolParticipantId
      matchResult
      receivedAt
    }
  }
`;
export type EinvoicingAdminDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    EinvoicingAdminDataQuery,
    EinvoicingAdminDataQueryVariables
  >,
  'query'
>;

export const EinvoicingAdminDataComponent = (
  props: EinvoicingAdminDataComponentProps,
) => (
  <ApolloReactComponents.Query<
    EinvoicingAdminDataQuery,
    EinvoicingAdminDataQueryVariables
  >
    query={EinvoicingAdminDataDocument}
    {...props}
  />
);

/**
 * __useEinvoicingAdminDataQuery__
 *
 * To run a query within a React component, call `useEinvoicingAdminDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEinvoicingAdminDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEinvoicingAdminDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useEinvoicingAdminDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EinvoicingAdminDataQuery,
    EinvoicingAdminDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    EinvoicingAdminDataQuery,
    EinvoicingAdminDataQueryVariables
  >(EinvoicingAdminDataDocument, options);
}
export function useEinvoicingAdminDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EinvoicingAdminDataQuery,
    EinvoicingAdminDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    EinvoicingAdminDataQuery,
    EinvoicingAdminDataQueryVariables
  >(EinvoicingAdminDataDocument, options);
}
export type EinvoicingAdminDataQueryHookResult = ReturnType<
  typeof useEinvoicingAdminDataQuery
>;
export type EinvoicingAdminDataLazyQueryHookResult = ReturnType<
  typeof useEinvoicingAdminDataLazyQuery
>;
export type EinvoicingAdminDataQueryResult = Apollo.QueryResult<
  EinvoicingAdminDataQuery,
  EinvoicingAdminDataQueryVariables
>;
export function refetchEinvoicingAdminDataQuery(
  variables?: EinvoicingAdminDataQueryVariables,
) {
  return { query: EinvoicingAdminDataDocument, variables: variables };
}
export const UpdateVenueGracePeriodDocument = gql`
  mutation UpdateVenueGracePeriod($venueId: String!, $gracePeriodDays: Int) {
    updateVenueGracePeriod(
      venueId: $venueId
      gracePeriodDays: $gracePeriodDays
    ) {
      id
      name
      paymentFailureGracePeriodDays
    }
  }
`;
export type UpdateVenueGracePeriodMutationFn = Apollo.MutationFunction<
  UpdateVenueGracePeriodMutation,
  UpdateVenueGracePeriodMutationVariables
>;
export type UpdateVenueGracePeriodComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateVenueGracePeriodMutation,
    UpdateVenueGracePeriodMutationVariables
  >,
  'mutation'
>;

export const UpdateVenueGracePeriodComponent = (
  props: UpdateVenueGracePeriodComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateVenueGracePeriodMutation,
    UpdateVenueGracePeriodMutationVariables
  >
    mutation={UpdateVenueGracePeriodDocument}
    {...props}
  />
);

/**
 * __useUpdateVenueGracePeriodMutation__
 *
 * To run a mutation, you first call `useUpdateVenueGracePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVenueGracePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVenueGracePeriodMutation, { data, loading, error }] = useUpdateVenueGracePeriodMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      gracePeriodDays: // value for 'gracePeriodDays'
 *   },
 * });
 */
export function useUpdateVenueGracePeriodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVenueGracePeriodMutation,
    UpdateVenueGracePeriodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVenueGracePeriodMutation,
    UpdateVenueGracePeriodMutationVariables
  >(UpdateVenueGracePeriodDocument, options);
}
export type UpdateVenueGracePeriodMutationHookResult = ReturnType<
  typeof useUpdateVenueGracePeriodMutation
>;
export type UpdateVenueGracePeriodMutationResult =
  Apollo.MutationResult<UpdateVenueGracePeriodMutation>;
export type UpdateVenueGracePeriodMutationOptions = Apollo.BaseMutationOptions<
  UpdateVenueGracePeriodMutation,
  UpdateVenueGracePeriodMutationVariables
>;
export const VenueGracePeriodInfoDocument = gql`
  query VenueGracePeriodInfo($venueId: String!) {
    venueGracePeriodInfo(venueId: $venueId) {
      gracePeriodDays
      hasPaymentFailure
      paymentFailureStartedAt
      daysRemaining
      isLockedOut
      paymentType
      overdueInvoiceAmount
      overdueInvoiceCurrency
      overdueInvoiceDueDate
      overdueInvoiceVariableSymbol
    }
  }
`;
export type VenueGracePeriodInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenueGracePeriodInfoQuery,
    VenueGracePeriodInfoQueryVariables
  >,
  'query'
> &
  (
    | { variables: VenueGracePeriodInfoQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const VenueGracePeriodInfoComponent = (
  props: VenueGracePeriodInfoComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenueGracePeriodInfoQuery,
    VenueGracePeriodInfoQueryVariables
  >
    query={VenueGracePeriodInfoDocument}
    {...props}
  />
);

/**
 * __useVenueGracePeriodInfoQuery__
 *
 * To run a query within a React component, call `useVenueGracePeriodInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueGracePeriodInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueGracePeriodInfoQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueGracePeriodInfoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    VenueGracePeriodInfoQuery,
    VenueGracePeriodInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenueGracePeriodInfoQuery,
    VenueGracePeriodInfoQueryVariables
  >(VenueGracePeriodInfoDocument, options);
}
export function useVenueGracePeriodInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenueGracePeriodInfoQuery,
    VenueGracePeriodInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenueGracePeriodInfoQuery,
    VenueGracePeriodInfoQueryVariables
  >(VenueGracePeriodInfoDocument, options);
}
export type VenueGracePeriodInfoQueryHookResult = ReturnType<
  typeof useVenueGracePeriodInfoQuery
>;
export type VenueGracePeriodInfoLazyQueryHookResult = ReturnType<
  typeof useVenueGracePeriodInfoLazyQuery
>;
export type VenueGracePeriodInfoQueryResult = Apollo.QueryResult<
  VenueGracePeriodInfoQuery,
  VenueGracePeriodInfoQueryVariables
>;
export function refetchVenueGracePeriodInfoQuery(
  variables: VenueGracePeriodInfoQueryVariables,
) {
  return { query: VenueGracePeriodInfoDocument, variables: variables };
}
export const PaymentFailureGracePeriodDefaultDocument = gql`
  query PaymentFailureGracePeriodDefault {
    paymentFailureGracePeriodDefault
  }
`;
export type PaymentFailureGracePeriodDefaultComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PaymentFailureGracePeriodDefaultQuery,
    PaymentFailureGracePeriodDefaultQueryVariables
  >,
  'query'
>;

export const PaymentFailureGracePeriodDefaultComponent = (
  props: PaymentFailureGracePeriodDefaultComponentProps,
) => (
  <ApolloReactComponents.Query<
    PaymentFailureGracePeriodDefaultQuery,
    PaymentFailureGracePeriodDefaultQueryVariables
  >
    query={PaymentFailureGracePeriodDefaultDocument}
    {...props}
  />
);

/**
 * __usePaymentFailureGracePeriodDefaultQuery__
 *
 * To run a query within a React component, call `usePaymentFailureGracePeriodDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentFailureGracePeriodDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentFailureGracePeriodDefaultQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentFailureGracePeriodDefaultQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PaymentFailureGracePeriodDefaultQuery,
    PaymentFailureGracePeriodDefaultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    PaymentFailureGracePeriodDefaultQuery,
    PaymentFailureGracePeriodDefaultQueryVariables
  >(PaymentFailureGracePeriodDefaultDocument, options);
}
export function usePaymentFailureGracePeriodDefaultLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentFailureGracePeriodDefaultQuery,
    PaymentFailureGracePeriodDefaultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    PaymentFailureGracePeriodDefaultQuery,
    PaymentFailureGracePeriodDefaultQueryVariables
  >(PaymentFailureGracePeriodDefaultDocument, options);
}
export type PaymentFailureGracePeriodDefaultQueryHookResult = ReturnType<
  typeof usePaymentFailureGracePeriodDefaultQuery
>;
export type PaymentFailureGracePeriodDefaultLazyQueryHookResult = ReturnType<
  typeof usePaymentFailureGracePeriodDefaultLazyQuery
>;
export type PaymentFailureGracePeriodDefaultQueryResult = Apollo.QueryResult<
  PaymentFailureGracePeriodDefaultQuery,
  PaymentFailureGracePeriodDefaultQueryVariables
>;
export function refetchPaymentFailureGracePeriodDefaultQuery(
  variables?: PaymentFailureGracePeriodDefaultQueryVariables,
) {
  return {
    query: PaymentFailureGracePeriodDefaultDocument,
    variables: variables,
  };
}
export const VenuesDocument = gql`
  query Venues {
    venues {
      id
      name
      useAutoCategorization
    }
  }
`;
export type VenuesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenuesQuery,
    VenuesQueryVariables
  >,
  'query'
>;

export const VenuesComponent = (props: VenuesComponentProps) => (
  <ApolloReactComponents.Query<VenuesQuery, VenuesQueryVariables>
    query={VenuesDocument}
    {...props}
  />
);

/**
 * __useVenuesQuery__
 *
 * To run a query within a React component, call `useVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVenuesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VenuesQuery,
    VenuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<VenuesQuery, VenuesQueryVariables>(
    VenuesDocument,
    options,
  );
}
export function useVenuesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenuesQuery,
    VenuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<VenuesQuery, VenuesQueryVariables>(
    VenuesDocument,
    options,
  );
}
export type VenuesQueryHookResult = ReturnType<typeof useVenuesQuery>;
export type VenuesLazyQueryHookResult = ReturnType<typeof useVenuesLazyQuery>;
export type VenuesQueryResult = Apollo.QueryResult<
  VenuesQuery,
  VenuesQueryVariables
>;
export function refetchVenuesQuery(variables?: VenuesQueryVariables) {
  return { query: VenuesDocument, variables: variables };
}
export const SetupInvoiceBillingDocument = gql`
  mutation SetupInvoiceBilling($input: SetupInvoiceBillingInput!) {
    setupInvoiceBilling(input: $input) {
      isEnabled
      externalCustomerId
      isLegalDataFilledIn
      venueId
      hasStripeBilling
    }
  }
`;
export type SetupInvoiceBillingMutationFn = Apollo.MutationFunction<
  SetupInvoiceBillingMutation,
  SetupInvoiceBillingMutationVariables
>;
export type SetupInvoiceBillingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetupInvoiceBillingMutation,
    SetupInvoiceBillingMutationVariables
  >,
  'mutation'
>;

export const SetupInvoiceBillingComponent = (
  props: SetupInvoiceBillingComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    SetupInvoiceBillingMutation,
    SetupInvoiceBillingMutationVariables
  >
    mutation={SetupInvoiceBillingDocument}
    {...props}
  />
);

/**
 * __useSetupInvoiceBillingMutation__
 *
 * To run a mutation, you first call `useSetupInvoiceBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupInvoiceBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupInvoiceBillingMutation, { data, loading, error }] = useSetupInvoiceBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupInvoiceBillingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetupInvoiceBillingMutation,
    SetupInvoiceBillingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    SetupInvoiceBillingMutation,
    SetupInvoiceBillingMutationVariables
  >(SetupInvoiceBillingDocument, options);
}
export type SetupInvoiceBillingMutationHookResult = ReturnType<
  typeof useSetupInvoiceBillingMutation
>;
export type SetupInvoiceBillingMutationResult =
  Apollo.MutationResult<SetupInvoiceBillingMutation>;
export type SetupInvoiceBillingMutationOptions = Apollo.BaseMutationOptions<
  SetupInvoiceBillingMutation,
  SetupInvoiceBillingMutationVariables
>;
export const InvoiceBillingStatusDocument = gql`
  query InvoiceBillingStatus($venueId: String!) {
    invoiceBillingStatus(venueId: $venueId) {
      isEnabled
      externalCustomerId
      isLegalDataFilledIn
      venueId
      hasStripeBilling
    }
  }
`;
export type InvoiceBillingStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    InvoiceBillingStatusQuery,
    InvoiceBillingStatusQueryVariables
  >,
  'query'
> &
  (
    | { variables: InvoiceBillingStatusQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const InvoiceBillingStatusComponent = (
  props: InvoiceBillingStatusComponentProps,
) => (
  <ApolloReactComponents.Query<
    InvoiceBillingStatusQuery,
    InvoiceBillingStatusQueryVariables
  >
    query={InvoiceBillingStatusDocument}
    {...props}
  />
);

/**
 * __useInvoiceBillingStatusQuery__
 *
 * To run a query within a React component, call `useInvoiceBillingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceBillingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceBillingStatusQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useInvoiceBillingStatusQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InvoiceBillingStatusQuery,
    InvoiceBillingStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    InvoiceBillingStatusQuery,
    InvoiceBillingStatusQueryVariables
  >(InvoiceBillingStatusDocument, options);
}
export function useInvoiceBillingStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvoiceBillingStatusQuery,
    InvoiceBillingStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    InvoiceBillingStatusQuery,
    InvoiceBillingStatusQueryVariables
  >(InvoiceBillingStatusDocument, options);
}
export type InvoiceBillingStatusQueryHookResult = ReturnType<
  typeof useInvoiceBillingStatusQuery
>;
export type InvoiceBillingStatusLazyQueryHookResult = ReturnType<
  typeof useInvoiceBillingStatusLazyQuery
>;
export type InvoiceBillingStatusQueryResult = Apollo.QueryResult<
  InvoiceBillingStatusQuery,
  InvoiceBillingStatusQueryVariables
>;
export function refetchInvoiceBillingStatusQuery(
  variables: InvoiceBillingStatusQueryVariables,
) {
  return { query: InvoiceBillingStatusDocument, variables: variables };
}
export const CreatePendingAccountDocument = gql`
  mutation CreatePendingAccount(
    $venueName: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $country: CountryCode!
    $isTest: Boolean
    $crmLink: String
    $useAutoCategorization: Boolean
  ) {
    createPendingAccount(
      venueName: $venueName
      email: $email
      firstName: $firstName
      lastName: $lastName
      country: $country
      isTest: $isTest
      crmLink: $crmLink
      useAutoCategorization: $useAutoCategorization
    ) {
      id
      email
      firstName
      lastName
      isSent
      adminAccountId
      venue {
        id
        name
        crmLink
        legalEntity {
          country
        }
      }
    }
  }
`;
export type CreatePendingAccountMutationFn = Apollo.MutationFunction<
  CreatePendingAccountMutation,
  CreatePendingAccountMutationVariables
>;
export type CreatePendingAccountComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreatePendingAccountMutation,
    CreatePendingAccountMutationVariables
  >,
  'mutation'
>;

export const CreatePendingAccountComponent = (
  props: CreatePendingAccountComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreatePendingAccountMutation,
    CreatePendingAccountMutationVariables
  >
    mutation={CreatePendingAccountDocument}
    {...props}
  />
);

/**
 * __useCreatePendingAccountMutation__
 *
 * To run a mutation, you first call `useCreatePendingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePendingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPendingAccountMutation, { data, loading, error }] = useCreatePendingAccountMutation({
 *   variables: {
 *      venueName: // value for 'venueName'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      country: // value for 'country'
 *      isTest: // value for 'isTest'
 *      crmLink: // value for 'crmLink'
 *      useAutoCategorization: // value for 'useAutoCategorization'
 *   },
 * });
 */
export function useCreatePendingAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePendingAccountMutation,
    CreatePendingAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreatePendingAccountMutation,
    CreatePendingAccountMutationVariables
  >(CreatePendingAccountDocument, options);
}
export type CreatePendingAccountMutationHookResult = ReturnType<
  typeof useCreatePendingAccountMutation
>;
export type CreatePendingAccountMutationResult =
  Apollo.MutationResult<CreatePendingAccountMutation>;
export type CreatePendingAccountMutationOptions = Apollo.BaseMutationOptions<
  CreatePendingAccountMutation,
  CreatePendingAccountMutationVariables
>;
export const EditPendingAccountDocument = gql`
  mutation EditPendingAccount(
    $id: ID!
    $venueName: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $country: CountryCode!
    $crmLink: String
  ) {
    editPendingAccount(
      id: $id
      venueName: $venueName
      email: $email
      firstName: $firstName
      lastName: $lastName
      country: $country
      crmLink: $crmLink
    ) {
      id
      email
      firstName
      lastName
      isSent
      adminAccountId
      venue {
        id
        name
        crmLink
        legalEntity {
          country
        }
      }
    }
  }
`;
export type EditPendingAccountMutationFn = Apollo.MutationFunction<
  EditPendingAccountMutation,
  EditPendingAccountMutationVariables
>;
export type EditPendingAccountComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    EditPendingAccountMutation,
    EditPendingAccountMutationVariables
  >,
  'mutation'
>;

export const EditPendingAccountComponent = (
  props: EditPendingAccountComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    EditPendingAccountMutation,
    EditPendingAccountMutationVariables
  >
    mutation={EditPendingAccountDocument}
    {...props}
  />
);

/**
 * __useEditPendingAccountMutation__
 *
 * To run a mutation, you first call `useEditPendingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPendingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPendingAccountMutation, { data, loading, error }] = useEditPendingAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      venueName: // value for 'venueName'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      country: // value for 'country'
 *      crmLink: // value for 'crmLink'
 *   },
 * });
 */
export function useEditPendingAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EditPendingAccountMutation,
    EditPendingAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    EditPendingAccountMutation,
    EditPendingAccountMutationVariables
  >(EditPendingAccountDocument, options);
}
export type EditPendingAccountMutationHookResult = ReturnType<
  typeof useEditPendingAccountMutation
>;
export type EditPendingAccountMutationResult =
  Apollo.MutationResult<EditPendingAccountMutation>;
export type EditPendingAccountMutationOptions = Apollo.BaseMutationOptions<
  EditPendingAccountMutation,
  EditPendingAccountMutationVariables
>;
export const ArchivePendingAccountDocument = gql`
  mutation ArchivePendingAccount($id: ID!) {
    archivePendingAccount(id: $id) {
      id
      deletedAt
    }
  }
`;
export type ArchivePendingAccountMutationFn = Apollo.MutationFunction<
  ArchivePendingAccountMutation,
  ArchivePendingAccountMutationVariables
>;
export type ArchivePendingAccountComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ArchivePendingAccountMutation,
    ArchivePendingAccountMutationVariables
  >,
  'mutation'
>;

export const ArchivePendingAccountComponent = (
  props: ArchivePendingAccountComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    ArchivePendingAccountMutation,
    ArchivePendingAccountMutationVariables
  >
    mutation={ArchivePendingAccountDocument}
    {...props}
  />
);

/**
 * __useArchivePendingAccountMutation__
 *
 * To run a mutation, you first call `useArchivePendingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePendingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePendingAccountMutation, { data, loading, error }] = useArchivePendingAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchivePendingAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ArchivePendingAccountMutation,
    ArchivePendingAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ArchivePendingAccountMutation,
    ArchivePendingAccountMutationVariables
  >(ArchivePendingAccountDocument, options);
}
export type ArchivePendingAccountMutationHookResult = ReturnType<
  typeof useArchivePendingAccountMutation
>;
export type ArchivePendingAccountMutationResult =
  Apollo.MutationResult<ArchivePendingAccountMutation>;
export type ArchivePendingAccountMutationOptions = Apollo.BaseMutationOptions<
  ArchivePendingAccountMutation,
  ArchivePendingAccountMutationVariables
>;
export const UnarchivePendingAccountDocument = gql`
  mutation UnarchivePendingAccount($id: ID!) {
    unarchivePendingAccount(id: $id) {
      id
      deletedAt
    }
  }
`;
export type UnarchivePendingAccountMutationFn = Apollo.MutationFunction<
  UnarchivePendingAccountMutation,
  UnarchivePendingAccountMutationVariables
>;
export type UnarchivePendingAccountComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UnarchivePendingAccountMutation,
    UnarchivePendingAccountMutationVariables
  >,
  'mutation'
>;

export const UnarchivePendingAccountComponent = (
  props: UnarchivePendingAccountComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UnarchivePendingAccountMutation,
    UnarchivePendingAccountMutationVariables
  >
    mutation={UnarchivePendingAccountDocument}
    {...props}
  />
);

/**
 * __useUnarchivePendingAccountMutation__
 *
 * To run a mutation, you first call `useUnarchivePendingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchivePendingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchivePendingAccountMutation, { data, loading, error }] = useUnarchivePendingAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchivePendingAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnarchivePendingAccountMutation,
    UnarchivePendingAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UnarchivePendingAccountMutation,
    UnarchivePendingAccountMutationVariables
  >(UnarchivePendingAccountDocument, options);
}
export type UnarchivePendingAccountMutationHookResult = ReturnType<
  typeof useUnarchivePendingAccountMutation
>;
export type UnarchivePendingAccountMutationResult =
  Apollo.MutationResult<UnarchivePendingAccountMutation>;
export type UnarchivePendingAccountMutationOptions = Apollo.BaseMutationOptions<
  UnarchivePendingAccountMutation,
  UnarchivePendingAccountMutationVariables
>;
export const ConfirmPendingAccountDocument = gql`
  mutation ConfirmPendingAccount(
    $pendingAccountId: ID!
    $doesAccountExist: Boolean!
  ) {
    confirmPendingAccount(
      pendingAccountId: $pendingAccountId
      doesAccountExist: $doesAccountExist
    ) {
      id
      isSent
    }
  }
`;
export type ConfirmPendingAccountMutationFn = Apollo.MutationFunction<
  ConfirmPendingAccountMutation,
  ConfirmPendingAccountMutationVariables
>;
export type ConfirmPendingAccountComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConfirmPendingAccountMutation,
    ConfirmPendingAccountMutationVariables
  >,
  'mutation'
>;

export const ConfirmPendingAccountComponent = (
  props: ConfirmPendingAccountComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    ConfirmPendingAccountMutation,
    ConfirmPendingAccountMutationVariables
  >
    mutation={ConfirmPendingAccountDocument}
    {...props}
  />
);

/**
 * __useConfirmPendingAccountMutation__
 *
 * To run a mutation, you first call `useConfirmPendingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPendingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPendingAccountMutation, { data, loading, error }] = useConfirmPendingAccountMutation({
 *   variables: {
 *      pendingAccountId: // value for 'pendingAccountId'
 *      doesAccountExist: // value for 'doesAccountExist'
 *   },
 * });
 */
export function useConfirmPendingAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfirmPendingAccountMutation,
    ConfirmPendingAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ConfirmPendingAccountMutation,
    ConfirmPendingAccountMutationVariables
  >(ConfirmPendingAccountDocument, options);
}
export type ConfirmPendingAccountMutationHookResult = ReturnType<
  typeof useConfirmPendingAccountMutation
>;
export type ConfirmPendingAccountMutationResult =
  Apollo.MutationResult<ConfirmPendingAccountMutation>;
export type ConfirmPendingAccountMutationOptions = Apollo.BaseMutationOptions<
  ConfirmPendingAccountMutation,
  ConfirmPendingAccountMutationVariables
>;
export const ExistingAccountByEmailDocument = gql`
  query ExistingAccountByEmail($email: String!) {
    existingAccountByEmail(email: $email) {
      accountId
      email
      firstName
      lastName
      venueNames
      isDeleted
    }
  }
`;
export type ExistingAccountByEmailComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ExistingAccountByEmailQuery,
    ExistingAccountByEmailQueryVariables
  >,
  'query'
> &
  (
    | { variables: ExistingAccountByEmailQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ExistingAccountByEmailComponent = (
  props: ExistingAccountByEmailComponentProps,
) => (
  <ApolloReactComponents.Query<
    ExistingAccountByEmailQuery,
    ExistingAccountByEmailQueryVariables
  >
    query={ExistingAccountByEmailDocument}
    {...props}
  />
);

/**
 * __useExistingAccountByEmailQuery__
 *
 * To run a query within a React component, call `useExistingAccountByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingAccountByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingAccountByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useExistingAccountByEmailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ExistingAccountByEmailQuery,
    ExistingAccountByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ExistingAccountByEmailQuery,
    ExistingAccountByEmailQueryVariables
  >(ExistingAccountByEmailDocument, options);
}
export function useExistingAccountByEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ExistingAccountByEmailQuery,
    ExistingAccountByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ExistingAccountByEmailQuery,
    ExistingAccountByEmailQueryVariables
  >(ExistingAccountByEmailDocument, options);
}
export type ExistingAccountByEmailQueryHookResult = ReturnType<
  typeof useExistingAccountByEmailQuery
>;
export type ExistingAccountByEmailLazyQueryHookResult = ReturnType<
  typeof useExistingAccountByEmailLazyQuery
>;
export type ExistingAccountByEmailQueryResult = Apollo.QueryResult<
  ExistingAccountByEmailQuery,
  ExistingAccountByEmailQueryVariables
>;
export function refetchExistingAccountByEmailQuery(
  variables: ExistingAccountByEmailQueryVariables,
) {
  return { query: ExistingAccountByEmailDocument, variables: variables };
}
export const PendingAccountsDocument = gql`
  query PendingAccounts {
    pendingAccounts {
      id
      email
      firstName
      lastName
      isSent
      adminAccountId
      deletedAt
      createdAt
      venue {
        id
        name
        isTest
        crmLink
        legalEntity {
          country
        }
      }
    }
  }
`;
export type PendingAccountsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PendingAccountsQuery,
    PendingAccountsQueryVariables
  >,
  'query'
>;

export const PendingAccountsComponent = (
  props: PendingAccountsComponentProps,
) => (
  <ApolloReactComponents.Query<
    PendingAccountsQuery,
    PendingAccountsQueryVariables
  >
    query={PendingAccountsDocument}
    {...props}
  />
);

/**
 * __usePendingAccountsQuery__
 *
 * To run a query within a React component, call `usePendingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PendingAccountsQuery,
    PendingAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    PendingAccountsQuery,
    PendingAccountsQueryVariables
  >(PendingAccountsDocument, options);
}
export function usePendingAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PendingAccountsQuery,
    PendingAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    PendingAccountsQuery,
    PendingAccountsQueryVariables
  >(PendingAccountsDocument, options);
}
export type PendingAccountsQueryHookResult = ReturnType<
  typeof usePendingAccountsQuery
>;
export type PendingAccountsLazyQueryHookResult = ReturnType<
  typeof usePendingAccountsLazyQuery
>;
export type PendingAccountsQueryResult = Apollo.QueryResult<
  PendingAccountsQuery,
  PendingAccountsQueryVariables
>;
export function refetchPendingAccountsQuery(
  variables?: PendingAccountsQueryVariables,
) {
  return { query: PendingAccountsDocument, variables: variables };
}
export const MoveVenueToPaywallDocument = gql`
  mutation MoveVenueToPaywall($venueId: String!, $force: Boolean!) {
    moveVenueToPaywall(venueId: $venueId, force: $force) {
      id
      start
      end
      subscriptionPlanType
      pricingModelVersion
      invoiceRecognitionsPerMonth
      subscriptionPeriod
    }
  }
`;
export type MoveVenueToPaywallMutationFn = Apollo.MutationFunction<
  MoveVenueToPaywallMutation,
  MoveVenueToPaywallMutationVariables
>;
export type MoveVenueToPaywallComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MoveVenueToPaywallMutation,
    MoveVenueToPaywallMutationVariables
  >,
  'mutation'
>;

export const MoveVenueToPaywallComponent = (
  props: MoveVenueToPaywallComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    MoveVenueToPaywallMutation,
    MoveVenueToPaywallMutationVariables
  >
    mutation={MoveVenueToPaywallDocument}
    {...props}
  />
);

/**
 * __useMoveVenueToPaywallMutation__
 *
 * To run a mutation, you first call `useMoveVenueToPaywallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveVenueToPaywallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveVenueToPaywallMutation, { data, loading, error }] = useMoveVenueToPaywallMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useMoveVenueToPaywallMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MoveVenueToPaywallMutation,
    MoveVenueToPaywallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    MoveVenueToPaywallMutation,
    MoveVenueToPaywallMutationVariables
  >(MoveVenueToPaywallDocument, options);
}
export type MoveVenueToPaywallMutationHookResult = ReturnType<
  typeof useMoveVenueToPaywallMutation
>;
export type MoveVenueToPaywallMutationResult =
  Apollo.MutationResult<MoveVenueToPaywallMutation>;
export type MoveVenueToPaywallMutationOptions = Apollo.BaseMutationOptions<
  MoveVenueToPaywallMutation,
  MoveVenueToPaywallMutationVariables
>;
export const SubscriptionDataDocument = gql`
  query SubscriptionData($venueId: String!) {
    subscriptionData(venueId: $venueId) {
      id
      start
      end
      pricingModelVersion
      subscriptionPlanType
      subscriptionPeriod
      invoiceRecognitionsPerMonth
      overrideAutomaticUpdates
    }
  }
`;
export type SubscriptionDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SubscriptionDataQuery,
    SubscriptionDataQueryVariables
  >,
  'query'
> &
  (
    | { variables: SubscriptionDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SubscriptionDataComponent = (
  props: SubscriptionDataComponentProps,
) => (
  <ApolloReactComponents.Query<
    SubscriptionDataQuery,
    SubscriptionDataQueryVariables
  >
    query={SubscriptionDataDocument}
    {...props}
  />
);

/**
 * __useSubscriptionData__
 *
 * To run a query within a React component, call `useSubscriptionData` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionData({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useSubscriptionData(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SubscriptionDataQuery,
    SubscriptionDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SubscriptionDataQuery,
    SubscriptionDataQueryVariables
  >(SubscriptionDataDocument, options);
}
export function useSubscriptionDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionDataQuery,
    SubscriptionDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SubscriptionDataQuery,
    SubscriptionDataQueryVariables
  >(SubscriptionDataDocument, options);
}
export type SubscriptionDataHookResult = ReturnType<typeof useSubscriptionData>;
export type SubscriptionDataLazyQueryHookResult = ReturnType<
  typeof useSubscriptionDataLazyQuery
>;
export type SubscriptionDataQueryResult = Apollo.QueryResult<
  SubscriptionDataQuery,
  SubscriptionDataQueryVariables
>;
export function refetchSubscriptionData(
  variables: SubscriptionDataQueryVariables,
) {
  return { query: SubscriptionDataDocument, variables: variables };
}
export const ConnectStoryousIntegrationDocument = gql`
  mutation ConnectStoryousIntegration(
    $venueId: ID!
    $merchantId: String!
    $placeId: String!
    $startDate: String!
    $skipIcoValidation: Boolean
  ) {
    connectStoryousIntegration(
      venueId: $venueId
      merchantId: $merchantId
      placeId: $placeId
      startDate: $startDate
      skipIcoValidation: $skipIcoValidation
    ) {
      id
      provider
    }
  }
`;
export type ConnectStoryousIntegrationMutationFn = Apollo.MutationFunction<
  ConnectStoryousIntegrationMutation,
  ConnectStoryousIntegrationMutationVariables
>;
export type ConnectStoryousIntegrationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConnectStoryousIntegrationMutation,
    ConnectStoryousIntegrationMutationVariables
  >,
  'mutation'
>;

export const ConnectStoryousIntegrationComponent = (
  props: ConnectStoryousIntegrationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    ConnectStoryousIntegrationMutation,
    ConnectStoryousIntegrationMutationVariables
  >
    mutation={ConnectStoryousIntegrationDocument}
    {...props}
  />
);

/**
 * __useConnectStoryousIntegrationMutation__
 *
 * To run a mutation, you first call `useConnectStoryousIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectStoryousIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectStoryousIntegrationMutation, { data, loading, error }] = useConnectStoryousIntegrationMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      merchantId: // value for 'merchantId'
 *      placeId: // value for 'placeId'
 *      startDate: // value for 'startDate'
 *      skipIcoValidation: // value for 'skipIcoValidation'
 *   },
 * });
 */
export function useConnectStoryousIntegrationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConnectStoryousIntegrationMutation,
    ConnectStoryousIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ConnectStoryousIntegrationMutation,
    ConnectStoryousIntegrationMutationVariables
  >(ConnectStoryousIntegrationDocument, options);
}
export type ConnectStoryousIntegrationMutationHookResult = ReturnType<
  typeof useConnectStoryousIntegrationMutation
>;
export type ConnectStoryousIntegrationMutationResult =
  Apollo.MutationResult<ConnectStoryousIntegrationMutation>;
export type ConnectStoryousIntegrationMutationOptions =
  Apollo.BaseMutationOptions<
    ConnectStoryousIntegrationMutation,
    ConnectStoryousIntegrationMutationVariables
  >;
export const MarkStoryousIntegrationRequestCompletedDocument = gql`
  mutation MarkStoryousIntegrationRequestCompleted($id: ID!) {
    markStoryousIntegrationRequestCompleted(id: $id) {
      id
      status
      completedAt
    }
  }
`;
export type MarkStoryousIntegrationRequestCompletedMutationFn =
  Apollo.MutationFunction<
    MarkStoryousIntegrationRequestCompletedMutation,
    MarkStoryousIntegrationRequestCompletedMutationVariables
  >;
export type MarkStoryousIntegrationRequestCompletedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MarkStoryousIntegrationRequestCompletedMutation,
    MarkStoryousIntegrationRequestCompletedMutationVariables
  >,
  'mutation'
>;

export const MarkStoryousIntegrationRequestCompletedComponent = (
  props: MarkStoryousIntegrationRequestCompletedComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    MarkStoryousIntegrationRequestCompletedMutation,
    MarkStoryousIntegrationRequestCompletedMutationVariables
  >
    mutation={MarkStoryousIntegrationRequestCompletedDocument}
    {...props}
  />
);

/**
 * __useMarkStoryousIntegrationRequestCompletedMutation__
 *
 * To run a mutation, you first call `useMarkStoryousIntegrationRequestCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStoryousIntegrationRequestCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStoryousIntegrationRequestCompletedMutation, { data, loading, error }] = useMarkStoryousIntegrationRequestCompletedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkStoryousIntegrationRequestCompletedMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkStoryousIntegrationRequestCompletedMutation,
    MarkStoryousIntegrationRequestCompletedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    MarkStoryousIntegrationRequestCompletedMutation,
    MarkStoryousIntegrationRequestCompletedMutationVariables
  >(MarkStoryousIntegrationRequestCompletedDocument, options);
}
export type MarkStoryousIntegrationRequestCompletedMutationHookResult =
  ReturnType<typeof useMarkStoryousIntegrationRequestCompletedMutation>;
export type MarkStoryousIntegrationRequestCompletedMutationResult =
  Apollo.MutationResult<MarkStoryousIntegrationRequestCompletedMutation>;
export type MarkStoryousIntegrationRequestCompletedMutationOptions =
  Apollo.BaseMutationOptions<
    MarkStoryousIntegrationRequestCompletedMutation,
    MarkStoryousIntegrationRequestCompletedMutationVariables
  >;
export const RejectStoryousIntegrationRequestDocument = gql`
  mutation RejectStoryousIntegrationRequest($id: ID!, $notes: String) {
    rejectStoryousIntegrationRequest(id: $id, notes: $notes) {
      id
      status
      completedAt
      notes
    }
  }
`;
export type RejectStoryousIntegrationRequestMutationFn =
  Apollo.MutationFunction<
    RejectStoryousIntegrationRequestMutation,
    RejectStoryousIntegrationRequestMutationVariables
  >;
export type RejectStoryousIntegrationRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RejectStoryousIntegrationRequestMutation,
    RejectStoryousIntegrationRequestMutationVariables
  >,
  'mutation'
>;

export const RejectStoryousIntegrationRequestComponent = (
  props: RejectStoryousIntegrationRequestComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    RejectStoryousIntegrationRequestMutation,
    RejectStoryousIntegrationRequestMutationVariables
  >
    mutation={RejectStoryousIntegrationRequestDocument}
    {...props}
  />
);

/**
 * __useRejectStoryousIntegrationRequestMutation__
 *
 * To run a mutation, you first call `useRejectStoryousIntegrationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectStoryousIntegrationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectStoryousIntegrationRequestMutation, { data, loading, error }] = useRejectStoryousIntegrationRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useRejectStoryousIntegrationRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectStoryousIntegrationRequestMutation,
    RejectStoryousIntegrationRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    RejectStoryousIntegrationRequestMutation,
    RejectStoryousIntegrationRequestMutationVariables
  >(RejectStoryousIntegrationRequestDocument, options);
}
export type RejectStoryousIntegrationRequestMutationHookResult = ReturnType<
  typeof useRejectStoryousIntegrationRequestMutation
>;
export type RejectStoryousIntegrationRequestMutationResult =
  Apollo.MutationResult<RejectStoryousIntegrationRequestMutation>;
export type RejectStoryousIntegrationRequestMutationOptions =
  Apollo.BaseMutationOptions<
    RejectStoryousIntegrationRequestMutation,
    RejectStoryousIntegrationRequestMutationVariables
  >;
export const AvailableStoryousInstancesDocument = gql`
  query AvailableStoryousInstances {
    availableStoryousInstances {
      merchantId
      merchantName
      placeId
      placeName
      placeState
      businessId
      city
      country
      isAlreadyConnected
      connectedVenueName
      connectedVenueId
    }
  }
`;
export type AvailableStoryousInstancesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AvailableStoryousInstancesQuery,
    AvailableStoryousInstancesQueryVariables
  >,
  'query'
>;

export const AvailableStoryousInstancesComponent = (
  props: AvailableStoryousInstancesComponentProps,
) => (
  <ApolloReactComponents.Query<
    AvailableStoryousInstancesQuery,
    AvailableStoryousInstancesQueryVariables
  >
    query={AvailableStoryousInstancesDocument}
    {...props}
  />
);

/**
 * __useAvailableStoryousInstancesQuery__
 *
 * To run a query within a React component, call `useAvailableStoryousInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableStoryousInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableStoryousInstancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableStoryousInstancesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AvailableStoryousInstancesQuery,
    AvailableStoryousInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AvailableStoryousInstancesQuery,
    AvailableStoryousInstancesQueryVariables
  >(AvailableStoryousInstancesDocument, options);
}
export function useAvailableStoryousInstancesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AvailableStoryousInstancesQuery,
    AvailableStoryousInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AvailableStoryousInstancesQuery,
    AvailableStoryousInstancesQueryVariables
  >(AvailableStoryousInstancesDocument, options);
}
export type AvailableStoryousInstancesQueryHookResult = ReturnType<
  typeof useAvailableStoryousInstancesQuery
>;
export type AvailableStoryousInstancesLazyQueryHookResult = ReturnType<
  typeof useAvailableStoryousInstancesLazyQuery
>;
export type AvailableStoryousInstancesQueryResult = Apollo.QueryResult<
  AvailableStoryousInstancesQuery,
  AvailableStoryousInstancesQueryVariables
>;
export function refetchAvailableStoryousInstancesQuery(
  variables?: AvailableStoryousInstancesQueryVariables,
) {
  return { query: AvailableStoryousInstancesDocument, variables: variables };
}
export const StoryousMatchSuggestionsDocument = gql`
  query StoryousMatchSuggestions(
    $venueId: ID!
    $searchTerm: String
    $firstName: String
    $lastName: String
    $venueName: String
  ) {
    storyousMatchSuggestions(
      venueId: $venueId
      searchTerm: $searchTerm
      firstName: $firstName
      lastName: $lastName
      venueName: $venueName
    ) {
      merchantPlace {
        merchantId
        merchantName
        placeId
        placeName
        placeState
        businessId
        city
        country
        isAlreadyConnected
        connectedVenueName
        connectedVenueId
      }
      matchScore
      matchedOn
      icoMatch
    }
  }
`;
export type StoryousMatchSuggestionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StoryousMatchSuggestionsQuery,
    StoryousMatchSuggestionsQueryVariables
  >,
  'query'
> &
  (
    | { variables: StoryousMatchSuggestionsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const StoryousMatchSuggestionsComponent = (
  props: StoryousMatchSuggestionsComponentProps,
) => (
  <ApolloReactComponents.Query<
    StoryousMatchSuggestionsQuery,
    StoryousMatchSuggestionsQueryVariables
  >
    query={StoryousMatchSuggestionsDocument}
    {...props}
  />
);

/**
 * __useStoryousMatchSuggestionsQuery__
 *
 * To run a query within a React component, call `useStoryousMatchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryousMatchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryousMatchSuggestionsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      searchTerm: // value for 'searchTerm'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      venueName: // value for 'venueName'
 *   },
 * });
 */
export function useStoryousMatchSuggestionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    StoryousMatchSuggestionsQuery,
    StoryousMatchSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    StoryousMatchSuggestionsQuery,
    StoryousMatchSuggestionsQueryVariables
  >(StoryousMatchSuggestionsDocument, options);
}
export function useStoryousMatchSuggestionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StoryousMatchSuggestionsQuery,
    StoryousMatchSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    StoryousMatchSuggestionsQuery,
    StoryousMatchSuggestionsQueryVariables
  >(StoryousMatchSuggestionsDocument, options);
}
export type StoryousMatchSuggestionsQueryHookResult = ReturnType<
  typeof useStoryousMatchSuggestionsQuery
>;
export type StoryousMatchSuggestionsLazyQueryHookResult = ReturnType<
  typeof useStoryousMatchSuggestionsLazyQuery
>;
export type StoryousMatchSuggestionsQueryResult = Apollo.QueryResult<
  StoryousMatchSuggestionsQuery,
  StoryousMatchSuggestionsQueryVariables
>;
export function refetchStoryousMatchSuggestionsQuery(
  variables: StoryousMatchSuggestionsQueryVariables,
) {
  return { query: StoryousMatchSuggestionsDocument, variables: variables };
}
export const VenuesForStoryousConnectionDocument = gql`
  query VenuesForStoryousConnection {
    venuesForStoryousConnection {
      id
      name
      ico
      icoSource
      legalName
      existingStoryousConnections {
        merchantId
        placeId
        placeName
      }
    }
  }
`;
export type VenuesForStoryousConnectionComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenuesForStoryousConnectionQuery,
    VenuesForStoryousConnectionQueryVariables
  >,
  'query'
>;

export const VenuesForStoryousConnectionComponent = (
  props: VenuesForStoryousConnectionComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenuesForStoryousConnectionQuery,
    VenuesForStoryousConnectionQueryVariables
  >
    query={VenuesForStoryousConnectionDocument}
    {...props}
  />
);

/**
 * __useVenuesForStoryousConnectionQuery__
 *
 * To run a query within a React component, call `useVenuesForStoryousConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuesForStoryousConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenuesForStoryousConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useVenuesForStoryousConnectionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VenuesForStoryousConnectionQuery,
    VenuesForStoryousConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenuesForStoryousConnectionQuery,
    VenuesForStoryousConnectionQueryVariables
  >(VenuesForStoryousConnectionDocument, options);
}
export function useVenuesForStoryousConnectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenuesForStoryousConnectionQuery,
    VenuesForStoryousConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenuesForStoryousConnectionQuery,
    VenuesForStoryousConnectionQueryVariables
  >(VenuesForStoryousConnectionDocument, options);
}
export type VenuesForStoryousConnectionQueryHookResult = ReturnType<
  typeof useVenuesForStoryousConnectionQuery
>;
export type VenuesForStoryousConnectionLazyQueryHookResult = ReturnType<
  typeof useVenuesForStoryousConnectionLazyQuery
>;
export type VenuesForStoryousConnectionQueryResult = Apollo.QueryResult<
  VenuesForStoryousConnectionQuery,
  VenuesForStoryousConnectionQueryVariables
>;
export function refetchVenuesForStoryousConnectionQuery(
  variables?: VenuesForStoryousConnectionQueryVariables,
) {
  return { query: VenuesForStoryousConnectionDocument, variables: variables };
}
export const PendingStoryousIntegrationRequestsDocument = gql`
  query PendingStoryousIntegrationRequests {
    pendingStoryousIntegrationRequests {
      id
      createdAt
      venueId
      venue {
        id
        name
        legalEntity {
          legalName
          companyIdentificationNumber
        }
      }
      accountId
      account {
        email
      }
      provider
      startDate
      status
    }
  }
`;
export type PendingStoryousIntegrationRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PendingStoryousIntegrationRequestsQuery,
    PendingStoryousIntegrationRequestsQueryVariables
  >,
  'query'
>;

export const PendingStoryousIntegrationRequestsComponent = (
  props: PendingStoryousIntegrationRequestsComponentProps,
) => (
  <ApolloReactComponents.Query<
    PendingStoryousIntegrationRequestsQuery,
    PendingStoryousIntegrationRequestsQueryVariables
  >
    query={PendingStoryousIntegrationRequestsDocument}
    {...props}
  />
);

/**
 * __usePendingStoryousIntegrationRequestsQuery__
 *
 * To run a query within a React component, call `usePendingStoryousIntegrationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingStoryousIntegrationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingStoryousIntegrationRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingStoryousIntegrationRequestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PendingStoryousIntegrationRequestsQuery,
    PendingStoryousIntegrationRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    PendingStoryousIntegrationRequestsQuery,
    PendingStoryousIntegrationRequestsQueryVariables
  >(PendingStoryousIntegrationRequestsDocument, options);
}
export function usePendingStoryousIntegrationRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PendingStoryousIntegrationRequestsQuery,
    PendingStoryousIntegrationRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    PendingStoryousIntegrationRequestsQuery,
    PendingStoryousIntegrationRequestsQueryVariables
  >(PendingStoryousIntegrationRequestsDocument, options);
}
export type PendingStoryousIntegrationRequestsQueryHookResult = ReturnType<
  typeof usePendingStoryousIntegrationRequestsQuery
>;
export type PendingStoryousIntegrationRequestsLazyQueryHookResult = ReturnType<
  typeof usePendingStoryousIntegrationRequestsLazyQuery
>;
export type PendingStoryousIntegrationRequestsQueryResult = Apollo.QueryResult<
  PendingStoryousIntegrationRequestsQuery,
  PendingStoryousIntegrationRequestsQueryVariables
>;
export function refetchPendingStoryousIntegrationRequestsQuery(
  variables?: PendingStoryousIntegrationRequestsQueryVariables,
) {
  return {
    query: PendingStoryousIntegrationRequestsDocument,
    variables: variables,
  };
}
export const UpdateVenueInvoiceLimitDocument = gql`
  mutation UpdateVenueInvoiceLimit(
    $venueId: String!
    $invoiceLimit: Int
    $costRadarLimit: Int
    $planType: SubscriptionPlanType
    $fromNextCycle: Boolean
    $oneTime: Boolean
    $force: Boolean
  ) {
    updateVenueInvoiceLimit(
      venueId: $venueId
      invoiceLimit: $invoiceLimit
      costRadarLimit: $costRadarLimit
      planType: $planType
      fromNextCycle: $fromNextCycle
      oneTime: $oneTime
      force: $force
    ) {
      id
      start
      end
      subscriptionPlanType
      pricingModelVersion
      invoiceRecognitionsPerMonth
      orderItemsPerMonth
      subscriptionPeriod
    }
  }
`;
export type UpdateVenueInvoiceLimitMutationFn = Apollo.MutationFunction<
  UpdateVenueInvoiceLimitMutation,
  UpdateVenueInvoiceLimitMutationVariables
>;
export type UpdateVenueInvoiceLimitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateVenueInvoiceLimitMutation,
    UpdateVenueInvoiceLimitMutationVariables
  >,
  'mutation'
>;

export const UpdateVenueInvoiceLimitComponent = (
  props: UpdateVenueInvoiceLimitComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateVenueInvoiceLimitMutation,
    UpdateVenueInvoiceLimitMutationVariables
  >
    mutation={UpdateVenueInvoiceLimitDocument}
    {...props}
  />
);

/**
 * __useUpdateVenueInvoiceLimitMutation__
 *
 * To run a mutation, you first call `useUpdateVenueInvoiceLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVenueInvoiceLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVenueInvoiceLimitMutation, { data, loading, error }] = useUpdateVenueInvoiceLimitMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      invoiceLimit: // value for 'invoiceLimit'
 *      costRadarLimit: // value for 'costRadarLimit'
 *      planType: // value for 'planType'
 *      fromNextCycle: // value for 'fromNextCycle'
 *      oneTime: // value for 'oneTime'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdateVenueInvoiceLimitMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVenueInvoiceLimitMutation,
    UpdateVenueInvoiceLimitMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVenueInvoiceLimitMutation,
    UpdateVenueInvoiceLimitMutationVariables
  >(UpdateVenueInvoiceLimitDocument, options);
}
export type UpdateVenueInvoiceLimitMutationHookResult = ReturnType<
  typeof useUpdateVenueInvoiceLimitMutation
>;
export type UpdateVenueInvoiceLimitMutationResult =
  Apollo.MutationResult<UpdateVenueInvoiceLimitMutation>;
export type UpdateVenueInvoiceLimitMutationOptions = Apollo.BaseMutationOptions<
  UpdateVenueInvoiceLimitMutation,
  UpdateVenueInvoiceLimitMutationVariables
>;
export const EnableVenueAutoCategorizationDocument = gql`
  mutation EnableVenueAutoCategorization($venueId: String!) {
    enableVenueAutoCategorization(venueId: $venueId) {
      id
      useAutoCategorization
    }
  }
`;
export type EnableVenueAutoCategorizationMutationFn = Apollo.MutationFunction<
  EnableVenueAutoCategorizationMutation,
  EnableVenueAutoCategorizationMutationVariables
>;
export type EnableVenueAutoCategorizationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    EnableVenueAutoCategorizationMutation,
    EnableVenueAutoCategorizationMutationVariables
  >,
  'mutation'
>;

export const EnableVenueAutoCategorizationComponent = (
  props: EnableVenueAutoCategorizationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    EnableVenueAutoCategorizationMutation,
    EnableVenueAutoCategorizationMutationVariables
  >
    mutation={EnableVenueAutoCategorizationDocument}
    {...props}
  />
);

/**
 * __useEnableVenueAutoCategorizationMutation__
 *
 * To run a mutation, you first call `useEnableVenueAutoCategorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableVenueAutoCategorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableVenueAutoCategorizationMutation, { data, loading, error }] = useEnableVenueAutoCategorizationMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useEnableVenueAutoCategorizationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EnableVenueAutoCategorizationMutation,
    EnableVenueAutoCategorizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    EnableVenueAutoCategorizationMutation,
    EnableVenueAutoCategorizationMutationVariables
  >(EnableVenueAutoCategorizationDocument, options);
}
export type EnableVenueAutoCategorizationMutationHookResult = ReturnType<
  typeof useEnableVenueAutoCategorizationMutation
>;
export type EnableVenueAutoCategorizationMutationResult =
  Apollo.MutationResult<EnableVenueAutoCategorizationMutation>;
export type EnableVenueAutoCategorizationMutationOptions =
  Apollo.BaseMutationOptions<
    EnableVenueAutoCategorizationMutation,
    EnableVenueAutoCategorizationMutationVariables
  >;
export const UpdateVenueRenewalDayDocument = gql`
  mutation UpdateVenueRenewalDay(
    $venueId: String!
    $renewalDay: Int!
    $fromNextCycle: Boolean
    $force: Boolean
  ) {
    updateVenueRenewalDay(
      venueId: $venueId
      renewalDay: $renewalDay
      fromNextCycle: $fromNextCycle
      force: $force
    ) {
      id
      start
      end
      subscriptionPlanType
      pricingModelVersion
      invoiceRecognitionsPerMonth
      orderItemsPerMonth
      subscriptionPeriod
    }
  }
`;
export type UpdateVenueRenewalDayMutationFn = Apollo.MutationFunction<
  UpdateVenueRenewalDayMutation,
  UpdateVenueRenewalDayMutationVariables
>;
export type UpdateVenueRenewalDayComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateVenueRenewalDayMutation,
    UpdateVenueRenewalDayMutationVariables
  >,
  'mutation'
>;

export const UpdateVenueRenewalDayComponent = (
  props: UpdateVenueRenewalDayComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateVenueRenewalDayMutation,
    UpdateVenueRenewalDayMutationVariables
  >
    mutation={UpdateVenueRenewalDayDocument}
    {...props}
  />
);

/**
 * __useUpdateVenueRenewalDayMutation__
 *
 * To run a mutation, you first call `useUpdateVenueRenewalDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVenueRenewalDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVenueRenewalDayMutation, { data, loading, error }] = useUpdateVenueRenewalDayMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      renewalDay: // value for 'renewalDay'
 *      fromNextCycle: // value for 'fromNextCycle'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdateVenueRenewalDayMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVenueRenewalDayMutation,
    UpdateVenueRenewalDayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVenueRenewalDayMutation,
    UpdateVenueRenewalDayMutationVariables
  >(UpdateVenueRenewalDayDocument, options);
}
export type UpdateVenueRenewalDayMutationHookResult = ReturnType<
  typeof useUpdateVenueRenewalDayMutation
>;
export type UpdateVenueRenewalDayMutationResult =
  Apollo.MutationResult<UpdateVenueRenewalDayMutation>;
export type UpdateVenueRenewalDayMutationOptions = Apollo.BaseMutationOptions<
  UpdateVenueRenewalDayMutation,
  UpdateVenueRenewalDayMutationVariables
>;
export const LinkVenueBillingAccountDocument = gql`
  mutation LinkVenueBillingAccount(
    $venueId: String!
    $billingMethod: BillingMethod!
    $externalLink: String!
    $userId: String
  ) {
    linkVenueBillingAccount(
      venueId: $venueId
      billingMethod: $billingMethod
      externalLink: $externalLink
      userId: $userId
    )
  }
`;
export type LinkVenueBillingAccountMutationFn = Apollo.MutationFunction<
  LinkVenueBillingAccountMutation,
  LinkVenueBillingAccountMutationVariables
>;
export type LinkVenueBillingAccountComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    LinkVenueBillingAccountMutation,
    LinkVenueBillingAccountMutationVariables
  >,
  'mutation'
>;

export const LinkVenueBillingAccountComponent = (
  props: LinkVenueBillingAccountComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    LinkVenueBillingAccountMutation,
    LinkVenueBillingAccountMutationVariables
  >
    mutation={LinkVenueBillingAccountDocument}
    {...props}
  />
);

/**
 * __useLinkVenueBillingAccountMutation__
 *
 * To run a mutation, you first call `useLinkVenueBillingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkVenueBillingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkVenueBillingAccountMutation, { data, loading, error }] = useLinkVenueBillingAccountMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      billingMethod: // value for 'billingMethod'
 *      externalLink: // value for 'externalLink'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLinkVenueBillingAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LinkVenueBillingAccountMutation,
    LinkVenueBillingAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    LinkVenueBillingAccountMutation,
    LinkVenueBillingAccountMutationVariables
  >(LinkVenueBillingAccountDocument, options);
}
export type LinkVenueBillingAccountMutationHookResult = ReturnType<
  typeof useLinkVenueBillingAccountMutation
>;
export type LinkVenueBillingAccountMutationResult =
  Apollo.MutationResult<LinkVenueBillingAccountMutation>;
export type LinkVenueBillingAccountMutationOptions = Apollo.BaseMutationOptions<
  LinkVenueBillingAccountMutation,
  LinkVenueBillingAccountMutationVariables
>;
export const SubscriptionLimitDataDocument = gql`
  query SubscriptionLimitData($venueId: String!) {
    subscriptionData(venueId: $venueId) {
      id
      start
      end
      subscriptionPlanType
      subscriptionPeriod
      pricingModelVersion
      invoiceRecognitionsPerMonth
      orderItemsPerMonth
    }
  }
`;
export type SubscriptionLimitDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SubscriptionLimitDataQuery,
    SubscriptionLimitDataQueryVariables
  >,
  'query'
> &
  (
    | { variables: SubscriptionLimitDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SubscriptionLimitDataComponent = (
  props: SubscriptionLimitDataComponentProps,
) => (
  <ApolloReactComponents.Query<
    SubscriptionLimitDataQuery,
    SubscriptionLimitDataQueryVariables
  >
    query={SubscriptionLimitDataDocument}
    {...props}
  />
);

/**
 * __useSubscriptionLimitData__
 *
 * To run a query within a React component, call `useSubscriptionLimitData` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionLimitData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionLimitData({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useSubscriptionLimitData(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SubscriptionLimitDataQuery,
    SubscriptionLimitDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SubscriptionLimitDataQuery,
    SubscriptionLimitDataQueryVariables
  >(SubscriptionLimitDataDocument, options);
}
export function useSubscriptionLimitDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionLimitDataQuery,
    SubscriptionLimitDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SubscriptionLimitDataQuery,
    SubscriptionLimitDataQueryVariables
  >(SubscriptionLimitDataDocument, options);
}
export type SubscriptionLimitDataHookResult = ReturnType<
  typeof useSubscriptionLimitData
>;
export type SubscriptionLimitDataLazyQueryHookResult = ReturnType<
  typeof useSubscriptionLimitDataLazyQuery
>;
export type SubscriptionLimitDataQueryResult = Apollo.QueryResult<
  SubscriptionLimitDataQuery,
  SubscriptionLimitDataQueryVariables
>;
export function refetchSubscriptionLimitData(
  variables: SubscriptionLimitDataQueryVariables,
) {
  return { query: SubscriptionLimitDataDocument, variables: variables };
}
export const VenuesForSubscriptionLimitDocument = gql`
  query VenuesForSubscriptionLimit {
    venues {
      id
      name
      isTest
      useAutoCategorization
    }
  }
`;
export type VenuesForSubscriptionLimitComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenuesForSubscriptionLimitQuery,
    VenuesForSubscriptionLimitQueryVariables
  >,
  'query'
>;

export const VenuesForSubscriptionLimitComponent = (
  props: VenuesForSubscriptionLimitComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenuesForSubscriptionLimitQuery,
    VenuesForSubscriptionLimitQueryVariables
  >
    query={VenuesForSubscriptionLimitDocument}
    {...props}
  />
);

/**
 * __useVenuesForSubscriptionLimit__
 *
 * To run a query within a React component, call `useVenuesForSubscriptionLimit` and pass it any options that fit your needs.
 * When your component renders, `useVenuesForSubscriptionLimit` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenuesForSubscriptionLimit({
 *   variables: {
 *   },
 * });
 */
export function useVenuesForSubscriptionLimit(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VenuesForSubscriptionLimitQuery,
    VenuesForSubscriptionLimitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenuesForSubscriptionLimitQuery,
    VenuesForSubscriptionLimitQueryVariables
  >(VenuesForSubscriptionLimitDocument, options);
}
export function useVenuesForSubscriptionLimitLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenuesForSubscriptionLimitQuery,
    VenuesForSubscriptionLimitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenuesForSubscriptionLimitQuery,
    VenuesForSubscriptionLimitQueryVariables
  >(VenuesForSubscriptionLimitDocument, options);
}
export type VenuesForSubscriptionLimitHookResult = ReturnType<
  typeof useVenuesForSubscriptionLimit
>;
export type VenuesForSubscriptionLimitLazyQueryHookResult = ReturnType<
  typeof useVenuesForSubscriptionLimitLazyQuery
>;
export type VenuesForSubscriptionLimitQueryResult = Apollo.QueryResult<
  VenuesForSubscriptionLimitQuery,
  VenuesForSubscriptionLimitQueryVariables
>;
export function refetchVenuesForSubscriptionLimit(
  variables?: VenuesForSubscriptionLimitQueryVariables,
) {
  return { query: VenuesForSubscriptionLimitDocument, variables: variables };
}
export const PricingDataDocument = gql`
  query PricingData {
    getPricingData {
      subscriptionTiers {
        type
        value
      }
    }
  }
`;
export type PricingDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PricingDataQuery,
    PricingDataQueryVariables
  >,
  'query'
>;

export const PricingDataComponent = (props: PricingDataComponentProps) => (
  <ApolloReactComponents.Query<PricingDataQuery, PricingDataQueryVariables>
    query={PricingDataDocument}
    {...props}
  />
);

/**
 * __usePricingDataQuery__
 *
 * To run a query within a React component, call `usePricingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePricingDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PricingDataQuery,
    PricingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<PricingDataQuery, PricingDataQueryVariables>(
    PricingDataDocument,
    options,
  );
}
export function usePricingDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PricingDataQuery,
    PricingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    PricingDataQuery,
    PricingDataQueryVariables
  >(PricingDataDocument, options);
}
export type PricingDataQueryHookResult = ReturnType<typeof usePricingDataQuery>;
export type PricingDataLazyQueryHookResult = ReturnType<
  typeof usePricingDataLazyQuery
>;
export type PricingDataQueryResult = Apollo.QueryResult<
  PricingDataQuery,
  PricingDataQueryVariables
>;
export function refetchPricingDataQuery(variables?: PricingDataQueryVariables) {
  return { query: PricingDataDocument, variables: variables };
}
export const FutureSubscriptionsDocument = gql`
  query FutureSubscriptions($venueId: String!) {
    futureSubscriptions(venueId: $venueId) {
      id
      start
      end
      subscriptionPlanType
      pricingModelVersion
      invoiceRecognitionsPerMonth
      orderItemsPerMonth
    }
  }
`;
export type FutureSubscriptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    FutureSubscriptionsQuery,
    FutureSubscriptionsQueryVariables
  >,
  'query'
> &
  (
    | { variables: FutureSubscriptionsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const FutureSubscriptionsComponent = (
  props: FutureSubscriptionsComponentProps,
) => (
  <ApolloReactComponents.Query<
    FutureSubscriptionsQuery,
    FutureSubscriptionsQueryVariables
  >
    query={FutureSubscriptionsDocument}
    {...props}
  />
);

/**
 * __useFutureSubscriptions__
 *
 * To run a query within a React component, call `useFutureSubscriptions` and pass it any options that fit your needs.
 * When your component renders, `useFutureSubscriptions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFutureSubscriptions({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useFutureSubscriptions(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FutureSubscriptionsQuery,
    FutureSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    FutureSubscriptionsQuery,
    FutureSubscriptionsQueryVariables
  >(FutureSubscriptionsDocument, options);
}
export function useFutureSubscriptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FutureSubscriptionsQuery,
    FutureSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    FutureSubscriptionsQuery,
    FutureSubscriptionsQueryVariables
  >(FutureSubscriptionsDocument, options);
}
export type FutureSubscriptionsHookResult = ReturnType<
  typeof useFutureSubscriptions
>;
export type FutureSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useFutureSubscriptionsLazyQuery
>;
export type FutureSubscriptionsQueryResult = Apollo.QueryResult<
  FutureSubscriptionsQuery,
  FutureSubscriptionsQueryVariables
>;
export function refetchFutureSubscriptions(
  variables: FutureSubscriptionsQueryVariables,
) {
  return { query: FutureSubscriptionsDocument, variables: variables };
}
export const VenueUsersForBillingLinkDocument = gql`
  query VenueUsersForBillingLink($venueId: String!) {
    venueUsersForBillingLink(venueId: $venueId) {
      id
      roleName
      account {
        id
        email
        firstName
        lastName
      }
    }
  }
`;
export type VenueUsersForBillingLinkComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenueUsersForBillingLinkQuery,
    VenueUsersForBillingLinkQueryVariables
  >,
  'query'
> &
  (
    | { variables: VenueUsersForBillingLinkQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const VenueUsersForBillingLinkComponent = (
  props: VenueUsersForBillingLinkComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenueUsersForBillingLinkQuery,
    VenueUsersForBillingLinkQueryVariables
  >
    query={VenueUsersForBillingLinkDocument}
    {...props}
  />
);

/**
 * __useVenueUsersForBillingLinkQuery__
 *
 * To run a query within a React component, call `useVenueUsersForBillingLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueUsersForBillingLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueUsersForBillingLinkQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueUsersForBillingLinkQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    VenueUsersForBillingLinkQuery,
    VenueUsersForBillingLinkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenueUsersForBillingLinkQuery,
    VenueUsersForBillingLinkQueryVariables
  >(VenueUsersForBillingLinkDocument, options);
}
export function useVenueUsersForBillingLinkLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenueUsersForBillingLinkQuery,
    VenueUsersForBillingLinkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenueUsersForBillingLinkQuery,
    VenueUsersForBillingLinkQueryVariables
  >(VenueUsersForBillingLinkDocument, options);
}
export type VenueUsersForBillingLinkQueryHookResult = ReturnType<
  typeof useVenueUsersForBillingLinkQuery
>;
export type VenueUsersForBillingLinkLazyQueryHookResult = ReturnType<
  typeof useVenueUsersForBillingLinkLazyQuery
>;
export type VenueUsersForBillingLinkQueryResult = Apollo.QueryResult<
  VenueUsersForBillingLinkQuery,
  VenueUsersForBillingLinkQueryVariables
>;
export function refetchVenueUsersForBillingLinkQuery(
  variables: VenueUsersForBillingLinkQueryVariables,
) {
  return { query: VenueUsersForBillingLinkDocument, variables: variables };
}
export const CreateGlobalSupplierDocument = gql`
  mutation CreateGlobalSupplier(
    $name: String!
    $contactEmail: String!
    $emailDomain: String
    $invoicingEmail: String
  ) {
    createGlobalSupplier(
      name: $name
      contactEmail: $contactEmail
      emailDomain: $emailDomain
      invoicingEmail: $invoicingEmail
    ) {
      id
      name
      emailDomain
      invoicingEmail
      exceptionFlag
      exceptionReason
      contactEmails {
        id
        email
      }
    }
  }
`;
export type CreateGlobalSupplierMutationFn = Apollo.MutationFunction<
  CreateGlobalSupplierMutation,
  CreateGlobalSupplierMutationVariables
>;
export type CreateGlobalSupplierComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateGlobalSupplierMutation,
    CreateGlobalSupplierMutationVariables
  >,
  'mutation'
>;

export const CreateGlobalSupplierComponent = (
  props: CreateGlobalSupplierComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateGlobalSupplierMutation,
    CreateGlobalSupplierMutationVariables
  >
    mutation={CreateGlobalSupplierDocument}
    {...props}
  />
);

/**
 * __useCreateGlobalSupplierMutation__
 *
 * To run a mutation, you first call `useCreateGlobalSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalSupplierMutation, { data, loading, error }] = useCreateGlobalSupplierMutation({
 *   variables: {
 *      name: // value for 'name'
 *      contactEmail: // value for 'contactEmail'
 *      emailDomain: // value for 'emailDomain'
 *      invoicingEmail: // value for 'invoicingEmail'
 *   },
 * });
 */
export function useCreateGlobalSupplierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateGlobalSupplierMutation,
    CreateGlobalSupplierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateGlobalSupplierMutation,
    CreateGlobalSupplierMutationVariables
  >(CreateGlobalSupplierDocument, options);
}
export type CreateGlobalSupplierMutationHookResult = ReturnType<
  typeof useCreateGlobalSupplierMutation
>;
export type CreateGlobalSupplierMutationResult =
  Apollo.MutationResult<CreateGlobalSupplierMutation>;
export type CreateGlobalSupplierMutationOptions = Apollo.BaseMutationOptions<
  CreateGlobalSupplierMutation,
  CreateGlobalSupplierMutationVariables
>;
export const UpdateGlobalSupplierDocument = gql`
  mutation UpdateGlobalSupplier(
    $id: ID!
    $name: String
    $emailDomain: String
    $invoicingEmail: String
    $exceptionFlag: Boolean
    $exceptionReason: String
  ) {
    updateGlobalSupplier(
      id: $id
      name: $name
      emailDomain: $emailDomain
      invoicingEmail: $invoicingEmail
      exceptionFlag: $exceptionFlag
      exceptionReason: $exceptionReason
    ) {
      id
      name
      emailDomain
      invoicingEmail
      exceptionFlag
      exceptionReason
      contactEmails {
        id
        email
      }
    }
  }
`;
export type UpdateGlobalSupplierMutationFn = Apollo.MutationFunction<
  UpdateGlobalSupplierMutation,
  UpdateGlobalSupplierMutationVariables
>;
export type UpdateGlobalSupplierComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateGlobalSupplierMutation,
    UpdateGlobalSupplierMutationVariables
  >,
  'mutation'
>;

export const UpdateGlobalSupplierComponent = (
  props: UpdateGlobalSupplierComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateGlobalSupplierMutation,
    UpdateGlobalSupplierMutationVariables
  >
    mutation={UpdateGlobalSupplierDocument}
    {...props}
  />
);

/**
 * __useUpdateGlobalSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalSupplierMutation, { data, loading, error }] = useUpdateGlobalSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      emailDomain: // value for 'emailDomain'
 *      invoicingEmail: // value for 'invoicingEmail'
 *      exceptionFlag: // value for 'exceptionFlag'
 *      exceptionReason: // value for 'exceptionReason'
 *   },
 * });
 */
export function useUpdateGlobalSupplierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateGlobalSupplierMutation,
    UpdateGlobalSupplierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateGlobalSupplierMutation,
    UpdateGlobalSupplierMutationVariables
  >(UpdateGlobalSupplierDocument, options);
}
export type UpdateGlobalSupplierMutationHookResult = ReturnType<
  typeof useUpdateGlobalSupplierMutation
>;
export type UpdateGlobalSupplierMutationResult =
  Apollo.MutationResult<UpdateGlobalSupplierMutation>;
export type UpdateGlobalSupplierMutationOptions = Apollo.BaseMutationOptions<
  UpdateGlobalSupplierMutation,
  UpdateGlobalSupplierMutationVariables
>;
export const AddGlobalSupplierContactEmailDocument = gql`
  mutation AddGlobalSupplierContactEmail($supplierId: ID!, $email: String!) {
    addGlobalSupplierContactEmail(supplierId: $supplierId, email: $email) {
      id
      name
      contactEmails {
        id
        email
      }
    }
  }
`;
export type AddGlobalSupplierContactEmailMutationFn = Apollo.MutationFunction<
  AddGlobalSupplierContactEmailMutation,
  AddGlobalSupplierContactEmailMutationVariables
>;
export type AddGlobalSupplierContactEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddGlobalSupplierContactEmailMutation,
    AddGlobalSupplierContactEmailMutationVariables
  >,
  'mutation'
>;

export const AddGlobalSupplierContactEmailComponent = (
  props: AddGlobalSupplierContactEmailComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AddGlobalSupplierContactEmailMutation,
    AddGlobalSupplierContactEmailMutationVariables
  >
    mutation={AddGlobalSupplierContactEmailDocument}
    {...props}
  />
);

/**
 * __useAddGlobalSupplierContactEmailMutation__
 *
 * To run a mutation, you first call `useAddGlobalSupplierContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGlobalSupplierContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGlobalSupplierContactEmailMutation, { data, loading, error }] = useAddGlobalSupplierContactEmailMutation({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddGlobalSupplierContactEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddGlobalSupplierContactEmailMutation,
    AddGlobalSupplierContactEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AddGlobalSupplierContactEmailMutation,
    AddGlobalSupplierContactEmailMutationVariables
  >(AddGlobalSupplierContactEmailDocument, options);
}
export type AddGlobalSupplierContactEmailMutationHookResult = ReturnType<
  typeof useAddGlobalSupplierContactEmailMutation
>;
export type AddGlobalSupplierContactEmailMutationResult =
  Apollo.MutationResult<AddGlobalSupplierContactEmailMutation>;
export type AddGlobalSupplierContactEmailMutationOptions =
  Apollo.BaseMutationOptions<
    AddGlobalSupplierContactEmailMutation,
    AddGlobalSupplierContactEmailMutationVariables
  >;
export const InitiateSupplierIntegrationsDocument = gql`
  mutation InitiateSupplierIntegrations(
    $venueId: ID!
    $selections: [SupplierIntegrationSelectionInput!]!
  ) {
    initiateSupplierIntegrations(venueId: $venueId, selections: $selections) {
      id
      venueId
      globalSupplierId
      contactEmail
      initiatedByEmail
      status
      isActive
      lastContactDate
      followUpsManuallyDisabledAt
      supplierReplyDetectedAt
      nextEmailInDays
      automatedFollowUpsStopTooltip
      globalSupplier {
        id
        name
      }
    }
  }
`;
export type InitiateSupplierIntegrationsMutationFn = Apollo.MutationFunction<
  InitiateSupplierIntegrationsMutation,
  InitiateSupplierIntegrationsMutationVariables
>;
export type InitiateSupplierIntegrationsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    InitiateSupplierIntegrationsMutation,
    InitiateSupplierIntegrationsMutationVariables
  >,
  'mutation'
>;

export const InitiateSupplierIntegrationsComponent = (
  props: InitiateSupplierIntegrationsComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    InitiateSupplierIntegrationsMutation,
    InitiateSupplierIntegrationsMutationVariables
  >
    mutation={InitiateSupplierIntegrationsDocument}
    {...props}
  />
);

/**
 * __useInitiateSupplierIntegrationsMutation__
 *
 * To run a mutation, you first call `useInitiateSupplierIntegrationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateSupplierIntegrationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateSupplierIntegrationsMutation, { data, loading, error }] = useInitiateSupplierIntegrationsMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      selections: // value for 'selections'
 *   },
 * });
 */
export function useInitiateSupplierIntegrationsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    InitiateSupplierIntegrationsMutation,
    InitiateSupplierIntegrationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    InitiateSupplierIntegrationsMutation,
    InitiateSupplierIntegrationsMutationVariables
  >(InitiateSupplierIntegrationsDocument, options);
}
export type InitiateSupplierIntegrationsMutationHookResult = ReturnType<
  typeof useInitiateSupplierIntegrationsMutation
>;
export type InitiateSupplierIntegrationsMutationResult =
  Apollo.MutationResult<InitiateSupplierIntegrationsMutation>;
export type InitiateSupplierIntegrationsMutationOptions =
  Apollo.BaseMutationOptions<
    InitiateSupplierIntegrationsMutation,
    InitiateSupplierIntegrationsMutationVariables
  >;
export const DisableAutomatedFollowUpsDocument = gql`
  mutation DisableAutomatedFollowUps($requestId: ID!) {
    disableAutomatedFollowUps(requestId: $requestId) {
      id
      followUpsManuallyDisabledAt
      automatedFollowUpsStopTooltip
      nextEmailInDays
    }
  }
`;
export type DisableAutomatedFollowUpsMutationFn = Apollo.MutationFunction<
  DisableAutomatedFollowUpsMutation,
  DisableAutomatedFollowUpsMutationVariables
>;
export type DisableAutomatedFollowUpsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DisableAutomatedFollowUpsMutation,
    DisableAutomatedFollowUpsMutationVariables
  >,
  'mutation'
>;

export const DisableAutomatedFollowUpsComponent = (
  props: DisableAutomatedFollowUpsComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    DisableAutomatedFollowUpsMutation,
    DisableAutomatedFollowUpsMutationVariables
  >
    mutation={DisableAutomatedFollowUpsDocument}
    {...props}
  />
);

/**
 * __useDisableAutomatedFollowUpsMutation__
 *
 * To run a mutation, you first call `useDisableAutomatedFollowUpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAutomatedFollowUpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAutomatedFollowUpsMutation, { data, loading, error }] = useDisableAutomatedFollowUpsMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useDisableAutomatedFollowUpsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisableAutomatedFollowUpsMutation,
    DisableAutomatedFollowUpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DisableAutomatedFollowUpsMutation,
    DisableAutomatedFollowUpsMutationVariables
  >(DisableAutomatedFollowUpsDocument, options);
}
export type DisableAutomatedFollowUpsMutationHookResult = ReturnType<
  typeof useDisableAutomatedFollowUpsMutation
>;
export type DisableAutomatedFollowUpsMutationResult =
  Apollo.MutationResult<DisableAutomatedFollowUpsMutation>;
export type DisableAutomatedFollowUpsMutationOptions =
  Apollo.BaseMutationOptions<
    DisableAutomatedFollowUpsMutation,
    DisableAutomatedFollowUpsMutationVariables
  >;
export const GlobalSuppliersDocument = gql`
  query GlobalSuppliers($search: String) {
    globalSuppliers(search: $search) {
      id
      name
      emailDomain
      invoicingEmail
      exceptionFlag
      exceptionReason
      contactEmails {
        id
        email
        globalSupplierId
      }
    }
  }
`;
export type GlobalSuppliersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GlobalSuppliersQuery,
    GlobalSuppliersQueryVariables
  >,
  'query'
>;

export const GlobalSuppliersComponent = (
  props: GlobalSuppliersComponentProps,
) => (
  <ApolloReactComponents.Query<
    GlobalSuppliersQuery,
    GlobalSuppliersQueryVariables
  >
    query={GlobalSuppliersDocument}
    {...props}
  />
);

/**
 * __useGlobalSuppliersQuery__
 *
 * To run a query within a React component, call `useGlobalSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSuppliersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGlobalSuppliersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GlobalSuppliersQuery,
    GlobalSuppliersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GlobalSuppliersQuery,
    GlobalSuppliersQueryVariables
  >(GlobalSuppliersDocument, options);
}
export function useGlobalSuppliersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GlobalSuppliersQuery,
    GlobalSuppliersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GlobalSuppliersQuery,
    GlobalSuppliersQueryVariables
  >(GlobalSuppliersDocument, options);
}
export type GlobalSuppliersQueryHookResult = ReturnType<
  typeof useGlobalSuppliersQuery
>;
export type GlobalSuppliersLazyQueryHookResult = ReturnType<
  typeof useGlobalSuppliersLazyQuery
>;
export type GlobalSuppliersQueryResult = Apollo.QueryResult<
  GlobalSuppliersQuery,
  GlobalSuppliersQueryVariables
>;
export function refetchGlobalSuppliersQuery(
  variables?: GlobalSuppliersQueryVariables,
) {
  return { query: GlobalSuppliersDocument, variables: variables };
}
export const SupplierIntegrationRequestsDocument = gql`
  query SupplierIntegrationRequests($venueId: ID!) {
    supplierIntegrationRequests(venueId: $venueId) {
      id
      venueId
      globalSupplierId
      contactEmail
      initiatedByEmail
      status
      isActive
      lastContactDate
      createdAt
      followUpsManuallyDisabledAt
      supplierReplyDetectedAt
      nextEmailInDays
      automatedFollowUpsStopTooltip
      globalSupplier {
        id
        name
        emailDomain
        invoicingEmail
        exceptionFlag
        exceptionReason
        contactEmails {
          id
          email
        }
      }
    }
  }
`;
export type SupplierIntegrationRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SupplierIntegrationRequestsQuery,
    SupplierIntegrationRequestsQueryVariables
  >,
  'query'
> &
  (
    | { variables: SupplierIntegrationRequestsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SupplierIntegrationRequestsComponent = (
  props: SupplierIntegrationRequestsComponentProps,
) => (
  <ApolloReactComponents.Query<
    SupplierIntegrationRequestsQuery,
    SupplierIntegrationRequestsQueryVariables
  >
    query={SupplierIntegrationRequestsDocument}
    {...props}
  />
);

/**
 * __useSupplierIntegrationRequestsQuery__
 *
 * To run a query within a React component, call `useSupplierIntegrationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierIntegrationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierIntegrationRequestsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useSupplierIntegrationRequestsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SupplierIntegrationRequestsQuery,
    SupplierIntegrationRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SupplierIntegrationRequestsQuery,
    SupplierIntegrationRequestsQueryVariables
  >(SupplierIntegrationRequestsDocument, options);
}
export function useSupplierIntegrationRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SupplierIntegrationRequestsQuery,
    SupplierIntegrationRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SupplierIntegrationRequestsQuery,
    SupplierIntegrationRequestsQueryVariables
  >(SupplierIntegrationRequestsDocument, options);
}
export type SupplierIntegrationRequestsQueryHookResult = ReturnType<
  typeof useSupplierIntegrationRequestsQuery
>;
export type SupplierIntegrationRequestsLazyQueryHookResult = ReturnType<
  typeof useSupplierIntegrationRequestsLazyQuery
>;
export type SupplierIntegrationRequestsQueryResult = Apollo.QueryResult<
  SupplierIntegrationRequestsQuery,
  SupplierIntegrationRequestsQueryVariables
>;
export function refetchSupplierIntegrationRequestsQuery(
  variables: SupplierIntegrationRequestsQueryVariables,
) {
  return { query: SupplierIntegrationRequestsDocument, variables: variables };
}
export const ExportSupplierIntegrationsCsvDocument = gql`
  query ExportSupplierIntegrationsCsv {
    exportSupplierIntegrationsCsv
  }
`;
export type ExportSupplierIntegrationsCsvComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ExportSupplierIntegrationsCsvQuery,
    ExportSupplierIntegrationsCsvQueryVariables
  >,
  'query'
>;

export const ExportSupplierIntegrationsCsvComponent = (
  props: ExportSupplierIntegrationsCsvComponentProps,
) => (
  <ApolloReactComponents.Query<
    ExportSupplierIntegrationsCsvQuery,
    ExportSupplierIntegrationsCsvQueryVariables
  >
    query={ExportSupplierIntegrationsCsvDocument}
    {...props}
  />
);

/**
 * __useExportSupplierIntegrationsCsvQuery__
 *
 * To run a query within a React component, call `useExportSupplierIntegrationsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSupplierIntegrationsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSupplierIntegrationsCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportSupplierIntegrationsCsvQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ExportSupplierIntegrationsCsvQuery,
    ExportSupplierIntegrationsCsvQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ExportSupplierIntegrationsCsvQuery,
    ExportSupplierIntegrationsCsvQueryVariables
  >(ExportSupplierIntegrationsCsvDocument, options);
}
export function useExportSupplierIntegrationsCsvLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ExportSupplierIntegrationsCsvQuery,
    ExportSupplierIntegrationsCsvQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ExportSupplierIntegrationsCsvQuery,
    ExportSupplierIntegrationsCsvQueryVariables
  >(ExportSupplierIntegrationsCsvDocument, options);
}
export type ExportSupplierIntegrationsCsvQueryHookResult = ReturnType<
  typeof useExportSupplierIntegrationsCsvQuery
>;
export type ExportSupplierIntegrationsCsvLazyQueryHookResult = ReturnType<
  typeof useExportSupplierIntegrationsCsvLazyQuery
>;
export type ExportSupplierIntegrationsCsvQueryResult = Apollo.QueryResult<
  ExportSupplierIntegrationsCsvQuery,
  ExportSupplierIntegrationsCsvQueryVariables
>;
export function refetchExportSupplierIntegrationsCsvQuery(
  variables?: ExportSupplierIntegrationsCsvQueryVariables,
) {
  return { query: ExportSupplierIntegrationsCsvDocument, variables: variables };
}
export const VenuesForSupplierIntegrationsDocument = gql`
  query VenuesForSupplierIntegrations {
    adminVenues {
      id
      name
      city
      invoiceEmail
    }
  }
`;
export type VenuesForSupplierIntegrationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenuesForSupplierIntegrationsQuery,
    VenuesForSupplierIntegrationsQueryVariables
  >,
  'query'
>;

export const VenuesForSupplierIntegrationsComponent = (
  props: VenuesForSupplierIntegrationsComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenuesForSupplierIntegrationsQuery,
    VenuesForSupplierIntegrationsQueryVariables
  >
    query={VenuesForSupplierIntegrationsDocument}
    {...props}
  />
);

/**
 * __useVenuesForSupplierIntegrationsQuery__
 *
 * To run a query within a React component, call `useVenuesForSupplierIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuesForSupplierIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenuesForSupplierIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVenuesForSupplierIntegrationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VenuesForSupplierIntegrationsQuery,
    VenuesForSupplierIntegrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenuesForSupplierIntegrationsQuery,
    VenuesForSupplierIntegrationsQueryVariables
  >(VenuesForSupplierIntegrationsDocument, options);
}
export function useVenuesForSupplierIntegrationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenuesForSupplierIntegrationsQuery,
    VenuesForSupplierIntegrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenuesForSupplierIntegrationsQuery,
    VenuesForSupplierIntegrationsQueryVariables
  >(VenuesForSupplierIntegrationsDocument, options);
}
export type VenuesForSupplierIntegrationsQueryHookResult = ReturnType<
  typeof useVenuesForSupplierIntegrationsQuery
>;
export type VenuesForSupplierIntegrationsLazyQueryHookResult = ReturnType<
  typeof useVenuesForSupplierIntegrationsLazyQuery
>;
export type VenuesForSupplierIntegrationsQueryResult = Apollo.QueryResult<
  VenuesForSupplierIntegrationsQuery,
  VenuesForSupplierIntegrationsQueryVariables
>;
export function refetchVenuesForSupplierIntegrationsQuery(
  variables?: VenuesForSupplierIntegrationsQueryVariables,
) {
  return { query: VenuesForSupplierIntegrationsDocument, variables: variables };
}
export const UpdateVenueAdminDocument = gql`
  mutation UpdateVenueAdmin($venueId: String!, $input: UpdateVenueAdminInput!) {
    updateVenueAdmin(venueId: $venueId, input: $input) {
      id
      name
      isTest
      stripeCouponId
      crmLink
    }
  }
`;
export type UpdateVenueAdminMutationFn = Apollo.MutationFunction<
  UpdateVenueAdminMutation,
  UpdateVenueAdminMutationVariables
>;
export type UpdateVenueAdminComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateVenueAdminMutation,
    UpdateVenueAdminMutationVariables
  >,
  'mutation'
>;

export const UpdateVenueAdminComponent = (
  props: UpdateVenueAdminComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateVenueAdminMutation,
    UpdateVenueAdminMutationVariables
  >
    mutation={UpdateVenueAdminDocument}
    {...props}
  />
);

/**
 * __useUpdateVenueAdminMutation__
 *
 * To run a mutation, you first call `useUpdateVenueAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVenueAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVenueAdminMutation, { data, loading, error }] = useUpdateVenueAdminMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVenueAdminMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVenueAdminMutation,
    UpdateVenueAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVenueAdminMutation,
    UpdateVenueAdminMutationVariables
  >(UpdateVenueAdminDocument, options);
}
export type UpdateVenueAdminMutationHookResult = ReturnType<
  typeof useUpdateVenueAdminMutation
>;
export type UpdateVenueAdminMutationResult =
  Apollo.MutationResult<UpdateVenueAdminMutation>;
export type UpdateVenueAdminMutationOptions = Apollo.BaseMutationOptions<
  UpdateVenueAdminMutation,
  UpdateVenueAdminMutationVariables
>;
export const VenueForManagementDocument = gql`
  query VenueForManagement($venueId: String!) {
    venueForManagement(venueId: $venueId) {
      id
      name
      isTest
      stripeCouponId
      crmLink
      city
      legalEntity {
        legalName
        country
      }
    }
  }
`;
export type VenueForManagementComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    VenueForManagementQuery,
    VenueForManagementQueryVariables
  >,
  'query'
> &
  (
    | { variables: VenueForManagementQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const VenueForManagementComponent = (
  props: VenueForManagementComponentProps,
) => (
  <ApolloReactComponents.Query<
    VenueForManagementQuery,
    VenueForManagementQueryVariables
  >
    query={VenueForManagementDocument}
    {...props}
  />
);

/**
 * __useVenueForManagementQuery__
 *
 * To run a query within a React component, call `useVenueForManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueForManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueForManagementQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueForManagementQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    VenueForManagementQuery,
    VenueForManagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VenueForManagementQuery,
    VenueForManagementQueryVariables
  >(VenueForManagementDocument, options);
}
export function useVenueForManagementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VenueForManagementQuery,
    VenueForManagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VenueForManagementQuery,
    VenueForManagementQueryVariables
  >(VenueForManagementDocument, options);
}
export type VenueForManagementQueryHookResult = ReturnType<
  typeof useVenueForManagementQuery
>;
export type VenueForManagementLazyQueryHookResult = ReturnType<
  typeof useVenueForManagementLazyQuery
>;
export type VenueForManagementQueryResult = Apollo.QueryResult<
  VenueForManagementQuery,
  VenueForManagementQueryVariables
>;
export function refetchVenueForManagementQuery(
  variables: VenueForManagementQueryVariables,
) {
  return { query: VenueForManagementDocument, variables: variables };
}
